/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    "/rfp": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Submit RFP
         * @description This endpoint is used to submit a request for proposal. If the group already has an in-force plan, the plan design is sent over in coverages. It also includes some other related information like employer, broker, eligibility etc. If this is a new group, it will include the requested coverages with default/benchmark plans. It can also include alternate benefit configuration for the request which would not include rates.
         */
        post: operations["createRfp"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/rfp/{carrierIssuedIdentifier}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Submit a replacement for an RFP
         * @description This endpoint is used to submit an update to a request for proposal. This is also used for re-quote request. If the group already has an existing policy, the policy information is sent over in coverages. It also includes some other related information like employer, broker, eligibility etc. If this is a new group, it will include the requested coverages with default/benchmark plans. It can also include alternate benefit configuration for the request which would not include rates.
         */
        put: operations["replaceRfp"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/rfp/{carrierIssuedIdentifier}/proposal/{proposalIdentifier}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Retrieve a proposal
         * @description This endpoint is used to retrieve a proposal for an RFP.
         */
        get: operations["getProposal"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/event/rfpq/carrier/{carrierIdentifier}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Send quote event notification
         * @description Carriers invoke this Ecosystem endpoint to notify Ecosystem that the quote is ready to be retrieved.
         */
        post: operations["rfpqEventSubmit"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/files": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Upload a file
         * @description Centro Ecosystem exposes this endpoint to allow carriers to upload files that will be referenced in Proposals. This is useful if carriers cannot support file downloads.
         */
        post: operations["uploadFile"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/files/{fileIdentifier}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Download a file
         * @description Centro Ecosystem exposes this endpoint to allow carriers to download files that are referenced in RFP submissions. Carriers must expose this endpoint to allow Ecosystem to download files that are referenced in Proposals.
         */
        get: operations["downloadFile"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        /**
         * @description These are the codes for US States and territories.
         * @enum {string}
         */
        StateTerritoryCodeEnum: StateTerritoryCodeEnum;
        /**
         * @description Acceptable country codes.
         * @default US
         * @enum {string}
         */
        CountryCodeEnum: CountryCodeEnum;
        Address: {
            /** @description First line of the address. */
            firstLine: string;
            /** @description Second line of the address. */
            secondLine?: string;
            /** @description Third line of the address. */
            thirdLine?: string;
            /** @description City for the address. */
            cityName: string;
            /** @description Code/abbreviation for the state or province for the address. */
            stateProvinceCode: components["schemas"]["StateTerritoryCodeEnum"];
            /** @description Postal code for the address. */
            postalCode: string;
            countryCode?: components["schemas"]["CountryCodeEnum"];
        };
        /**
         * @description The benefits administration platform being used.
         * @enum {string}
         */
        BenAdminNameEnum: BenAdminNameEnum;
        /** @description Benefits administration platform information. */
        BenAdmin: {
            name: components["schemas"]["BenAdminNameEnum"];
            /** @description Name of the benefits administration platform when 'other' is selected. */
            nameOther?: string;
        };
        Employer: {
            /** @description Employer's Name - This is a representation of the organizational entity's name. */
            name: string;
            /** @description Number of employees eligible to enroll overall (not plan specific). */
            numberOfEligibleEmployees: number;
            /** @description Indicates if any employees are actively working outside of the United Stated. */
            hasEmployeeOutsideUS: boolean;
            address: components["schemas"]["Address"];
            /** @description Two character abbreviation for the state the plan was sold in. */
            situsState: components["schemas"]["StateTerritoryCodeEnum"];
            benAdmin: components["schemas"]["BenAdmin"];
        };
        BenefitClass: {
            /** @description This is the identifier of the Benefit Class. */
            identifier: string;
            /** @description If there is only one class, the class  description will be  "All Eligible Employees". If there is more than one class, the description will define each specific class. */
            name: string;
        };
        /**
         * @description The type of employment that could impact rating.
         * @enum {string}
         */
        EmploymentTypeEnum: EmploymentTypeEnum;
        /**
         * @description The legal gender of the enrollee (required for all relationships).
         * @enum {string}
         */
        GenderCodeEnum: GenderCodeEnum;
        /**
         * @description The status of the employee's employment.
         * @enum {string}
         */
        EmploymentStatusEnum: EmploymentStatusEnum;
        /**
         * @description Types of coverage, aka line of coverage (LoC). We don't see standalone AD&D often. However, it is still a valid coverage type that is usually part of life plans.
         * @enum {string}
         */
        CoverageTypeEnum: CoverageTypeEnum;
        /**
         * @description Values acceptable for coverage tier.
         * @enum {string}
         */
        CoverageTierEnum: CoverageTierEnum;
        /**
         * @description This indicates the type for the coverageAmount field.
         * @enum {string}
         */
        CoverageAmountTypeEnum: CoverageAmountTypeEnum;
        MemberCoverage: {
            /** @description If the current benefits are classed out, this field will indicate which class the employee falls under for this specific coverage. This corresponds to benefitClasses[].identifier. This is only required for employees. */
            benefitClassIdentifier?: string;
            /** @description This is the coverage type for this record. */
            coverageType?: components["schemas"]["CoverageTypeEnum"];
            /** @description Indicates if member waived coverage for this coverage type. */
            isWaived?: boolean;
            /** @description Indicates the coverage tier for this coverage. */
            coverageTierCode?: components["schemas"]["CoverageTierEnum"];
            /** @description Plan Name or Type the employee has elected, if more than one Option exists. */
            benefitPlanName?: string;
            /** @description This indicates the type for the coverageAmount field. */
            coverageAmountType?: components["schemas"]["CoverageAmountTypeEnum"];
            /** @description This is the amount for member coverage. */
            coverageAmount?: number;
        };
        GroupMember: {
            /** @description An identifier to tie employees to their dependents; the identifier should be unique between employees. */
            employeeCode: string;
            /** @description Indicates if the employee is full time or part time. */
            employmentType?: components["schemas"]["EmploymentTypeEnum"];
            /** @description The legal gender of the enrollee (required for all relationships) */
            gender?: components["schemas"]["GenderCodeEnum"];
            /**
             * Format: date
             * @description Date of birth for the employee. This is used for age-based rates/benefits. Required for Employee only. ISO-8601 format.
             */
            birthDate?: string;
            /** @description The postal code where the employee resides. Required for EE only. */
            postalCode?: string;
            /** @description The status of the employee's employment. Req'd for EE only. */
            employmentStatus?: components["schemas"]["EmploymentStatusEnum"];
            /** @description The title/job type of the employee. Req'd for EE only. For example, owner, ceo etc. */
            employeeJobTitle?: string;
            /** @description The current salary of the employee. This is used for salary-based benefits. Req'd for EE only. */
            annualIncome?: number;
            /** @description This is the coverage information for the member */
            coverage?: components["schemas"]["MemberCoverage"][];
        };
        /** @description This is the census for the group. */
        GroupCensus: components["schemas"]["GroupMember"][];
        /** @description This includes the uri to retrieve the file, but does not include the content of it. In the RFP, the carrier will call the Ecosystem File API endpoint to retrieve the file contents. In the Proposal, Ecosystem will call the carrier's File API to retrieve the file contents. */
        File: {
            /** @description This is the unique identifier of the file. This field is optional as the 'uri' is what should be used to retrieve the file content. */
            identifier?: string;
            /**
             * Format: uri
             * @description This is Uniform Resource Identifier of the file. See the File API for more details on how to retrieve the file content. This needs to be a fully qualified URL, starting with 'https://' and including the file identifier.
             */
            uri?: string;
        };
        ContactName: {
            /** @description First name. */
            firstName: string;
            /** @description Last name. */
            lastName: string;
        };
        ContactSlim: components["schemas"]["ContactName"] & {
            /**
             * Format: email
             * @description Email address.
             */
            email: string;
        };
        CommissionsBase: {
            /** @description This is the coverage type for the compensation split. */
            coverageType?: components["schemas"]["CoverageTypeEnum"];
            /** @description Value used to reference the Coverage.BenefitPlan.identifier element within the payload. */
            benefitPlanIdentifier?: string;
        };
        /**
         * @description Type of commission paid to a Producer.
         * @enum {string}
         */
        CurrentCommissionTypeEnum: CurrentCommissionTypeEnum;
        /**
         * Format: decimal
         * @description The percentage, net, pepm, or graded amount. The heaped type does not use this field.
         */
        FlatAmount: number;
        /** @description List of commission amounts for heaped commission type, ordered by consecutive year with the first year coming first. */
        HeapedAmount: number[];
        /**
         * @description Type of commission paid to a Producer.
         * @enum {string}
         */
        CommissionTypeEnum: CommissionTypeEnum;
        RfpCommissions: components["schemas"]["CommissionsBase"] & {
            /** @description The current type of commission. */
            currentType: components["schemas"]["CurrentCommissionTypeEnum"];
            currentAmount?: components["schemas"]["FlatAmount"];
            currentHeapedAmount?: components["schemas"]["HeapedAmount"];
            /** @description Type of commission being requested. */
            requestedType: components["schemas"]["CommissionTypeEnum"];
            requestedAmount?: components["schemas"]["FlatAmount"];
            requestedHeapedAmount?: components["schemas"]["HeapedAmount"];
        };
        Broker: {
            /** @description The name of the Broker Firm/entity requesting a quote - may not be current BoR. */
            name: string;
            /** @description The HQ address for the Broker Firm. */
            address: components["schemas"]["Address"];
            /** @description Individual account manager within the Broker/Broker firm who is the client facing day to day contact. */
            accountManager: components["schemas"]["ContactName"];
            /** @description Individual producer within the Broker/Broker firm. */
            producer: components["schemas"]["ContactSlim"];
            /** @description Indicates if another person within the broker's organization can provide insights to match the RFP to Carrier sales rep. If OneDigital Enterprise, the name of the Benefit Consultant will be provided. */
            additionalAgent?: components["schemas"]["ContactSlim"];
            /** @description Email addresses for carrier sales representatives */
            carrierSalesRepEmails?: string[];
            commissions: components["schemas"]["RfpCommissions"][];
        };
        /**
         * @description The general agent name.
         * @enum {string}
         */
        GeneralAgentNameEnum: GeneralAgentNameEnum;
        /** @description This is the General Agent entity that contains details about the general agent. */
        GeneralAgent: {
            name: components["schemas"]["GeneralAgentNameEnum"];
            /** @description This will always be Daniel McAlone. */
            producer: components["schemas"]["ContactName"];
            /** @description The analyst at Centro responsible for submitting and negotiating RFP/Q. */
            centroRfpAnalyst: components["schemas"]["ContactSlim"];
        };
        /**
         * @description Coverage types that are not supported by the system.
         * @enum {string}
         */
        UnsupportedCoverageTypeEnum: UnsupportedCoverageTypeEnum;
        /** @description Base schema containing common properties for Group RFP operations. */
        BaseGroupRfp: {
            /**
             * Format: uuid
             * @description This is the unique identifier generated by Ecosystem for the RFP. Ecosystem will send this on RFP submission. It is recommended that the carriers store this in case future correlation is needed, however, it is optional for carriers to return this back.
             */
            identifier?: string;
            /** @description This is the version number of the RFP. This is important to be stored by the carriers as it is used to correlate the proposals with the RFP. Ecosystem will increment this number on every update to the RFP, but there is no guarantee about the specific value. For example, you might first receive a RFP with version number 3, and then you might receive an update to the same RFP with version number 5. This is because there can be internal updates to the RFP that are not visible to carriers. */
            versionNumber?: number;
            /**
             * Format: date
             * @description Date when the requested coverage should become effective. The date must be in the format of ISO 8601
             */
            effectiveDate?: string;
            /**
             * Format: date
             * @description Date when the requested quotes are due. The date must be in the format of ISO 8601
             */
            dueDate?: string;
            /** @description Notes that the Centro Analyst will provide regarding the RFP. */
            notes?: string;
            /** @description This is the employer that has requested a proposal. */
            employer?: components["schemas"]["Employer"];
            /** @description These classes will be used to indicate class eligibility for each coverage and will match class eligibility on the census data. */
            benefitClasses?: components["schemas"]["BenefitClass"][];
            /** @description This is the census. It is a list of employees and dependents used for the RFP. */
            census?: components["schemas"]["GroupCensus"];
            /** @description This is the list of documents submitted for the RFP. */
            files?: components["schemas"]["File"][];
            broker?: components["schemas"]["Broker"];
            /** @description This is the Centro information. */
            generalAgent?: components["schemas"]["GeneralAgent"];
            /** @description Provides the ability to request additional products not supported by API. Since these products are not currently supported via API, UW should review template to view additional information for certain products. */
            additionalCoverages?: {
                types?: components["schemas"]["UnsupportedCoverageTypeEnum"][];
                /** @description Additional details on the additional products quoted. */
                notes?: string;
            };
        };
        /**
         * @description The type of technology credit offered.
         * @enum {string}
         */
        TechCreditTypeEnum: TechCreditTypeEnum;
        /** @description Credits that may be offered by carrier during rating to be used by employer for technology. */
        TechCredit: {
            type: components["schemas"]["TechCreditTypeEnum"];
            amount?: number;
        };
        BaseCoverage: {
            /** @description Dental, Vision, LTD, STD etc. */
            type?: components["schemas"]["CoverageTypeEnum"];
            /** @description Notes about the line of coverage. This can be used for RFP creation, update (re-quote), or proposal. */
            notes?: string;
            /** @description Technical credit information for the benefits administration platform. */
            techCredit?: components["schemas"]["TechCredit"];
        };
        /**
         * @description Indicates the status of the coverage for quoting. For RFP creation, only quoteNeeded is allowed.
         * @enum {string}
         */
        PostRfpCoverageStatusEnum: PostRfpCoverageStatusEnum;
        /**
         * @description This is a list of all possible plan types across all the coverage types.
         * @enum {string}
         */
        BenefitPlanTypeEnum: BenefitPlanTypeEnum;
        /**
         * @description This is the list of funding types. In the simplest terms, this is about how the claims are funded. There are other factors involved as well.
         * @enum {string}
         */
        FundingTypeEnum: FundingTypeEnum;
        /**
         * @description This is a list of option names that we allow for dual option plans.
         * @enum {string}
         */
        OptionNameEnum: OptionNameEnum;
        /**
         * @description This is the list of different rate designs.
         * @enum {string}
         */
        RateDesignEnum: RateDesignEnum;
        /**
         * @description Gender values for gender-specific rates.
         * @enum {string}
         */
        RateGenderEnum: RateGenderEnum;
        /**
         * @description This is the unit for the rates across different lines fo coverage.
         * @enum {string}
         */
        RateUnitEnum: RateUnitEnum;
        Rate: {
            /** @description Lower age of this age band. Omit if not age banded or this age band only has an upper limit e.g. rates that apply to any age up to 69. */
            ageBandLower?: number;
            /** @description Upper age of this band. Omit if not age banded or this age band only has a lower limit e.g. rates that apply to to any age 70 and above. */
            ageBandUpper?: number;
            /** @description Indicates the specific tier the RateAmount is pertinent to (Employee, Family, etc). Omit if not applicable. */
            coverageTierCode?: components["schemas"]["CoverageTierEnum"];
            /** @description This field is the count of lives that this rate applies to. */
            numberOfLives?: number;
            /** @description This is for gender specific rates. Omit if not applicable. */
            gender?: components["schemas"]["RateGenderEnum"];
            /** @description This is for rates that depend on tobacco use. Omit if not applicable. */
            isTobaccoRated?: boolean;
            /**
             * Format: decimal
             * @description The number indicating the monthly rate.
             */
            rate?: number;
            /** @description Volume used to calculate premium, calculated based on enrolled elections, covered benefit or covered payroll. This is only used for LTD, STD, and Life coverages. */
            volume?: number;
            /** @description This is the base unit for the amount like, USD/VOLUME PER 100 etc. */
            unit: components["schemas"]["RateUnitEnum"];
        };
        /**
         * @description This is for all life plans to differentiate between the life and adnd rates.
         * @enum {string}
         */
        RateCoverageIndicatorEnum: RateCoverageIndicatorEnum;
        RateSchedule: {
            /** @description Describes the rate design. */
            rateDesign: components["schemas"]["RateDesignEnum"];
            /** @description This field is the count of lives that matters for this rate. Depending on the Line of Coverage, it can represent different counts. */
            numberOfLives?: number;
            /**
             * Format: decimal
             * @description Per Employee Per Month. This is the rate used mainly for some ASO.
             */
            pepm?: number;
            /** @description Rate details by age/tier/gender/tobacco etc. */
            rates?: components["schemas"]["Rate"][];
            /** @description This is for all life plans to differentiate between the life and adnd rates. */
            rateCoverageIndicator?: components["schemas"]["RateCoverageIndicatorEnum"];
        };
        BaseBenefitPlan: {
            /** @description This plan identifier follows the following convention: < coverage code >-< Sequence number of the plan >-< Number for grouping multi-option plans together >. The first number is used to match plans that need to be grouped together. The second number makes this identifier unique. For example, a dual option vision plan could have benefitPlans with identifiers VIS-1-1 and VIS-1-2. */
            identifier?: string;
            /** @description This describes the type of plan design (PPO, HMO, etc). */
            type?: components["schemas"]["BenefitPlanTypeEnum"];
            /** @description This is the funding type for the plan. */
            fundingType?: components["schemas"]["FundingTypeEnum"];
            /** @description This describes the minimum amount of participation required for the plan to be effective. */
            participationRequirements?: string;
            /** @description This is used for plans with multiple options. */
            optionName?: components["schemas"]["OptionNameEnum"];
            /** @description This is the list of benefit class identifiers eligible for the plan design, and that this contribution structure applies to. */
            benefitClassAvailability?: string[];
            /** @description This is the rate schedule for this plan. */
            rateSchedule?: components["schemas"]["RateSchedule"][];
        };
        /**
         * @description This field tells us if the requested plan design matches the in-force plan (current) or if it is an alternate plan design (alternate). For a virgin line of coverage, use newBusiness.
         * @enum {string}
         */
        PolicyPeriodEnum: PolicyPeriodEnum;
        /** @description This is the carrier name */
        name: string;
        /**
         * @description The object type for dental benefits.
         * @enum {string}
         */
        DentalObjectTypeEnum: DentalObjectTypeEnum;
        /**
         * @description The type of dental service for which the waiting period applies.
         * @enum {string}
         */
        ServiceWaitingPeriodTypeEnum: ServiceWaitingPeriodTypeEnum;
        ServiceWaitingPeriod: {
            type: components["schemas"]["ServiceWaitingPeriodTypeEnum"];
            /** @description The number of months a participant must wait before utilizing benefits for this service type. */
            months: number;
        };
        DhmoBenefitDetail: {
            /** @description National medical code attached to service name (used in claims/billing). */
            adaCode: string;
            /** @description Name of service pertinent to the ADA code. */
            serviceName?: string;
            /** @description Dollar amount indicating the participant cost for the service name. */
            memberCost: number;
        };
        /**
         * @description The level of Employer contribution.
         * @enum {string}
         */
        EmployerContributionEnum: EmployerContributionEnum;
        BaseDentalBenefit: {
            objectType: components["schemas"]["DentalObjectTypeEnum"];
            /** @description The period of time, if any, a specific service may require the participant to wait before they can utilize that benefit. */
            serviceWaitingPeriods?: components["schemas"]["ServiceWaitingPeriod"][];
            /** @description Indicates the maximum age a child can be for dental coverage. */
            dependentAgeLimitYears?: number;
            /** @description If this is a DHMO plan, the networkBenefits will be empty and this will contain the list of benefits. */
            dhmoBenefits?: components["schemas"]["DhmoBenefitDetail"][];
            employerContribution?: components["schemas"]["EmployerContributionEnum"];
        };
        /**
         * @description This indicates if a benefit/service is considered as in network or out of network.
         * @enum {string}
         */
        NetworkEnum: NetworkEnum;
        /** @description The dollar amount when applicable. Omit if not applicable. */
        DollarAmount: number;
        /**
         * @description Indicates the type of dollar amount for individual deductible.
         * @enum {string}
         */
        IndividualDeductibleEnum: IndividualDeductibleEnum;
        IndividualDeductibleBenefit: {
            amount?: components["schemas"]["DollarAmount"];
            type: components["schemas"]["IndividualDeductibleEnum"];
        };
        BaseDentalNetworkBenefit: {
            /** @description Type of Network pertinent to benefits following. */
            network: components["schemas"]["NetworkEnum"];
            /**
             * @description This is used to label the network for when there are more than one in-network options. This should be omitted for out of network benefits
             * @example [
             *       "Dental PPO",
             *       "Dental Premier"
             *     ]
             */
            networkName?: string;
            /** @description Dollar amount of the deductible for an individual. */
            individualDeductible?: components["schemas"]["IndividualDeductibleBenefit"];
        };
        /**
         * @description Indicates the type of dollar amount for RFP.
         * @enum {string}
         */
        RfpDollarBenefitEnum: RfpDollarBenefitEnum;
        RfpDollarBenefit: {
            amount?: components["schemas"]["DollarAmount"];
            type: components["schemas"]["RfpDollarBenefitEnum"];
        };
        /** @description The percentage amount when applicable. Must be between 0-100. Omit if not applicable. */
        PercentageAmount: number;
        /**
         * @description Indicates the type of percentage amount for RFP.
         * @enum {string}
         */
        RfpPercentageBenefitTypeEnum: RfpPercentageBenefitTypeEnum;
        RfpPercentageBenefit: {
            amount?: components["schemas"]["PercentageAmount"];
            type: components["schemas"]["RfpPercentageBenefitTypeEnum"];
        };
        /**
         * @description This is a list of categories for dental services for RFP.
         * @enum {string}
         */
        RfpDentalServiceCategoryEnum: RfpDentalServiceCategoryEnum;
        /** @description The limiting age for a child to receive ortho coverage. */
        BaseOrthoAgeLimit: {
            age?: number;
        };
        /**
         * @description The type of ortho age limit for RFP.
         * @enum {string}
         */
        RfpOrthoAgeLimitTypeEnum: RfpOrthoAgeLimitTypeEnum;
        RfpOrthoAgeLimit: components["schemas"]["BaseOrthoAgeLimit"] & {
            type?: components["schemas"]["RfpOrthoAgeLimitTypeEnum"];
        };
        RfpDentalNetworkBenefit: components["schemas"]["BaseDentalNetworkBenefit"] & {
            /** @description Dollar amount of the deductible for family. */
            familyDeductible?: components["schemas"]["RfpDollarBenefit"];
            /** @description The maximum dollar amount carrier will pay annually toward all services. */
            annualMaximum?: components["schemas"]["RfpDollarBenefit"];
            /** @description The % of cost the carrier will cover for this service category. */
            preventativeType1?: components["schemas"]["RfpPercentageBenefit"];
            /** @description The % of cost the carrier will cover for this service category. */
            basicType2?: components["schemas"]["RfpPercentageBenefit"];
            /** @description The % of cost the carrier will cover for this service category. */
            majorType3?: components["schemas"]["RfpPercentageBenefit"];
            /** @description The % of cost the carrier will cover for this service category. */
            orthoType4?: components["schemas"]["RfpPercentageBenefit"];
            /** @description The maximum dollar amount carrier will pay for this service. */
            orthoMaximum?: components["schemas"]["RfpDollarBenefit"];
            /** @description Indicates the category in which the service is covered. */
            endodontics?: components["schemas"]["RfpDentalServiceCategoryEnum"];
            /** @description Indicates the category in which the service is covered. */
            periodonticsNonSurgical?: components["schemas"]["RfpDentalServiceCategoryEnum"];
            /** @description Indicates the category in which the service is covered. */
            periodonticsSurgical?: components["schemas"]["RfpDentalServiceCategoryEnum"];
            /** @description Indicates the category in which the service is covered. */
            oralSurgerySimple?: components["schemas"]["RfpDentalServiceCategoryEnum"];
            /** @description Indicates the category in which the service is covered. */
            oralSurgeryComplex?: components["schemas"]["RfpDentalServiceCategoryEnum"];
            /** @description Indicates the category in which the service is covered. */
            implants?: components["schemas"]["RfpDentalServiceCategoryEnum"];
            /** @description Indicates the category in which the service is covered. */
            sealants?: components["schemas"]["RfpDentalServiceCategoryEnum"];
            /** @description Indicates the category in which the service is covered. */
            spaceMaintainers?: components["schemas"]["RfpDentalServiceCategoryEnum"];
            /** @description Indicates the category in which the service is covered. */
            generalAnesthesia?: components["schemas"]["RfpDentalServiceCategoryEnum"];
            /** @description Indicates the category in which the service is covered. */
            compositeWhiteFillings?: components["schemas"]["RfpDentalServiceCategoryEnum"];
            /** @description The limiting age for a child to receive ortho coverage. */
            orthoAgeLimit?: components["schemas"]["RfpOrthoAgeLimit"];
        };
        /**
         * @description This is the list values expected for Out of Network Reimbursement for RFP.
         * @enum {string}
         */
        OutOfNetworkReimbursementEnum: OutOfNetworkReimbursementEnum;
        /**
         * @description Indicates the inclusion status of a benefit or feature.
         * @enum {string}
         */
        RfpInclusionStatusEnum: RfpInclusionStatusEnum;
        /**
         * @description The type of annual open enrollment for the plan.
         * @enum {string}
         */
        RfpAnnualOpenEnrollmentEnum: RfpAnnualOpenEnrollmentEnum;
        /**
         * @description This is the list of deductible time periods.
         * @enum {string}
         */
        RfpDeductibleDurationEnum: RfpDeductibleDurationEnum;
        RfpDentalBenefit: components["schemas"]["BaseDentalBenefit"] & {
            /** @description This is an array of in and out of network benefits. In most cases, it should only have two items - one with `network` set to `inNetwork` and one set to `outOfNetwork`. */
            networkBenefits?: components["schemas"]["RfpDentalNetworkBenefit"][];
            /** @description The amount carrier will reimburse for an out of network claim. */
            outOfNetworkReimbursement?: components["schemas"]["OutOfNetworkReimbursementEnum"];
            /** @description Indicates if a carrier will allow any portion of unused annual maximum to rollover to the next plan year. */
            maximumRollover?: components["schemas"]["RfpInclusionStatusEnum"];
            /** @description The provider has a clause that missing tooth is not covered for prior instance. So, if it is 'included', the carrier would not cover any lost teeth prior to effective date. */
            missingToothExclusion?: components["schemas"]["RfpInclusionStatusEnum"];
            /** @description Indicates if annual open enrollment is included in the plan. */
            annualOpenEnrollment?: components["schemas"]["RfpAnnualOpenEnrollmentEnum"];
            /** @description Indicates the period of time that the deductible applies. */
            deductibleDuration?: components["schemas"]["RfpDeductibleDurationEnum"];
            /** @description Indicates whether the deductible will be waived for preventative services. */
            isDeductibleWaivedPreventative?: components["schemas"]["RfpInclusionStatusEnum"];
        } & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            objectType: DentalObjectTypeEnum;
        };
        /**
         * @description The object type for vision benefits.
         * @enum {string}
         */
        VisionObjectTypeEnum: VisionObjectTypeEnum;
        /** @enum {string} */
        InNetworkOnlyEnum: InNetworkOnlyEnum;
        BaseVisionNetworkBenefit: {
            /**
             * @description The name of the plan network these benefits apply to. This should be omitted for out of network benefits.
             * @example [
             *       "VSP",
             *       "EyeMed",
             *       "PDP Plus"
             *     ]
             */
            networkName?: string;
        };
        /**
         * @description The type of copay rule that applies for RFP.
         * @enum {string}
         */
        RfpVisionCopayRuleTypeEnum: RfpVisionCopayRuleTypeEnum;
        VisionCopayRule: {
            /** @description The copay amount in dollars. Required when type is dollarAmount. */
            amount?: number;
        };
        RfpVisionCopayRule: {
            type: components["schemas"]["RfpVisionCopayRuleTypeEnum"];
        } & components["schemas"]["VisionCopayRule"];
        /**
         * @description The type of copay rule that applies to network benefits for RFP.
         * @enum {string}
         */
        RfpVisionCopayFullAllowanceRuleTypeEnum: RfpVisionCopayFullAllowanceRuleTypeEnum;
        /** @description Indicates the portion of cost covered by carrier after copay has been met. */
        RfpVisionCopayFullAllowanceRule: {
            type: components["schemas"]["RfpVisionCopayFullAllowanceRuleTypeEnum"];
            /** @description The copay amount in dollars. */
            copayAmount?: number;
            /** @description The allowance amount in dollars. */
            allowanceAmount?: number;
        };
        /**
         * @description The type of copay rule for progressive lenses and contact lens exams for RFP.
         * @enum {string}
         */
        RfpVisionCopayAllowanceRuleTypeEnum: RfpVisionCopayAllowanceRuleTypeEnum;
        /** @description Indicates the portion of cost covered by carrier after copay has been met for progressive lenses and contact lens exams. */
        RfpVisionCopayAllowanceRule: {
            type: components["schemas"]["RfpVisionCopayAllowanceRuleTypeEnum"];
            /** @description The copay amount in dollars. */
            copayAmount?: number;
            /** @description The allowance amount in dollars. */
            allowanceAmount?: number;
        };
        /**
         * @description The type of copay rule for specific vision services for RFP.
         * @enum {string}
         */
        RfpVisionSpecialCopayAllowanceRuleTypeEnum: RfpVisionSpecialCopayAllowanceRuleTypeEnum;
        /** @description Indicates the portion of cost covered by carrier after copay has been met for specific vision services. */
        RfpVisionSpecialCopayAllowanceRule: {
            type: components["schemas"]["RfpVisionSpecialCopayAllowanceRuleTypeEnum"];
            /** @description The copay amount in dollars. */
            copayAmount?: number;
            /** @description The allowance amount in dollars. */
            allowanceAmount?: number;
        };
        /**
         * @description The type of frames discount that applies for RFP.
         * @enum {string}
         */
        RfpFramesDiscountsRuleTypeEnum: RfpFramesDiscountsRuleTypeEnum;
        BaseFramesDiscountsRule: {
            /** @description The discount amount (percentage or dollar amount depending on type). */
            amount?: number;
        };
        RfpFramesDiscountsRule: {
            type: components["schemas"]["RfpFramesDiscountsRuleTypeEnum"];
        } & components["schemas"]["BaseFramesDiscountsRule"];
        RfpVisionNetworkBenefit: {
            /** @description Type of Network pertinent to benefits following. */
            network?: components["schemas"]["InNetworkOnlyEnum"];
        } & components["schemas"]["BaseVisionNetworkBenefit"] & {
            /** @description The copay rule for vision exams. */
            examCopay?: components["schemas"]["RfpVisionCopayRule"];
            /** @description The copay rule for vision materials. */
            materialsCopay?: components["schemas"]["RfpVisionCopayRule"];
            singleLenses?: components["schemas"]["RfpVisionCopayFullAllowanceRule"];
            bifocalLenses?: components["schemas"]["RfpVisionCopayFullAllowanceRule"];
            trifocalLenses?: components["schemas"]["RfpVisionCopayFullAllowanceRule"];
            lenticularLenses?: components["schemas"]["RfpVisionCopayFullAllowanceRule"];
            standardProgressive?: components["schemas"]["RfpVisionCopayAllowanceRule"];
            standardFrames?: components["schemas"]["RfpVisionSpecialCopayAllowanceRule"];
            /** @description Additional discounts available on frames beyond standard coverage. */
            additionalDiscountsOnFrames?: components["schemas"]["RfpFramesDiscountsRule"];
            contactLensElective?: components["schemas"]["RfpVisionSpecialCopayAllowanceRule"];
            contactLensExam?: components["schemas"]["RfpVisionCopayAllowanceRule"];
        };
        /**
         * @description Indicates the frequency at which the service can be rendered.
         * @enum {string}
         */
        RfpVisionBenefitFrequencyOptionEnum: RfpVisionBenefitFrequencyOptionEnum;
        RfpVisionBenefit: {
            objectType: components["schemas"]["VisionObjectTypeEnum"];
            /** @description This is an array of in and out of network benefits. In most cases, it should only have two items - one with `network` set to `inNetwork` and one set to `outOfNetwork`. */
            networkBenefits?: components["schemas"]["RfpVisionNetworkBenefit"][];
            examFrequency?: components["schemas"]["RfpVisionBenefitFrequencyOptionEnum"];
            lensesFrequency?: components["schemas"]["RfpVisionBenefitFrequencyOptionEnum"];
            framesFrequency?: components["schemas"]["RfpVisionBenefitFrequencyOptionEnum"];
            annualOpenEnrollment?: components["schemas"]["RfpAnnualOpenEnrollmentEnum"];
            employerContribution?: components["schemas"]["EmployerContributionEnum"];
        } & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            objectType: VisionObjectTypeEnum;
        };
        /**
         * @description The object type for basic life AD&D benefits.
         * @enum {string}
         */
        RfpBasicLifeObjectTypeEnum: RfpBasicLifeObjectTypeEnum;
        /**
         * @description Describes the benefit configuration available.
         * @enum {string}
         */
        RfpBasicLifeBenefitAmountTypeEnum: RfpBasicLifeBenefitAmountTypeEnum;
        /**
         * @description Indicates the maximum amount of benefit that can be elected.
         * @enum {string}
         */
        BenefitMaximumTypeEnum: BenefitMaximumTypeEnum;
        /**
         * @description Describes the guarantee issue configuration available.
         * @enum {string}
         */
        RfpBasicLifeGuaranteeIssueTypeEnum: RfpBasicLifeGuaranteeIssueTypeEnum;
        /**
         * @description Defines the carrier's definition of earnings for the purpose of calculating benefit amount.
         * @enum {string}
         */
        DefinitionOfEarningsTypeEnum: DefinitionOfEarningsTypeEnum;
        /**
         * @description Indicates if policy holder can continue policy after separation of employment and whether Evidence of Insurability would be required.
         * @enum {string}
         */
        RfpPortabilityTypeEnum: RfpPortabilityTypeEnum;
        BaseBasicLifeAdndBenefit: {
            objectType?: components["schemas"]["RfpBasicLifeObjectTypeEnum"];
            /** @description Indicates the amount of benefit available to each individual. */
            benefitAmount?: {
                type: components["schemas"]["RfpBasicLifeBenefitAmountTypeEnum"];
                /** @description Used for increments, dollarAmount, and salaryMultiplierPlusDollarAmount types. Omit otherwise. */
                dollarAmount?: number;
                /** @description Used for salaryMultiplier and salaryMultiplierPlusDollarAmount types. Omit otherwise. */
                salaryMultiplier?: number;
            };
            /** @description Indicates the maximum amount of benefit for each individual. */
            benefitMaximum?: {
                type: components["schemas"]["BenefitMaximumTypeEnum"];
                /** @description The maximum benefit dollar amount. Used when type is dollarAmount or lesserOfDollarAmountOrSalaryMultiplier. Omit otherwise. */
                dollarAmount?: number;
                /** @description The maximum benefit salary multiplier. Used when type is salaryMultiplier or lesserOfDollarAmountOrSalaryMultiplier. Omit otherwise. */
                salaryMultiplier?: number;
            };
            /** @description Indicates the benefit amount of Life Insurance available without having to provide Evidence of Insurability. */
            guaranteeIssue?: {
                type: components["schemas"]["RfpBasicLifeGuaranteeIssueTypeEnum"];
                /** @description Used for salary multiplier types. Omit otherwise. */
                salaryMultiplier?: number;
                /** @description Used for dollar amount types. Omit otherwise. */
                dollarAmount?: number;
                /** @description Used for salaryMultiplierWithDollarAmountPlusAdditionalAmount. Omit otherwise. */
                additionalAmount?: number;
            };
            /** @description Indicates the earnings covered by the plan. */
            definitionOfEarnings?: {
                /** @description The type of earnings definition. */
                type: components["schemas"]["DefinitionOfEarningsTypeEnum"];
                /** @description The time period covered when considering earnings and what is included in those earnings (example - commissions averaged over a 12 month period). */
                earningsAverageMonths?: number;
            };
            /** @description Indicates if policy holder can continue policy after separation of employment and whether Evidence of Insurability would be required. */
            portability?: components["schemas"]["RfpPortabilityTypeEnum"];
            employerContribution?: components["schemas"]["EmployerContributionEnum"];
        };
        /**
         * @description Describes the spouse benefit configuration available for RFP.
         * @enum {string}
         */
        RfpBasicLifeSpouseBenefitTypeEnum: RfpVisionCopayRuleTypeEnum;
        /**
         * @description Describes the child benefit configuration available for RFP.
         * @enum {string}
         */
        RfpBasicLifeChildBenefitTypeEnum: RfpVisionCopayRuleTypeEnum;
        ReductionDetails: {
            /** @description The age at which the reduction schedule begins to apply. If excluded, indicates reduction applies to all ages less than or equal to ageBandUpper. */
            ageBandLower?: number;
            /** @description The age at which the reduction schedule ends. If excluded, indicates reduction applies to all ages greater than or equal to ageBandLower. */
            ageBandUpper?: number;
            /** @description The percentage amount the benefit is reduced by. */
            percent: number;
        };
        /** @description This is the list of reductions */
        ReductionSchedule: components["schemas"]["ReductionDetails"][];
        /** @description Details any benefit change-increments based on age. (Ex: 35% at 65, 50% at 70 *standard is two, but could be up to 6). */
        BaseAgeReductionSchedule: {
            /** @description Indicates the type of age reduction schedule. */
            type: unknown;
            /** @description The reduction schedule details. Omit if type is 'none', 'notIncluded', or 'notOffered'. */
            schedules?: components["schemas"]["ReductionSchedule"];
        };
        /**
         * @description Indicates the type of age reduction schedule for RFP.
         * @enum {string}
         */
        RfpAgeReductionScheduleTypeEnum: RfpAgeReductionScheduleTypeEnum;
        RfpAgeReductionSchedule: components["schemas"]["BaseAgeReductionSchedule"] & {
            type?: components["schemas"]["RfpAgeReductionScheduleTypeEnum"];
        };
        RfpBasicLifeAdndBenefit: components["schemas"]["BaseBasicLifeAdndBenefit"] & {
            /** @description Indicates the amount of benefit available for a spouse. */
            spouseBenefit?: {
                type: components["schemas"]["RfpBasicLifeSpouseBenefitTypeEnum"];
                /** @description The spouse benefit dollar amount. Omit if type is notIncluded. */
                amount?: number;
            };
            /** @description Indicates the amount of benefit available for a child. */
            childBenefit?: {
                type: components["schemas"]["RfpBasicLifeChildBenefitTypeEnum"];
                /** @description The child benefit dollar amount. Omit if type is notIncluded. */
                amount?: number;
            };
            /** @description Details any benefit change-increments based on age. (Ex: 35% at 65, 50% at 70 *standard is two, but could be up to 6). */
            ageReductionSchedule?: components["schemas"]["RfpAgeReductionSchedule"];
            /** @description Indicates if the employee will be allowed to convert the basic life policy to a different form of life policy. */
            conversion?: components["schemas"]["RfpInclusionStatusEnum"];
            /** @description Indicates if the plan will allow for any amount of life insurance benefit to be paid out in advance of death (typically in the case of a terminal illness diagnosis). */
            acceleratedDeathBenefit?: components["schemas"]["RfpInclusionStatusEnum"];
            /** @description Indicates if premium payments will be waived in the case of a critical illness or serious injury. */
            waiverOfPremium?: components["schemas"]["RfpInclusionStatusEnum"];
        } & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            objectType: RfpBasicLifeObjectTypeEnum;
        };
        /**
         * @description Describes the benefit configuration available for employee.
         * @enum {string}
         */
        RfpVoluntaryLifeEmployeeBenefitTypeEnum: RfpVoluntaryLifeEmployeeBenefitTypeEnum;
        /** @description Describes the benefit configuration available for employee. */
        RfpVoluntaryLifeEmployeeBenefitAmount: {
            /** @description The type of benefit amount. */
            type: components["schemas"]["RfpVoluntaryLifeEmployeeBenefitTypeEnum"];
            /** @description List of benefit amounts when applicable. Omit if not applicable. */
            amounts?: number[];
        };
        /**
         * @description Indicates the maximum amount of benefit that can be elected.
         * @enum {string}
         */
        RfpVoluntaryLifeBenefitMaximumTypeEnum: BenefitMaximumTypeEnum;
        /** @description Benefit maximum configuration. */
        RfpVoluntaryLifeBenefitMaximum: {
            /** @description The type of benefit maximum. */
            type: components["schemas"]["RfpVoluntaryLifeBenefitMaximumTypeEnum"];
            /** @description Dollar amount maximum when applicable. Omit if not applicable. */
            dollarAmount?: number;
            /** @description Salary multiplier maximum when applicable. Omit if not applicable. */
            salaryMultiplier?: number;
        };
        /**
         * @description Indicates the amount of Life Insurance volume available without having to provide Evidence of Insurability.
         * @enum {string}
         */
        RfpVoluntaryLifeGuaranteeIssueTypeEnum: RfpVoluntaryLifeGuaranteeIssueTypeEnum;
        /** @description Age-based guarantee issue amounts. */
        GuaranteeIssueAgeBasedAmount: {
            /** @description Lower age band for guarantee issue. */
            ageBandLower?: number;
            /** @description Upper age band for guarantee issue. */
            ageBandUpper?: number;
            /** @description Guarantee issue amount for this age band. */
            amount: number;
        };
        /** @description Guarantee issue configuration. */
        RfpVoluntaryLifeGuaranteeIssue: {
            /** @description The type of guarantee issue. */
            type: components["schemas"]["RfpVoluntaryLifeGuaranteeIssueTypeEnum"];
            /** @description Dollar amount for guarantee issue when applicable. Omit if not applicable. */
            dollarAmount?: number;
            /** @description Used for salary multiplier types. Omit otherwise. */
            salaryMultiplier?: number;
            /** @description Used for salaryMultiplierWithDollarAmountPlusAdditionalAmount. Omit otherwise. */
            additionalAmount?: number;
            /** @description Age-based guarantee issue amounts when applicable. Omit if not applicable. */
            ageBasedAmounts?: components["schemas"]["GuaranteeIssueAgeBasedAmount"][];
        };
        /** @description Employee voluntary life benefit configuration. */
        RfpVoluntaryLifeEmployeeBenefit: {
            /** @description Benefit amount configuration for employee. */
            benefitDescription?: components["schemas"]["RfpVoluntaryLifeEmployeeBenefitAmount"];
            /** @description Benefit maximum configuration for employee. */
            benefitMaximum?: components["schemas"]["RfpVoluntaryLifeBenefitMaximum"];
            /** @description Guarantee issue configuration for employee. */
            guaranteeIssue?: components["schemas"]["RfpVoluntaryLifeGuaranteeIssue"];
        };
        /**
         * @description Describes the benefit configuration available for spouse and child.
         * @enum {string}
         */
        RfpVoluntaryLifeSpouseChildBenefitTypeEnum: RfpVoluntaryLifeSpouseChildBenefitTypeEnum;
        /** @description Describes the benefit configuration available for spouse and child. */
        RfpVoluntaryLifeSpouseChildBenefitAmount: {
            /** @description The type of benefit amount. */
            type: components["schemas"]["RfpVoluntaryLifeSpouseChildBenefitTypeEnum"];
            /** @description List of benefit amounts when applicable. Omit if not applicable. */
            amounts?: number[];
        };
        /**
         * @description Indicates the maximum amount of benefit that can be elected for spouse and child.
         * @enum {string}
         */
        RfpVoluntaryLifeSpouseChildBenefitMaximumTypeEnum: RfpVisionCopayRuleTypeEnum;
        /** @description Benefit maximum configuration for spouse and child. */
        RfpVoluntaryLifeSpouseChildBenefitMaximum: {
            /** @description The type of benefit maximum. */
            type: components["schemas"]["RfpVoluntaryLifeSpouseChildBenefitMaximumTypeEnum"];
            /** @description Dollar amount maximum when applicable. Omit if not applicable. */
            dollarAmount?: number;
        };
        /**
         * @description Indicates limitation on Spouse or Child benefit.
         * @enum {string}
         */
        RfpVoluntaryLifeAmountNotToExceedTypeEnum: RfpVoluntaryLifeAmountNotToExceedTypeEnum;
        /** @description Amount not to exceed configuration. */
        RfpVoluntaryLifeAmountNotToExceed: {
            /** @description The type of amount not to exceed. */
            type: components["schemas"]["RfpVoluntaryLifeAmountNotToExceedTypeEnum"];
            /** @description Amount when applicable. Omit if not applicable. */
            amount?: number;
        };
        /** @description Spouse voluntary life benefit configuration. */
        RfpVoluntaryLifeSpouseBenefit: {
            /** @description Benefit amount configuration for spouse. */
            benefitDescription?: components["schemas"]["RfpVoluntaryLifeSpouseChildBenefitAmount"];
            /** @description Benefit maximum configuration for spouse. */
            benefitMaximum?: components["schemas"]["RfpVoluntaryLifeSpouseChildBenefitMaximum"];
            /** @description Guarantee issue configuration for spouse. */
            guaranteeIssue?: components["schemas"]["RfpVoluntaryLifeGuaranteeIssue"];
            /** @description Amount not to exceed configuration for spouse. */
            amountNotToExceed?: components["schemas"]["RfpVoluntaryLifeAmountNotToExceed"];
        };
        /**
         * @description The unit of measurement for child benefit age band limits.
         * @enum {string}
         */
        ChildBenefitAgeUnitEnum: ChildBenefitAgeUnitEnum;
        /** @description Child benefit configuration for a specific age band. */
        ChildBenefitAgeBasedAmount: {
            /** @description Lower age limit for this benefit band (in days for children under 1 year, in years for older children). If excluded, indicates this band applies to all ages less than or equal to ageBandUpper. */
            ageBandLower?: number;
            /** @description Upper age limit for this benefit band (in days for children under 1 year, in years for older children). If excluded, indicates this band applies to all ages greater than or equal to ageBandLower. */
            ageBandUpper?: number;
            unit: components["schemas"]["ChildBenefitAgeUnitEnum"];
            /** @description Benefit amount configuration for this age band. */
            benefitAmount: components["schemas"]["RfpVoluntaryLifeSpouseChildBenefitAmount"];
        };
        /** @description Child benefit configuration by age bands. */
        RfpVoluntaryLifeChildBenefitByAge: components["schemas"]["ChildBenefitAgeBasedAmount"][];
        /**
         * @description Indicates if the child benefits are offered beyond the child limiting age for children who are full time students.
         * @enum {string}
         */
        RfpVoluntaryLifeStudentStatusTypeEnum: RfpInclusionStatusEnum;
        /** @description Student status configuration. */
        RfpVoluntaryLifeStudentStatus: {
            /** @description The type of student status. */
            type: components["schemas"]["RfpVoluntaryLifeStudentStatusTypeEnum"];
            /** @description Student limiting age when applicable. Omit if not applicable. */
            amount?: number;
        };
        /** @description Child voluntary life benefit configuration. */
        RfpVoluntaryLifeChildBenefit: {
            /** @description Benefit amounts by age bands for child. */
            benefitAmountsByAge?: components["schemas"]["RfpVoluntaryLifeChildBenefitByAge"];
            /** @description Benefit maximum configuration for child. */
            benefitMaximum?: components["schemas"]["RfpVoluntaryLifeSpouseChildBenefitMaximum"];
            /** @description Amount not to exceed configuration for child. */
            amountNotToExceed?: components["schemas"]["RfpVoluntaryLifeAmountNotToExceed"];
            /** @description Student status configuration for child. */
            studentLimitingAge?: components["schemas"]["RfpVoluntaryLifeStudentStatus"];
        };
        /** @description Indicates the earnings covered by the plan. */
        DefinitionOfEarnings: {
            /** @description The type of earnings definition. */
            type: components["schemas"]["DefinitionOfEarningsTypeEnum"];
            /** @description The average month calculation when applicable. Omit if not applicable. */
            averageMonth?: number;
        };
        /**
         * @description Indicates if AD&D benefit amount must match vol life benefit amount.
         * @enum {string}
         */
        RfpVoluntaryLifeAdndTiedToLifeTypeEnum: RfpVoluntaryLifeAdndTiedToLifeTypeEnum;
        /**
         * @description Indicates the type of age reduction schedule.
         * @enum {string}
         */
        RfpVoluntaryLifeAgeReductionScheduleTypeEnum: RfpAgeReductionScheduleTypeEnum;
        /** @description Age reduction schedule configuration. */
        RfpVoluntaryLifeAgeReductionSchedule: {
            /** @description The type of age reduction schedule. */
            type: components["schemas"]["RfpVoluntaryLifeAgeReductionScheduleTypeEnum"];
            /** @description The reduction schedule details. Omit if type is 'none' or 'notIncluded'. */
            schedules?: components["schemas"]["ReductionSchedule"];
        };
        RfpVoluntaryLifeAdndBenefit: {
            /** @enum {string} */
            objectType: RfpVoluntaryLifeAdndBenefitObjectType;
            /** @description Employee benefit configuration. */
            employee?: components["schemas"]["RfpVoluntaryLifeEmployeeBenefit"];
            /** @description Spouse benefit configuration. */
            spouse?: components["schemas"]["RfpVoluntaryLifeSpouseBenefit"];
            /** @description Child benefit configuration. */
            child?: components["schemas"]["RfpVoluntaryLifeChildBenefit"];
            definitionOfEarnings?: components["schemas"]["DefinitionOfEarnings"];
            /** @description Indicates if AD&D benefit is included with Life benefit. */
            adndIncluded?: components["schemas"]["RfpInclusionStatusEnum"];
            /** @description Indicates if AD&D benefit amount must match vol life benefit amount. */
            adndTiedToLife?: components["schemas"]["RfpVoluntaryLifeAdndTiedToLifeTypeEnum"];
            /** @description Details any benefit change-increments based on age. */
            ageReductionSchedule?: components["schemas"]["RfpVoluntaryLifeAgeReductionSchedule"];
            /** @description Indicates if the employee will be allowed to convert the life policy to a different form of life policy. */
            conversion?: components["schemas"]["RfpInclusionStatusEnum"];
            /** @description Indicates if the plan will allow for any amount of life insurance benefit to be paid out in advance of death. */
            acceleratedDeathBenefit?: components["schemas"]["RfpInclusionStatusEnum"];
            /** @description Indicates if premium payments will be waived in the case of a critical illness or serious injury. */
            waiverOfPremium?: components["schemas"]["RfpInclusionStatusEnum"];
            /** @description Indicates if annual open enrollment is included in the plan. */
            annualOpenEnrollment?: components["schemas"]["RfpAnnualOpenEnrollmentEnum"];
            /** @description Indicates if policy holder can continue policy after separation of employment and whether Evidence of Insurability would be required. */
            portability?: components["schemas"]["RfpPortabilityTypeEnum"];
        } & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            objectType: RfpVoluntaryLifeAdndBenefitObjectType;
        };
        /**
         * @description Object type identifier for STD benefits.
         * @enum {string}
         */
        StdObjectTypeEnum: StdObjectTypeEnum;
        /**
         * @description Indicates the percentage of salary benefit will pay or the increment at which benefits may be elected.
         * @enum {string}
         */
        StdBenefitAmountTypeEnum: StdBenefitAmountTypeEnum;
        /** @description Indicates the percentage of salary benefit will pay or the increment at which benefits may be elected. */
        StdBenefitAmount: {
            /** @description The type of benefit amount structure. */
            type: components["schemas"]["StdBenefitAmountTypeEnum"];
            /** @description The specific amount when applicable. Omit if not applicable. */
            amount?: number;
            /** @description The minimum amount when applicable. Omit if not applicable. */
            minimum?: number;
        };
        /** @description Indicates the total max dollar amount benefit will pay. */
        MaximumAmountType: {
            /** @description The type of maximum amount structure. */
            type: unknown;
            /** @description The cap amount when applicable. Omit if not applicable. */
            dollarAmount?: number;
            /** @description The percent amount when applicable. Omit if not applicable. */
            percent?: number;
        };
        /**
         * @description Indicates the total max dollar amount benefit will pay.
         * @enum {string}
         */
        MaximumAmountTypeEnum: MaximumAmountTypeEnum;
        DisabilityMaximumAmount: components["schemas"]["MaximumAmountType"] & {
            type?: components["schemas"]["MaximumAmountTypeEnum"];
        };
        /**
         * @description Indicates carrier defined requirements for what constitutes a disability.
         * @enum {string}
         */
        DefinitionOfDisabilityTypeEnum: DefinitionOfDisabilityTypeEnum;
        BaseStdBenefit: {
            objectType?: components["schemas"]["StdObjectTypeEnum"];
            /** @description Indicates the percentage of salary benefit will pay or the increment at which benefits may be elected. */
            benefitAmount?: components["schemas"]["StdBenefitAmount"];
            /** @description Indicates the total max dollar amount benefit will pay. */
            maximumAmount?: components["schemas"]["DisabilityMaximumAmount"];
            definitionOfDisability?: components["schemas"]["DefinitionOfDisabilityTypeEnum"];
            /** @description Indicates the earnings covered by the plan. */
            definitionOfEarnings?: components["schemas"]["DefinitionOfEarnings"];
            /** @description Indicates the level of employer contribution. */
            employerContribution?: components["schemas"]["EmployerContributionEnum"];
        };
        /** @description Indicates the period of time that must pass before they begin receiving benefit. */
        EliminationPeriodType: {
            /** @description The number of days when applicable. Omit if not applicable. */
            amount?: number;
        };
        /**
         * @description Indicates the period of time that must pass before they begin receiving benefit.
         * @enum {string}
         */
        RfpEliminationPeriodTypeEnum: RfpEliminationPeriodTypeEnum;
        RfpEliminationPeriodType: components["schemas"]["EliminationPeriodType"] & {
            type: components["schemas"]["RfpEliminationPeriodTypeEnum"];
        };
        /**
         * @description Indicates the maximum amount of time the carrier will pay out the benefit.
         * @enum {string}
         */
        RfpStdBenefitDurationTypeEnum: RfpStdBenefitDurationTypeEnum;
        /** @description Indicates the maximum amount of time the carrier will pay out the benefit minus the elimination period time. */
        RfpStdBenefitDuration: {
            /** @description Indicates the maximum amount of time the carrier will pay out the benefit. */
            type: components["schemas"]["RfpStdBenefitDurationTypeEnum"];
            /** @description The duration amount when applicable. Omit if not applicable. */
            amount?: number;
        };
        /**
         * @description Indicates the pre-existing condition type.
         * @enum {string}
         */
        RfpPreExistingConditionTypeEnum: RfpPreExistingConditionTypeEnum;
        /** @description Indicates the amount of months before effective date AND after effective date participant needs to be illness free to claim benefit. */
        RfpPreExistingConditionExtended: {
            /** @description The pre-existing condition type. */
            type: components["schemas"]["RfpPreExistingConditionTypeEnum"];
            /** @description Months diagnosis free before effective date. Omit if not applicable. */
            monthsDiagnosisFreeBeforeEffDate?: number;
            /** @description Months treatment free. Omit if not applicable. */
            monthsTreatmentFree?: number;
            /** @description Months diagnosis free after effective date. Omit if not applicable. */
            monthsDiagnosisFreeAfterEffDate?: number;
        };
        /**
         * @description Indicates if FICA match is included.
         * @enum {string}
         */
        RfpFicaMatchEnum: RfpInclusionStatusEnum;
        /**
         * @description Indicates if the FICA match is considered billable or non-billable.
         * @enum {string}
         */
        RfpBillableTypeEnum: RfpBillableTypeEnum;
        RfpStdBenefit: components["schemas"]["BaseStdBenefit"] & {
            /** @description Indicates the period of time after accident event that must pass before they begin receiving benefit. */
            eliminationPeriodAccident?: components["schemas"]["RfpEliminationPeriodType"];
            /** @description Indicates the period of time after start of illness that must pass before they begin receiving benefit. */
            eliminationPeriodIllness?: components["schemas"]["RfpEliminationPeriodType"];
            /** @description Indicates the maximum amount of time the carrier will pay out the benefit minus the elimination period time. */
            benefitDuration?: components["schemas"]["RfpStdBenefitDuration"];
            /** @description Indicates the amount of months before eff date AND after effective date participant needs to be illness free to claim benefit. */
            preExistingCondition?: components["schemas"]["RfpPreExistingConditionExtended"];
            /** @description Indicates if FICA match is included in the quote. */
            ficaMatch?: components["schemas"]["RfpFicaMatchEnum"];
            /** @description Indicates if the FICA match is considered billable or non-billable. */
            billableType?: components["schemas"]["RfpBillableTypeEnum"];
        } & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            objectType: StdObjectTypeEnum;
        };
        /**
         * @description Object type identifier for LTD benefits.
         * @enum {string}
         */
        LtdObjectTypeEnum: LtdObjectTypeEnum;
        /**
         * @description The type of benefit amount structure.
         * @enum {string}
         */
        RfpLtdBenefitAmountTypeEnum: StdBenefitAmountTypeEnum;
        /** @description Indicates the percentage of salary benefit will pay or the increments at which the benefits can be elected. */
        LtdBenefitAmount: {
            /** @description The type of benefit amount structure. */
            type: components["schemas"]["RfpLtdBenefitAmountTypeEnum"];
            /** @description The specific amount when applicable. Omit if not applicable. */
            amount?: number;
            /** @description The minimum amount when applicable. Omit if not applicable. */
            minimum?: number;
        };
        BaseLtdBenefit: {
            objectType: components["schemas"]["LtdObjectTypeEnum"];
            /** @description Indicates the percentage of salary benefit will pay or the increments at which the benefits can be elected. */
            benefitAmount?: components["schemas"]["LtdBenefitAmount"];
            /** @description Indicates the total max dollar amount benefit will pay. */
            maximumAmount?: components["schemas"]["DisabilityMaximumAmount"];
            definitionOfDisability?: components["schemas"]["DefinitionOfDisabilityTypeEnum"];
            /** @description Indicates the earnings covered by the plan. */
            definitionOfEarnings?: components["schemas"]["DefinitionOfEarnings"];
            /** @description Indicates the employer contribution structure for the benefit. */
            employerContribution?: components["schemas"]["EmployerContributionEnum"];
        };
        /** @description Indicates the total benefit that is guaranteed without health questions. */
        GuaranteedIssue: {
            /** @description The type of guaranteed issue structure. */
            type: unknown;
            /** @description The guaranteed issue amount when applicable. Omit if not applicable. */
            amount?: number;
        };
        /**
         * @description The type of guaranteed issue structure for RFP.
         * @enum {string}
         */
        RfpLtdGuaranteedIssueRuleTypeEnum: RfpVisionCopayRuleTypeEnum;
        RfpGuaranteedIssue: components["schemas"]["GuaranteedIssue"] & {
            type?: components["schemas"]["RfpLtdGuaranteedIssueRuleTypeEnum"];
        };
        /** @description Indicates the own occupation period structure. */
        OwnOccupationPeriod: {
            /** @description The type of own occupation period. */
            type: unknown;
            /** @description The period amount when applicable. Omit if not applicable. */
            amount?: number;
        };
        /**
         * @description The type of own occupation period for RFP.
         * @enum {string}
         */
        RfpLtdOwnOccupationPeriodTypeEnum: RfpLtdOwnOccupationPeriodTypeEnum;
        RfpOwnOccupationPeriod: components["schemas"]["OwnOccupationPeriod"] & {
            type?: components["schemas"]["RfpLtdOwnOccupationPeriodTypeEnum"];
        };
        /** @description Defines the carrier's required 'loss of earnings' that must be met to be eligible for benefit. */
        GainfulEarningsTest: {
            /** @description The type of gainful earnings test. */
            type: unknown;
            /** @description The percentage amount when applicable. Omit if not applicable. */
            amount?: number;
        };
        /**
         * @description The type of gainful earnings test for RFP.
         * @enum {string}
         */
        RfpGainfulEarningsRuleTypeEnum: RfpGainfulEarningsRuleTypeEnum;
        RfpGainfulEarningsTest: components["schemas"]["GainfulEarningsTest"] & {
            type?: components["schemas"]["RfpGainfulEarningsRuleTypeEnum"];
        };
        /** @description Indicates the period of time after participant becomes disabled that must pass before they begin receiving benefit. */
        EliminationPeriod: {
            /** @description The type of elimination period. */
            type: unknown;
            /** @description The number of days when applicable. Omit if not applicable. */
            amount?: number;
        };
        RfpEliminationPeriod: components["schemas"]["EliminationPeriod"] & {
            type?: components["schemas"]["RfpEliminationPeriodTypeEnum"];
        };
        /**
         * @description Indicates the maximum amount of time the carrier will pay out the benefit.
         * @enum {string}
         */
        BenefitDurationTypeEnum: BenefitDurationTypeEnum;
        /** @description Indicates the amount of time the carrier will pay out the benefit. */
        BenefitDuration: {
            type: components["schemas"]["BenefitDurationTypeEnum"];
            /** @description The duration amount when applicable. Omit if not applicable. */
            amount?: number;
        };
        /** @description Base type for time period limitations. */
        Limitation: {
            /** @description The type of limitation. */
            type: unknown;
            /** @description The timeframe amount when applicable. Omit if not applicable. */
            timeframe?: number;
        };
        /**
         * @description Indicates if additional plan limitations exist.
         * @enum {string}
         */
        RfpLtdOtherLimitationsEnum: RfpLtdOtherLimitationsEnum;
        RfpOtherLimitation: components["schemas"]["Limitation"] & {
            type?: components["schemas"]["RfpLtdOtherLimitationsEnum"];
        };
        /**
         * @description The type of time period limitation for RFP.
         * @enum {string}
         */
        RfpLtdLimitationTypeEnum: RfpLtdOtherLimitationsEnum;
        RfpLimitation: components["schemas"]["Limitation"] & {
            type?: components["schemas"]["RfpLtdLimitationTypeEnum"];
        };
        /** @description Indicates the amount of months before effective date AND after effective date participant needs to be illness free to claim benefit. */
        RfpPreExistingCondition: {
            type: components["schemas"]["RfpPreExistingConditionTypeEnum"];
            /** @description Months diagnosis free before effective date. Omit if not applicable. */
            monthsDiagnosisFreeBeforeEffDate?: number;
            /** @description Months treatment free. Omit if not applicable. */
            monthsTreatmentFree?: number;
            /** @description Months diagnosis free after effective date. Omit if not applicable. */
            monthsDiagnosisFreeAfterEffDate?: number;
        };
        /**
         * @description Defines the carrier rehabilitation requirement to be eligible for benefit.
         * @enum {string}
         */
        RfpRehabTypeEnum: RfpRehabTypeEnum;
        RfpLtdBenefit: components["schemas"]["BaseLtdBenefit"] & {
            /** @description Indicates the total benefit that is guaranteed without health questions. */
            guaranteedIssue?: components["schemas"]["RfpGuaranteedIssue"];
            /** @description Own occupation period configuration. */
            ownOccupationPeriod?: components["schemas"]["RfpOwnOccupationPeriod"];
            /** @description Defines the carrier's required 'loss of earnings' that must be met to be eligible for benefit during the own occupation period. */
            gainfulEarningsTestOwnOccupation?: components["schemas"]["RfpGainfulEarningsTest"];
            /** @description Defines the carrier's required 'loss of earnings' that must be met to be eligible for benefit during the any occupation period. */
            gainfulEarningsTestAnyOccupation?: components["schemas"]["RfpGainfulEarningsTest"];
            /** @description Indicates the period of time after participant becomes disabled that must pass before they begin receiving benefit. */
            eliminationPeriod?: components["schemas"]["RfpEliminationPeriod"];
            /** @description Indicates the amount of time the carrier will pay out the benefit. */
            benefitDuration?: components["schemas"]["BenefitDuration"];
            /** @description Indicates if additional plan limitations exist in the quoted plan such as special conditions, self-reported limitations, etc. */
            otherLimitations?: components["schemas"]["RfpOtherLimitation"];
            /** @description Indicates the time period limitation for mental illness. */
            mentalIllness?: components["schemas"]["RfpLimitation"];
            /** @description Indicates the time period limitation for substance abuse. */
            substanceAbuse?: components["schemas"]["RfpLimitation"];
            /** @description Indicates the amount of months before eff date AND after effective date participant needs to be illness free to claim benefit. */
            preExistingCondition?: components["schemas"]["RfpPreExistingCondition"];
            /** @description Defines the carrier rehabilitation requirement to be eligible for benefit. */
            rehab?: components["schemas"]["RfpRehabTypeEnum"];
            /** @description Indicates if Cost of Living Adjustment will be factored into the benefit amount proposed. */
            cola?: components["schemas"]["RfpInclusionStatusEnum"];
            /** @description Indicates if the employee will be allowed to convert the policy to a different form of coverage. */
            conversion?: components["schemas"]["RfpInclusionStatusEnum"];
            /** @description Indicates if premium payments will be waived in the case of a critical illness or serious injury. */
            waiverOfPremium?: components["schemas"]["RfpInclusionStatusEnum"];
        } & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            objectType: LtdObjectTypeEnum;
        };
        /**
         * @description The object type for critical illness benefits.
         * @enum {string}
         */
        CriticalIllnessObjectTypeEnum: CriticalIllnessObjectTypeEnum;
        /**
         * @description Describes the benefit configuration available for employee.
         * @enum {string}
         */
        CriticalIllnessEmployeeBenefitDescriptionTypeEnum: CriticalIllnessEmployeeBenefitDescriptionTypeEnum;
        /** @description Describes the benefit configuration available for employee. */
        RfpCriticalIllnessEmployeeBenefitDescription: {
            /** @description The type of benefit description. */
            type: components["schemas"]["CriticalIllnessEmployeeBenefitDescriptionTypeEnum"];
            /** @description The benefit description amounts. Include multiple items when type is multipleOptions, single item otherwise when applicable. */
            amounts?: number[];
            /** @description The minimum benefit description amount. Include when applicable. */
            minimum?: number;
        };
        /**
         * @description Indicates the maximum amount of benefit the employee can elect.
         * @enum {string}
         */
        CriticalIllnessEmployeeMaximumTypeEnum: CriticalIllnessEmployeeMaximumTypeEnum;
        /** @description Indicates the maximum amount of benefit the employee can elect. */
        RfpCriticalIllnessEmployeeBenefitMaximum: {
            /** @description The type of benefit maximum. */
            type: components["schemas"]["CriticalIllnessEmployeeMaximumTypeEnum"];
            /** @description The dollar amount for the maximum. Include when type is dollarAmount or percentageOfEeBenefitAndDollarAmount. */
            dollarAmount?: number;
            /** @description The percentage of employee benefit. Include when type is percentageOfEeBenefit or percentageOfEeBenefitAndDollarAmount. */
            percent?: number;
        };
        /**
         * @description Indicates the amount of Employee Benefit available without having to provide Evidence of Insurability.
         * @enum {string}
         */
        RfpCriticalIllnessEmployeeGuaranteeIssueTypeEnum: RfpCriticalIllnessEmployeeGuaranteeIssueTypeEnum;
        /** @description Indicates the amount of Employee Benefit available without having to provide Evidence of Insurability. */
        RfpCriticalIllnessEmployeeGuaranteeIssue: {
            /** @description The type of guarantee issue. */
            type: components["schemas"]["RfpCriticalIllnessEmployeeGuaranteeIssueTypeEnum"];
            /** @description The guarantee issue amount. Include when type allows amounts. */
            amount?: number;
        };
        /** @description Employee critical illness benefit configuration. */
        RfpCriticalIllnessEmployeeBenefit: {
            /** @description Describes the benefit configuration available for employee. */
            benefitDescription?: components["schemas"]["RfpCriticalIllnessEmployeeBenefitDescription"];
            /** @description Indicates the maximum amount of benefit the employee can elect. */
            benefitMaximum?: components["schemas"]["RfpCriticalIllnessEmployeeBenefitMaximum"];
            /** @description Indicates the amount of Employee Benefit available without having to provide Evidence of Insurability. */
            guaranteeIssue?: components["schemas"]["RfpCriticalIllnessEmployeeGuaranteeIssue"];
        };
        /**
         * @description Describes the benefit configuration available for spouse.
         * @enum {string}
         */
        RfpCriticalIllnessSpouseBenefitDescriptionTypeEnum: RfpCriticalIllnessSpouseBenefitDescriptionTypeEnum;
        /** @description Describes the benefit configuration available for spouse. */
        RfpCriticalIllnessSpouseBenefitDescription: {
            /** @description The type of benefit description. */
            type: components["schemas"]["RfpCriticalIllnessSpouseBenefitDescriptionTypeEnum"];
            /** @description The benefit description amounts. Include multiple items when type is multipleOptions, single item otherwise when applicable. */
            amounts?: number[];
            /** @description The minimum benefit description amount. Include when applicable. */
            minimum?: number;
        };
        /**
         * @description Indicates the maximum amount of benefit the spouse can elect.
         * @enum {string}
         */
        RfpCriticalIllnessSpouseMaximumTypeEnum: RfpCriticalIllnessSpouseMaximumTypeEnum;
        /** @description Indicates the maximum amount of benefit the spouse can elect. */
        RfpCriticalIllnessSpouseBenefitMaximum: {
            /** @description The type of benefit maximum. */
            type: components["schemas"]["RfpCriticalIllnessSpouseMaximumTypeEnum"];
            /** @description The dollar amount for the maximum. Include when type is dollarAmount or percentageOfEeBenefitAndDollarAmount. */
            dollarAmount?: number;
            /** @description The percentage of employee benefit. Include when type is percentageOfEeBenefit or percentageOfEeBenefitAndDollarAmount. */
            percent?: number;
        };
        /**
         * @description Indicates the amount of Spouse Benefit available without having to provide Evidence of Insurability.
         * @enum {string}
         */
        RfpCriticalIllnessSpouseGuaranteeIssueTypeEnum: RfpCriticalIllnessEmployeeGuaranteeIssueTypeEnum;
        /** @description Indicates the amount of Spouse Benefit available without having to provide Evidence of Insurability. */
        RfpCriticalIllnessSpouseGuaranteeIssue: {
            /** @description The type of guarantee issue. */
            type: components["schemas"]["RfpCriticalIllnessSpouseGuaranteeIssueTypeEnum"];
            /** @description The guarantee issue amount. Include when type allows amounts. */
            amount?: number;
        };
        /** @description Spouse critical illness benefit configuration. */
        RfpCriticalIllnessSpouseBenefit: {
            /** @description Describes the benefit configuration available for spouse. */
            benefitDescription?: components["schemas"]["RfpCriticalIllnessSpouseBenefitDescription"];
            /** @description Indicates the maximum amount of benefit the spouse can elect. */
            benefitMaximum?: components["schemas"]["RfpCriticalIllnessSpouseBenefitMaximum"];
            /** @description Indicates the amount of Spouse Benefit available without having to provide Evidence of Insurability. */
            guaranteeIssue?: components["schemas"]["RfpCriticalIllnessSpouseGuaranteeIssue"];
        };
        /**
         * @description Describes the benefit configuration available for child.
         * @enum {string}
         */
        RfpCriticalIllnessChildBenefitDescriptionTypeEnum: RfpCriticalIllnessEmployeeGuaranteeIssueTypeEnum;
        /** @description Describes the benefit configuration available for child. */
        RfpCriticalIllnessChildBenefitDescription: {
            /** @description The type of benefit description. */
            type: components["schemas"]["RfpCriticalIllnessChildBenefitDescriptionTypeEnum"];
            /** @description The benefit description amounts. Include multiple items when type is flatAmount, single item otherwise when applicable. */
            amounts?: number[];
            /** @description The minimum benefit description amount. Include when applicable. */
            minimum?: number;
        };
        /** @description Child critical illness benefit configuration. */
        RfpCriticalIllnessChildBenefit: {
            /** @description Describes the benefit configuration available for child. */
            benefitDescription?: components["schemas"]["RfpCriticalIllnessChildBenefitDescription"];
        };
        /** @description Indicates what carrier will cover as benefit for this service. */
        BaseIllnessCoverage: {
            /** @description The type of illness coverage. */
            type: unknown;
            /** @description The illness coverage amount. Include when type is percentage. */
            amount?: number;
        };
        /**
         * @description Indicates what carrier will cover as benefit for this service.
         * @enum {string}
         */
        RfpIllnessTypeEnum: RfpIllnessTypeEnum;
        RfpIllnessCoverage: components["schemas"]["BaseIllnessCoverage"] & {
            type?: components["schemas"]["RfpIllnessTypeEnum"];
        };
        /** @description Indicates the total amount the plan will payout to any given employee (after factoring in recurrence and second occurrence). */
        BaseMaximumPayout: {
            /** @description The type of maximum payout. */
            type: unknown;
            /** @description The maximum payout amount. Include when type allows amounts. */
            amount?: number;
        };
        /**
         * @description Indicates the total amount the plan will payout to any given employee (after factoring in recurrence and second occurrence).
         * @enum {string}
         */
        RfpMaximumPayoutTypeEnum: RfpMaximumPayoutTypeEnum;
        RfpMaximumPayout: components["schemas"]["BaseMaximumPayout"] & {
            type?: components["schemas"]["RfpMaximumPayoutTypeEnum"];
        };
        /** @description Indicates the percentage at which an additional illness (in a different category) will be covered, and the time period compared to the initial illness covered. */
        BaseOccurrenceOfDifferentIllness: {
            /** @description The type of occurrence coverage. */
            type: unknown;
            /** @description The number of months for the waiting period. Include when type is months. */
            months?: number;
        };
        /**
         * @description Indicates coverage and time period for illness occurrences.
         * @enum {string}
         */
        RfpOccurrenceTypeEnum: RfpOccurrenceTypeEnum;
        RfpOccurrenceOfDifferentIllness: components["schemas"]["BaseOccurrenceOfDifferentIllness"] & {
            type?: components["schemas"]["RfpOccurrenceTypeEnum"];
        };
        /** @description Indicates the percentage at which a repeat occurrence of the same illness will be covered, and the time period compared to the initial illness covered. */
        BaseAdditionalOccurrenceOfSameIllness: {
            /** @description The type of additional occurrence coverage. */
            type: unknown;
            /** @description The number of months for the waiting period. Include when type is months. */
            months?: number;
        };
        RfpAdditionalOccurrenceOfSameIllness: components["schemas"]["BaseAdditionalOccurrenceOfSameIllness"] & {
            type?: components["schemas"]["RfpOccurrenceTypeEnum"];
        };
        /** @description Indicates dollar amount of available reimbursement for member completing wellness initiative(s). */
        BaseWellnessBenefit: {
            /** @description The type of wellness benefit. */
            type: unknown;
            /** @description The wellness benefit amount. Include when type is dollarAmount. */
            amount?: number;
        };
        /**
         * @description Indicates dollar amount of available reimbursement for member completing wellness initiative(s).
         * @enum {string}
         */
        RfpWellnessBenefitTypeEnum: RfpVisionCopayRuleTypeEnum;
        RfpWellnessBenefit: components["schemas"]["BaseWellnessBenefit"] & {
            type?: components["schemas"]["RfpWellnessBenefitTypeEnum"];
        };
        /**
         * @description Indicates whether the available benefit(s) are based on member age at time of policy issuance, or based member attained age in conjunction with age-band rules.
         * @enum {string}
         */
        RfpAgeBasisEnum: RfpAgeBasisEnum;
        RfpCriticalIllnessBenefit: {
            objectType: components["schemas"]["CriticalIllnessObjectTypeEnum"];
            /** @description Employee benefit configuration. */
            employee?: components["schemas"]["RfpCriticalIllnessEmployeeBenefit"];
            /** @description Spouse benefit configuration. */
            spouse?: components["schemas"]["RfpCriticalIllnessSpouseBenefit"];
            /** @description Child benefit configuration. */
            child?: components["schemas"]["RfpCriticalIllnessChildBenefit"];
            /** @description Indicates what carrier will cover as benefit for invasive cancer. */
            invasiveCancer?: components["schemas"]["RfpIllnessCoverage"];
            /** @description Indicates what carrier will cover as benefit for non-invasive cancer. */
            nonInvasiveCancer?: components["schemas"]["RfpIllnessCoverage"];
            /** @description Indicates what carrier will cover as benefit for Category 1 heart attack. */
            category1HeartAttack?: components["schemas"]["RfpIllnessCoverage"];
            /** @description Indicates what carrier will cover as benefit for Category 1 stroke. */
            category1Stroke?: components["schemas"]["RfpIllnessCoverage"];
            /** @description Indicates what carrier will cover as benefit for kidney failure. */
            kidneyFailure?: components["schemas"]["RfpIllnessCoverage"];
            /** @description Indicates the total amount the plan will payout to any given employee (after factoring in recurrence and second occurrence). */
            maximumPayout?: components["schemas"]["RfpMaximumPayout"];
            /** @description Indicates the percentage at which an additional illness (in a different category) will be covered, and the time period compared to the initial illness covered. */
            occurrenceOfDifferentIllness?: components["schemas"]["RfpOccurrenceOfDifferentIllness"];
            /** @description Indicates the percentage at which a repeat occurrence of the same illness will be covered, and the time period compared to the initial illness covered. */
            additionalOccurrenceOfSameIllness?: components["schemas"]["RfpAdditionalOccurrenceOfSameIllness"];
            /** @description Details any benefit change-increments based on age. */
            ageReductionSchedule?: components["schemas"]["RfpAgeReductionSchedule"];
            /** @description Indicates the amount of months before effective date AND after effective date participant needs to be illness free to claim benefit. */
            preExistingCondition?: components["schemas"]["RfpPreExistingCondition"];
            /** @description Indicates if policy holder can continue policy after separation of employment. */
            portability?: components["schemas"]["RfpInclusionStatusEnum"];
            /** @description Indicates dollar amount of available reimbursement for member completing wellness initiative(s). */
            wellnessBenefit?: components["schemas"]["RfpWellnessBenefit"];
            /** @description Indicates if annual open enrollment is included in the plan. */
            annualOpenEnrollment?: components["schemas"]["RfpAnnualOpenEnrollmentEnum"];
            /** @description Indicates whether the available benefit(s) are based on member age at time of policy issuance, or based member attained age in conjunction with age-band rules. */
            ageBasis?: components["schemas"]["RfpAgeBasisEnum"];
        } & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            objectType: CriticalIllnessObjectTypeEnum;
        };
        /**
         * @description Indicates when the accident event may occur to be eligible for coverage.
         * @enum {string}
         */
        RfpAccidentCoverageTypeEnum: RfpAccidentCoverageTypeEnum;
        /** @description Details for an accident benefit including type and amount. */
        AccidentBenefitDetails: {
            /** @description The type of benefit offered. */
            type: unknown;
            /** @description The dollar amount for the benefit. Only include when type is dollarAmount, upToDollarAmount, or dollar. */
            amount?: number;
        };
        /**
         * @description Indicates dollar amount carrier will cover as benefit for specific services that should not include hospital admission benefits.
         * @enum {string}
         */
        RfpAccidentSpecificBenefitTypeEnum: RfpAccidentSpecificBenefitTypeEnum;
        RfpAccidentSpecificBenefitDetails: components["schemas"]["AccidentBenefitDetails"] & {
            type?: components["schemas"]["RfpAccidentSpecificBenefitTypeEnum"];
        };
        /**
         * @description Indicates dollar amount carrier will cover as benefit for this service, including any conditional requirements.
         * @enum {string}
         */
        RfpAccidentBenefitTypeEnum: RfpAccidentBenefitTypeEnum;
        RfpAccidentBenefitDetails: components["schemas"]["AccidentBenefitDetails"] & {
            type?: components["schemas"]["RfpAccidentBenefitTypeEnum"];
        };
        /**
         * @description Maximum benefit type for accident coverage.
         * @enum {string}
         */
        RfpAccidentMaxBenefitTypeEnum: RfpAccidentMaxBenefitTypeEnum;
        RfpAccidentMaxBenefitDetails: components["schemas"]["AccidentBenefitDetails"] & {
            type?: components["schemas"]["RfpAccidentMaxBenefitTypeEnum"];
        };
        /** @description Details for a benefit amount including type and amount. */
        BenefitAmountDetails: {
            /** @description The type of benefit offered. */
            type: unknown;
            /** @description The dollar amount for the benefit. Only include when type is dollarAmount. */
            amount?: number;
        };
        /**
         * @description Indicates dollar amount carrier will cover as benefit for this service, including any conditional requirements.
         * @enum {string}
         */
        RfpBenefitTypeEnum: RfpVisionCopayRuleTypeEnum;
        RfpBenefitAmountDetails: components["schemas"]["BenefitAmountDetails"] & {
            type?: components["schemas"]["RfpBenefitTypeEnum"];
        };
        RfpAccidentBenefit: {
            /** @enum {string} */
            objectType: RfpAccidentBenefitObjectType;
            /** @description Indicates when the accident event may occur to be eligible for coverage (hours covered). */
            coverageType?: components["schemas"]["RfpAccidentCoverageTypeEnum"];
            /** @description Indicates dollar amount carrier will cover as benefit for this service, including any conditional requirements. */
            hospitalAdmission?: components["schemas"]["RfpAccidentSpecificBenefitDetails"];
            /** @description Indicates dollar amount carrier will cover as benefit for this service, including any conditional requirements. */
            icuAdmission?: components["schemas"]["RfpAccidentBenefitDetails"];
            /** @description Indicates dollar amount carrier will cover as benefit for this service, including any conditional requirements. */
            dailyHospitalConfinement?: components["schemas"]["RfpAccidentSpecificBenefitDetails"];
            /** @description Indicates dollar amount carrier will cover as benefit for this service, including any conditional requirements. */
            dailyIcuConfinement?: components["schemas"]["RfpAccidentBenefitDetails"];
            /** @description Indicates dollar amount carrier will cover as benefit for this service, including any conditional requirements. */
            ambulanceAir?: components["schemas"]["RfpAccidentSpecificBenefitDetails"];
            /** @description Indicates dollar amount carrier will cover as benefit for this service, including any conditional requirements. */
            ambulanceGround?: components["schemas"]["RfpAccidentSpecificBenefitDetails"];
            /** @description Indicates dollar amount carrier will cover as benefit for this service, including any conditional requirements. */
            emergencyTreatment?: components["schemas"]["RfpAccidentSpecificBenefitDetails"];
            /** @description Indicates dollar amount carrier will cover as benefit for this service, including any conditional requirements. */
            urgentCare?: components["schemas"]["RfpAccidentSpecificBenefitDetails"];
            /** @description Indicates dollar amount carrier will cover as benefit for this service, including any conditional requirements. */
            initialPhysicianOfficeVisit?: components["schemas"]["RfpAccidentSpecificBenefitDetails"];
            /** @description Max benefit amount for dislocations. */
            dislocationsMaximum?: components["schemas"]["RfpAccidentMaxBenefitDetails"];
            /** @description Max benefit amount for fractures. */
            fracturesMaximum?: components["schemas"]["RfpAccidentMaxBenefitDetails"];
            /** @description Indicates the maximum benefit amount available for lacerations. */
            lacerationsMaximum?: components["schemas"]["RfpAccidentMaxBenefitDetails"];
            /** @description Indicates the benefit amount available for a coma. */
            coma?: components["schemas"]["RfpAccidentMaxBenefitDetails"];
            /** @description Indicates the benefit amount available for a x-ray. */
            majorDiagnosticExamXray?: components["schemas"]["RfpAccidentMaxBenefitDetails"];
            /** @description Indicates the benefit amount available for a MRI. */
            majorDiagnosticExamMri?: components["schemas"]["RfpAccidentMaxBenefitDetails"];
            /** @description Indicates dollar amount of available reimbursement for member completing wellness initiative(s). */
            wellnessBenefit?: components["schemas"]["RfpBenefitAmountDetails"];
            /** @description Indicates if child organized sports enhancement is included. */
            childOrganizedSportsEnhancement?: components["schemas"]["RfpInclusionStatusEnum"];
            /** @description Indicates if policy holder can continue policy after separation of employment. */
            portability?: components["schemas"]["RfpInclusionStatusEnum"];
            /** @description Indicates the age and associated percentage of benefit reduction. */
            ageReductionSchedule?: components["schemas"]["RfpAgeReductionSchedule"];
            annualOpenEnrollment?: components["schemas"]["RfpAnnualOpenEnrollmentEnum"];
        } & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            objectType: RfpAccidentBenefitObjectType;
        };
        RfpHospitalIndemnityBenefit: {
            /** @enum {string} */
            objectType: RfpHospitalIndemnityBenefitObjectType;
            /** @description Indicates dollar amount carrier will cover as benefit for this service, including any conditional requirements. */
            hospitalAdmission?: components["schemas"]["RfpBenefitAmountDetails"];
            /** @description Indicates dollar amount carrier will cover as benefit for this service, including any conditional requirements. */
            icuAdmission?: components["schemas"]["RfpBenefitAmountDetails"];
            /** @description Indicates dollar amount carrier will cover as benefit for this service, including any conditional requirements. */
            hospitalConfinement?: components["schemas"]["RfpBenefitAmountDetails"];
            /** @description Indicates dollar amount carrier will cover as benefit for this service, including any conditional requirements. */
            icuConfinement?: components["schemas"]["RfpBenefitAmountDetails"];
            /** @description Indicates the amount of months before effective date AND after effective date participant needs to be illness free to claim benefit. */
            preExistingCondition?: components["schemas"]["RfpPreExistingCondition"];
            /** @description Indicates if policy holder can continue policy after separation of employment. */
            portability?: components["schemas"]["RfpInclusionStatusEnum"];
            /** @description Indicates dollar amount of available reimbursement for member completing wellness initiative(s). */
            wellness?: components["schemas"]["RfpBenefitAmountDetails"];
            /** @description Indicates if annual open enrollment is included in the plan. */
            annualOpenEnrollment?: components["schemas"]["RfpAnnualOpenEnrollmentEnum"];
        } & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            objectType: RfpHospitalIndemnityBenefitObjectType;
        };
        /**
         * @description The object type for cancer benefits.
         * @enum {string}
         */
        CancerObjectTypeEnum: CancerObjectTypeEnum;
        /**
         * @description Indicates the unit of time for the waiting period.
         * @enum {string}
         */
        CancerInitialDiagnosisWaitingPeriodTypeEnum: CancerInitialDiagnosisWaitingPeriodTypeEnum;
        BaseCancerBenefit: {
            objectType: components["schemas"]["CancerObjectTypeEnum"];
            /** @description The time a member must wait in order to receive benefits, after receiving a cancer diagnosis. */
            initialDiagnosisWaitingPeriod?: {
                type?: components["schemas"]["CancerInitialDiagnosisWaitingPeriodTypeEnum"];
                /** @description The duration of the waiting period. */
                duration?: number;
            };
        };
        /**
         * @description Indicates the type of benefit available for RFP.
         * @enum {string}
         */
        RfpCancerAmountBenefitTypeEnum: RfpVisionCopayRuleTypeEnum;
        RfpCancerAmountBenefit: {
            type: components["schemas"]["RfpCancerAmountBenefitTypeEnum"];
            /** @description The dollar amount of the benefit. Omit if type is not dollarAmount. */
            amount?: number;
        };
        /**
         * @description Indicates the type of hospice benefit available for RFP.
         * @enum {string}
         */
        RfpCancerHospiceBenefitTypeEnum: RfpCancerHospiceBenefitTypeEnum;
        RfpCancerHospiceBenefit: {
            type: components["schemas"]["RfpCancerHospiceBenefitTypeEnum"];
            /** @description The dollar amount of the hospice benefit. Omit if type is not dollarAmount or dollarAmountPerDayPerLifetime. */
            amount?: number;
            /** @description The limit of days per lifetime that this benefit is available. 0 is unlimited. */
            duration?: number;
        };
        /**
         * @description Indicates the type of schedule benefit available for RFP.
         * @enum {string}
         */
        RfpCancerScheduleBenefitTypeEnum: RfpCancerScheduleBenefitTypeEnum;
        RfpCancerScheduleBenefit: {
            type: components["schemas"]["RfpCancerScheduleBenefitTypeEnum"];
            /** @description The dollar amount of the schedule benefit. Omit if type is not scheduleUpToDollarAmount. */
            amount?: number;
        };
        RfpCancerBenefit: components["schemas"]["BaseCancerBenefit"] & {
            /** @description The dollar benefit available when a cancer diagnosis is made. */
            diagnosisBenefit?: components["schemas"]["RfpCancerAmountBenefit"];
            /** @description The benefit available for radiation/chemo. This can be a schedule or a flat dollar amount. This field will show the maximum available. */
            radiationTherapyChemo?: components["schemas"]["RfpCancerAmountBenefit"];
            /** @description The benefit available for services related to blood/plasma/platelets. */
            bloodPlasmaPlatelets?: components["schemas"]["RfpCancerAmountBenefit"];
            /** @description The daily amount available when on hospice.  Also the limit of days per lifetime that this benefit is available. */
            hospice?: components["schemas"]["RfpCancerHospiceBenefit"];
            /** @description Indicates dollar amount carrier will cover as benefit for this service, including any conditional requirements. */
            hospitalConfinementInitial?: components["schemas"]["RfpCancerAmountBenefit"];
            /** @description Indicates dollar amount carrier will cover as benefit for this service, including any conditional requirements. */
            icuConfinementInitial?: components["schemas"]["RfpCancerAmountBenefit"];
            /** @description The benefit for skin cancer treatment. */
            skinCancer?: components["schemas"]["RfpCancerScheduleBenefit"];
            /** @description The benefit for surgical procedures. */
            surgicalBenefit?: components["schemas"]["RfpCancerScheduleBenefit"];
            preExistingCondition?: components["schemas"]["RfpPreExistingCondition"];
            portability?: components["schemas"]["RfpInclusionStatusEnum"];
            /** @description The wellness benefit available. */
            wellnessBenefit?: components["schemas"]["RfpCancerAmountBenefit"];
            waiverOfPremium?: components["schemas"]["RfpInclusionStatusEnum"];
            annualOpenEnrollment?: components["schemas"]["RfpAnnualOpenEnrollmentEnum"];
        } & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            objectType: CancerObjectTypeEnum;
        };
        /**
         * @description Object type identifier for FML benefits.
         * @enum {string}
         */
        FmlObjectTypeEnum: FmlObjectTypeEnum;
        BaseFmlBenefit: {
            objectType: components["schemas"]["FmlObjectTypeEnum"];
            /** @description Indicates if history and takeover is included in the new policy or if it will be clean slate takeover. */
            historyAndTakeover?: string;
            /** @description Indicates if additional company leaves can be supported. */
            companyLeaves?: string;
            /** @description Indicates how the carrier communicates with employees. */
            correspondence?: string;
        };
        /**
         * @description The type of coverage for RFP.
         * @enum {string}
         */
        RfpFmlBenefitTypeEnum: RfpFmlBenefitTypeEnum;
        RfpFlmBenefitType: {
            /** @description The type of coverage. */
            type: components["schemas"]["RfpFmlBenefitTypeEnum"];
            /** @description The dollar amount if type is additionalDollarAmount. Omit otherwise. */
            amount?: number;
        };
        /**
         * @description Confirms if the plan is integrated with disability for RFP.
         * @enum {string}
         */
        RfpIntegratedStdFmlaClaimIntakeEnum: RfpInclusionStatusEnum;
        RfpFmlBenefit: components["schemas"]["BaseFmlBenefit"] & {
            /** @description Indicates if federal leaves are included in the provided plan. */
            federalFmla?: components["schemas"]["RfpFlmBenefitType"];
            /** @description Indicates if additional unpaid state leaves are included in the provided plan. */
            unpaidStateLeaves?: components["schemas"]["RfpFlmBenefitType"];
            /** @description Indicates if military leaves are included in the provided plan. */
            militaryUserra?: components["schemas"]["RfpFlmBenefitType"];
            /** @description Indicates if jury duty is included in the provided plan. */
            juryDuty?: components["schemas"]["RfpFlmBenefitType"];
            /** @description Indicates if ADA is included in the base price or for additional charge. */
            ada?: components["schemas"]["RfpFlmBenefitType"];
            /** @description Confirms if the plan is integrated with disability. */
            integratedStdFmlaClaimIntake?: components["schemas"]["RfpIntegratedStdFmlaClaimIntakeEnum"];
        } & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            objectType: FmlObjectTypeEnum;
        };
        /**
         * @description The object type for EAP benefits.
         * @enum {string}
         */
        EapObjectTypeEnum: EapObjectTypeEnum;
        BaseEapBenefit: {
            objectType: components["schemas"]["EapObjectTypeEnum"];
            /** @description Indicates the number of face to face visits covered. */
            faceToFaceVisits?: number;
            /** @description Indicates the frequency at which the face to face visits are provided. */
            perOccurrencePerYear?: string;
            /** @description Indicates if legal and financial resources are part of the EAP plan. */
            legalFinancialResources?: string;
            employerContribution?: components["schemas"]["EmployerContributionEnum"];
        };
        /**
         * @description Indicates which product the EAP is tied to for RFP.
         * @enum {string}
         */
        RfpTiedToAnotherLocEnum: RfpTiedToAnotherLocEnum;
        RfpEapBenefit: components["schemas"]["BaseEapBenefit"] & {
            /** @description Indicates if telephonic visits are unlimited or not. */
            unlimitedTelephonic?: components["schemas"]["RfpInclusionStatusEnum"];
            /** @description Indicates which, if any product the EAP is tied to. */
            tiedToAnotherLoc?: components["schemas"]["RfpTiedToAnotherLocEnum"];
        } & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            objectType: EapObjectTypeEnum;
        };
        /**
         * @description The object type for individual disability benefits.
         * @enum {string}
         */
        IndividualDisabilityObjectTypeEnum: IndividualDisabilityObjectTypeEnum;
        BaseIndividualDisabilityBenefit: {
            objectType: components["schemas"]["IndividualDisabilityObjectTypeEnum"];
            benefitDuration?: components["schemas"]["BenefitDuration"];
            definitionOfDisability?: components["schemas"]["DefinitionOfDisabilityTypeEnum"];
            employerContribution?: components["schemas"]["EmployerContributionEnum"];
        };
        /**
         * @description Describes the LTD plan design type for RFP.
         * @enum {string}
         */
        RfpLtdPlanDesignTypeEnum: RfpLtdPlanDesignTypeEnum;
        /**
         * @description Describes the IDI plan design type for RFP.
         * @enum {string}
         */
        RfpIdiPlanDesignTypeEnum: RfpIdiPlanDesignTypeEnum;
        /**
         * @description The type of own occupation period for RFP.
         * @enum {string}
         */
        RfpIndividualDisabilityOwnOccupationPeriodTypeEnum: RfpLtdOwnOccupationPeriodTypeEnum;
        /**
         * @description The mental illness benefit type for RFP.
         * @enum {string}
         */
        RfpIndividualDisabilityMentalIllnessBenefitTypeEnum: RfpLtdOtherLimitationsEnum;
        /**
         * @description Indicates if a recovery benefit is included in the IDI offering for RFP.
         * @enum {string}
         */
        RfpRecoveryBenefitEnum: RfpRecoveryBenefitEnum;
        /**
         * @description Indicates the benefit allowed for a catastrophic benefit for RFP.
         * @enum {string}
         */
        RfpCatastrophicBenefitEnum: RfpCatastrophicBenefitEnum;
        /**
         * @description Indicates if policy holder can continue policy after separation of employment for RFP.
         * @enum {string}
         */
        RfpIndividualDisabilityPortabilityEnum: RfpInclusionStatusEnum;
        RfpIndividualDisabilityBenefit: components["schemas"]["BaseIndividualDisabilityBenefit"] & {
            preExistingCondition?: components["schemas"]["RfpPreExistingCondition"];
            /** @description Indicates the benefit amount and benefit maximum of the existing LTD plan design. */
            ltdPlanDesign?: {
                type: components["schemas"]["RfpLtdPlanDesignTypeEnum"];
                /** @description The percentage amount. Omit if not percentageToDollarAmount. */
                percent?: number;
                /** @description The dollar amount. Omit if not percentageToDollarAmount. */
                dollarAmount?: number;
            };
            /** @description Indicates the plan design offered with the extra IDI coverage. */
            idiPlanDesign?: {
                type: components["schemas"]["RfpIdiPlanDesignTypeEnum"];
                /** @description The percentage amount. Omit if not percentage or percentageToDollarAmount. */
                percent?: number;
                /** @description The dollar amount. Omit if not percentageToDollarAmount. */
                dollarAmount?: number;
            };
            /** @description Indicates the maximum dollar amount of benefit allowed. */
            gsiBenefitMaximum?: number;
            /** @description Indicates the own occupation period. */
            ownOccupationPeriod?: {
                type: components["schemas"]["RfpIndividualDisabilityOwnOccupationPeriodTypeEnum"];
                /** @description The amount of time for own occupation period. Omit if not applicable. */
                amount?: number;
            };
            /** @description Indicates the period of time after participant becomes disabled that must pass before they begin receiving benefit. */
            eliminationPeriodDays?: number;
            /** @description Indicates the time period limitation of benefit duration for mental illness. */
            mentalIllnessBenefit?: {
                type: components["schemas"]["RfpIndividualDisabilityMentalIllnessBenefitTypeEnum"];
                /** @description The mental illness timeframe. Omit if not applicable. */
                timeframe?: number;
            };
            /** @description Indicates if a recovery benefit is included in the IDI offering. */
            recoveryBenefit?: {
                type: components["schemas"]["RfpRecoveryBenefitEnum"];
                /** @description The dollar amount for the recovery benefit. Omit if type is not dollarAmount. */
                amount?: number;
            };
            /** @description Indicates the benefit allowed for a catastrophic benefit. */
            catastrophicBenefit?: {
                type: components["schemas"]["RfpCatastrophicBenefitEnum"];
                /** @description The percentage amount for the catastrophic benefit. Omit if type is not percentageAmount. */
                amount?: number;
            };
            /** @description Indicates if policy holder can continue policy after separation of employment and whether Evidence of Insurability would be required. */
            portability?: components["schemas"]["RfpIndividualDisabilityPortabilityEnum"];
        } & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            objectType: IndividualDisabilityObjectTypeEnum;
        };
        /**
         * @description The object type for whole life benefits.
         * @enum {string}
         */
        WholeLifeObjectTypeEnum: WholeLifeObjectTypeEnum;
        /**
         * @description Indicates the type of coverage provided by the whole life plan.
         * @enum {string}
         */
        WholeLifeCoverageTypeEnum: WholeLifeCoverageTypeEnum;
        /**
         * @description Describes the benefit configuration available.
         * @enum {string}
         */
        WholeLifeEmployeeBenefitAmountTypeEnum: RfpVoluntaryLifeEmployeeBenefitTypeEnum;
        /**
         * @description Indicates the maximum amount of benefit that can be elected.
         * @enum {string}
         */
        WholeLifeEmployeeBenefitMaximumTypeEnum: WholeLifeEmployeeBenefitMaximumTypeEnum;
        BaseWholeLifeBenefit: {
            objectType: components["schemas"]["WholeLifeObjectTypeEnum"];
            coverageType?: components["schemas"]["WholeLifeCoverageTypeEnum"];
            /** @description The benefit schedule and maximum allowed by the plan. */
            employeeBenefitAmount?: {
                type: components["schemas"]["WholeLifeEmployeeBenefitAmountTypeEnum"];
                /** @description The dollar amounts for the benefit. Should contain only one item unless type is multipleOptions. Omit if notIncluded. */
                amount: number[];
            };
            /** @description Indicates the maximum amount of benefit the employee can elect. */
            employeeBenefitMaximum?: {
                type: components["schemas"]["WholeLifeEmployeeBenefitMaximumTypeEnum"];
                /** @description The maximum benefit dollar amount. Used when type is dollarAmount or lesserOfDollarAmountOrSalaryMultiplier. Omit otherwise. */
                dollarAmount?: number;
                /** @description The maximum benefit salary multiplier. Used when type is salaryMultiplier or lesserOfDollarAmountOrSalaryMultiplier. Omit otherwise. */
                salaryMultiplier?: number;
            };
            /** @description The amount of whole life guarantee issue amount. */
            guaranteeIssueAmount?: number;
            /** @description Indicates what riders may be available on the plan - example waiver of premium, AD&D, Accelerated Benefit etc. */
            ridersIncluded?: string;
            /** @description Indicates any plan specific provisions that could be available. */
            additionalOptionsIncluded?: string;
            /**
             * Format: decimal
             * @description Indicates the interest rate applied to the plan - this plan is 'in the market' so it is the rate of growth.
             */
            interestRate?: number;
            /** @description The age at which the policy endows. */
            endowsAge?: number;
        };
        /**
         * @description Describes the dependent benefit configuration available for RFP.
         * @enum {string}
         */
        RfpDependentBenefitTypeEnum: RfpVisionCopayRuleTypeEnum;
        /** @description Indicates the amount of benefit available for a dependent. */
        RfpDependentBenefit: {
            type: components["schemas"]["RfpDependentBenefitTypeEnum"];
            /** @description The dependent benefit dollar amount. Omit if type is notIncluded. */
            amount?: number;
        };
        /**
         * @description Indicates when the plan will be initiated for RFP.
         * @enum {string}
         */
        RfpWholeLifeCoverageEffectiveDateEnum: RfpWholeLifeCoverageEffectiveDateEnum;
        RfpWholeLifeBenefit: components["schemas"]["BaseWholeLifeBenefit"] & {
            spouseBenefitAmount?: components["schemas"]["RfpDependentBenefit"];
            spouseBenefitMaximum?: components["schemas"]["RfpDependentBenefit"];
            childBenefitAmount?: components["schemas"]["RfpDependentBenefit"];
            childBenefitMaximum?: components["schemas"]["RfpDependentBenefit"];
            portability?: components["schemas"]["RfpInclusionStatusEnum"];
            /** @description Indicates when the plan will be initiated. */
            coverageEffectiveDate?: components["schemas"]["RfpWholeLifeCoverageEffectiveDateEnum"];
            annualOpenEnrollment?: components["schemas"]["RfpAnnualOpenEnrollmentEnum"];
        } & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            objectType: WholeLifeObjectTypeEnum;
        };
        RfpBenefitPlan: components["schemas"]["BaseBenefitPlan"] & {
            /** @description This field tells us if the requested plan design matches the in-force plan (current) or if it is an alternate plan design (alternate). For a virgin line of coverage, use newBusiness. */
            policyPeriod: components["schemas"]["PolicyPeriodEnum"];
            /** @description This is the incumbent carrier name on the in-force coverage. */
            currentCarrierName?: components["schemas"]["name"];
            benefits: components["schemas"]["RfpDentalBenefit"] | components["schemas"]["RfpVisionBenefit"] | components["schemas"]["RfpBasicLifeAdndBenefit"] | components["schemas"]["RfpVoluntaryLifeAdndBenefit"] | components["schemas"]["RfpStdBenefit"] | components["schemas"]["RfpLtdBenefit"] | components["schemas"]["RfpCriticalIllnessBenefit"] | components["schemas"]["RfpAccidentBenefit"] | components["schemas"]["RfpHospitalIndemnityBenefit"] | components["schemas"]["RfpCancerBenefit"] | components["schemas"]["RfpFmlBenefit"] | components["schemas"]["RfpEapBenefit"] | components["schemas"]["RfpIndividualDisabilityBenefit"] | components["schemas"]["RfpWholeLifeBenefit"];
        };
        PostRfpCoverage: components["schemas"]["BaseCoverage"] & {
            /** @description Indicates the status of the coverage for quoting. For RFP creation, only quoteNeeded is allowed. */
            status: components["schemas"]["PostRfpCoverageStatusEnum"];
            benefitPlans: components["schemas"]["RfpBenefitPlan"][];
        };
        /** @description Schema for creating a new Group RFP (POST operation). This excludes the carrierIssuedIdentifier which is generated by the carrier. */
        PostGroupRfp: components["schemas"]["BaseGroupRfp"] & {
            /** @description The line of coverage definitions for the group for RFP creation. There must only be one record for each coverage type. For example, there should be only one Dental coverage, one Vision coverage etc. Multiple options and other variations are expressed at the benefitPlan level. */
            coverages: components["schemas"]["PostRfpCoverage"][];
        };
        /**
         * @description Indicates if a new quote is needed for the line of coverage.
         * @enum {string}
         */
        PutRfpCoverageStatusEnum: PutRfpCoverageStatusEnum;
        PutRfpCoverage: components["schemas"]["BaseCoverage"] & {
            /** @description Indicates if a new quote is needed for the line of coverage. */
            status: components["schemas"]["PutRfpCoverageStatusEnum"];
            benefitPlans: components["schemas"]["RfpBenefitPlan"][];
        };
        /** @description Complete Group RFP schema including carrier-generated identifier. */
        GroupRfp: {
            /** @description This is the unique identifier generated by the carrier for the RFP and cannot be modified after creation. This is mandatory because when quotes are sent back, the carrierIssuedIdentifier is used to correlate the quotes with the RFP. */
            carrierIssuedIdentifier?: string;
        } & components["schemas"]["BaseGroupRfp"] & {
            /** @description The line of coverage definitions for the group for RFP updates. There must only be one record for each coverage type. For example, there should be only one Dental coverage, one Vision coverage etc. Multiple options and other variations are expressed at the benefitPlan level. */
            coverages: components["schemas"]["PutRfpCoverage"][];
        };
        Error: {
            /** @description A short, human-readable summary of the problem */
            title: string;
            /** @description A human-readable explanation specific to this occurrence of the problem */
            detail: string;
        };
        ValidationErrorDetail: {
            /** @description A human-readable explanation of the validation error */
            detail: string;
            /** @description A JSON Pointer to the associated entity in the request document. For example, "#/employer/name" refers to the "name" attribute in the "employer" object. */
            pointer: string;
        };
        ValidationError: {
            /** @description A short, human-readable summary of the validation problem */
            title: string;
            /** @description An array of validation errors */
            errors: components["schemas"]["ValidationErrorDetail"][];
        };
        /**
         * @description Indicates if the coverage was quoted or declined.
         * @enum {string}
         */
        ProposalCoverageStatusEnum: ProposalCoverageStatusEnum;
        /**
         * @description Indicates the reason for declining a quote or coverage.
         * @enum {string}
         */
        DeclineReasonEnum: DeclineReasonEnum;
        /**
         * @description The time unit for how long rates are guaranteed to stay the same.
         * @enum {string}
         */
        RateGuaranteeTypeEnum: RateGuaranteeTypeEnum;
        /**
         * @description Indicates the inclusion status of a benefit or feature.
         * @enum {string}
         */
        QuoteInclusionStatusEnum: QuoteInclusionStatusEnum;
        /**
         * @description The type of annual open enrollment for the plan.
         * @enum {string}
         */
        QuoteAnnualOpenEnrollmentEnum: QuoteAnnualOpenEnrollmentEnum;
        /**
         * @description Indicates the type of dollar amount for Quote.
         * @enum {string}
         */
        QuoteDollarBenefitTypeEnum: QuoteDollarBenefitTypeEnum;
        QuoteDollarBenefit: {
            amount?: components["schemas"]["DollarAmount"];
            type: components["schemas"]["QuoteDollarBenefitTypeEnum"];
        };
        /**
         * @description Indicates the type of percentage amount for Quote.
         * @enum {string}
         */
        QuotePercentageBenefitTypeEnum: QuotePercentageBenefitTypeEnum;
        QuotePercentageBenefit: {
            amount?: components["schemas"]["PercentageAmount"];
            type: components["schemas"]["QuotePercentageBenefitTypeEnum"];
        };
        /**
         * @description This is a list of categories for dental services for Quote.
         * @enum {string}
         */
        QuoteDentalServiceCategoryEnum: QuoteDentalServiceCategoryEnum;
        /**
         * @description The type of ortho age limit for Quote.
         * @enum {string}
         */
        QuoteOrthoAgeLimitTypeEnum: QuoteOrthoAgeLimitTypeEnum;
        QuoteOrthoAgeLimit: components["schemas"]["BaseOrthoAgeLimit"] & {
            type?: components["schemas"]["QuoteOrthoAgeLimitTypeEnum"];
        };
        QuoteDentalNetworkBenefit: components["schemas"]["BaseDentalNetworkBenefit"] & {
            /** @description Dollar amount of the deductible for family. */
            familyDeductible: components["schemas"]["QuoteDollarBenefit"];
            /** @description The maximum dollar amount carrier will pay annually toward all services. */
            annualMaximum: components["schemas"]["QuoteDollarBenefit"];
            /** @description The % of cost the carrier will cover for this service category. */
            preventativeType1: components["schemas"]["QuotePercentageBenefit"];
            /** @description The % of cost the carrier will cover for this service category. */
            basicType2: components["schemas"]["QuotePercentageBenefit"];
            /** @description The % of cost the carrier will cover for this service category. */
            majorType3: components["schemas"]["QuotePercentageBenefit"];
            /** @description The % of cost the carrier will cover for this service category. */
            orthoType4: components["schemas"]["QuotePercentageBenefit"];
            /** @description The maximum dollar amount carrier will pay for this service. */
            orthoMaximum: components["schemas"]["QuoteDollarBenefit"];
            /** @description Indicates the category in which the service is covered. */
            endodontics: components["schemas"]["QuoteDentalServiceCategoryEnum"];
            /** @description Indicates the category in which the service is covered. */
            periodonticsNonSurgical: components["schemas"]["QuoteDentalServiceCategoryEnum"];
            /** @description Indicates the category in which the service is covered. */
            periodonticsSurgical: components["schemas"]["QuoteDentalServiceCategoryEnum"];
            /** @description Indicates the category in which the service is covered. */
            oralSurgerySimple: components["schemas"]["QuoteDentalServiceCategoryEnum"];
            /** @description Indicates the category in which the service is covered. */
            oralSurgeryComplex: components["schemas"]["QuoteDentalServiceCategoryEnum"];
            /** @description Indicates the category in which the service is covered. */
            implants: components["schemas"]["QuoteDentalServiceCategoryEnum"];
            /** @description Indicates the category in which the service is covered. */
            sealants: components["schemas"]["QuoteDentalServiceCategoryEnum"];
            /** @description Indicates the category in which the service is covered. */
            spaceMaintainers: components["schemas"]["QuoteDentalServiceCategoryEnum"];
            /** @description Indicates the category in which the service is covered. */
            generalAnesthesia: components["schemas"]["QuoteDentalServiceCategoryEnum"];
            /** @description Indicates the category in which the service is covered. */
            compositeWhiteFillings: components["schemas"]["QuoteDentalServiceCategoryEnum"];
            /** @description The limiting age for a child to receive ortho coverage. */
            orthoAgeLimit: components["schemas"]["QuoteOrthoAgeLimit"];
        };
        /**
         * @description This is the list of deductible time periods.
         * @enum {string}
         */
        QuoteDeductibleDurationEnum: QuoteDeductibleDurationEnum;
        /**
         * @description This is the list values expected for Out of Network Reimbursement for Quote.
         * @enum {string}
         */
        QuoteOutOfNetworkReimbursementEnum: QuoteOutOfNetworkReimbursementEnum;
        QuoteDentalBenefit: components["schemas"]["BaseDentalBenefit"] & {
            /** @description Indicates if a carrier will allow any portion of unused annual maximum to rollover to the next plan year. */
            maximumRollover: components["schemas"]["QuoteInclusionStatusEnum"];
            /** @description The provider has a clause that missing tooth is not covered for prior instance. So, if it is 'included', the carrier would not cover any lost teeth prior to effective date. */
            missingToothExclusion: components["schemas"]["QuoteInclusionStatusEnum"];
            /** @description Indicates if annual open enrollment is included in the plan. */
            annualOpenEnrollment: components["schemas"]["QuoteAnnualOpenEnrollmentEnum"];
            /** @description This is an array of in and out of network benefits. In most cases, it should only have two items - one with `network` set to `inNetwork` and one set to `outOfNetwork`. */
            networkBenefits: components["schemas"]["QuoteDentalNetworkBenefit"][];
            /** @description Indicates the period of time that the deductible applies. */
            deductibleDuration: components["schemas"]["QuoteDeductibleDurationEnum"];
            /** @description Indicates whether the deductible will be waived for preventative services. */
            isDeductibleWaivedPreventative: components["schemas"]["QuoteInclusionStatusEnum"];
            /** @description The amount carrier will reimburse for an out of network claim. */
            outOfNetworkReimbursement: components["schemas"]["QuoteOutOfNetworkReimbursementEnum"];
        } & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            objectType: DentalObjectTypeEnum;
        };
        /**
         * @description The type of copay rule that applies for Quote.
         * @enum {string}
         */
        QuoteVisionCopayRuleTypeEnum: QuoteVisionCopayRuleTypeEnum;
        QuoteVisionCopayRule: {
            type: components["schemas"]["QuoteVisionCopayRuleTypeEnum"];
        } & components["schemas"]["VisionCopayRule"];
        /**
         * @description The type of copay rule that applies to network benefits for Quote.
         * @enum {string}
         */
        QuoteVisionCopayFullAllowanceRuleTypeEnum: QuoteVisionCopayFullAllowanceRuleTypeEnum;
        /** @description The copay amount in dollars. */
        copayAmount: number;
        /** @description The allowance amount in dollars. */
        allowanceAmount: number;
        QuoteVisionCopayFullAllowanceRule: {
            type: components["schemas"]["QuoteVisionCopayFullAllowanceRuleTypeEnum"];
            copayAmount?: components["schemas"]["copayAmount"];
            allowanceAmount?: components["schemas"]["allowanceAmount"];
        };
        /**
         * @description The type of copay rule for progressive lenses and contact lens exams for Quote.
         * @enum {string}
         */
        QuoteVisionCopayAllowanceRuleTypeEnum: QuoteVisionCopayAllowanceRuleTypeEnum;
        QuoteVisionCopayAllowanceRule: {
            type: components["schemas"]["QuoteVisionCopayAllowanceRuleTypeEnum"];
            copayAmount?: components["schemas"]["copayAmount"];
            allowanceAmount?: components["schemas"]["allowanceAmount"];
        };
        /**
         * @description The type of copay rule for specific vision services for Quote.
         * @enum {string}
         */
        QuoteVisionSpecialCopayAllowanceRuleTypeEnum: QuoteVisionSpecialCopayAllowanceRuleTypeEnum;
        QuoteVisionSpecialCopayAllowanceRule: {
            type: components["schemas"]["QuoteVisionSpecialCopayAllowanceRuleTypeEnum"];
            copayAmount?: components["schemas"]["copayAmount"];
            allowanceAmount?: components["schemas"]["allowanceAmount"];
        };
        /**
         * @description The type of frames discount that applies for Quote.
         * @enum {string}
         */
        QuoteFramesDiscountsRuleTypeEnum: QuoteFramesDiscountsRuleTypeEnum;
        QuoteFramesDiscountsRule: {
            type: components["schemas"]["QuoteFramesDiscountsRuleTypeEnum"];
        } & components["schemas"]["BaseFramesDiscountsRule"];
        QuoteVisionNetworkBenefit: {
            /** @description Type of Network pertinent to benefits following. */
            network?: components["schemas"]["InNetworkOnlyEnum"];
        } & components["schemas"]["BaseVisionNetworkBenefit"] & {
            /** @description The copay rule for vision exams. */
            examCopay: components["schemas"]["QuoteVisionCopayRule"];
            /** @description The copay rule for vision materials. */
            materialsCopay: components["schemas"]["QuoteVisionCopayRule"];
            singleLenses: components["schemas"]["QuoteVisionCopayFullAllowanceRule"];
            bifocalLenses: components["schemas"]["QuoteVisionCopayFullAllowanceRule"];
            trifocalLenses: components["schemas"]["QuoteVisionCopayFullAllowanceRule"];
            lenticularLenses: components["schemas"]["QuoteVisionCopayFullAllowanceRule"];
            standardProgressive: components["schemas"]["QuoteVisionCopayAllowanceRule"];
            standardFrames: components["schemas"]["QuoteVisionSpecialCopayAllowanceRule"];
            /** @description Additional discounts available on frames beyond standard coverage. */
            additionalDiscountsOnFrames: components["schemas"]["QuoteFramesDiscountsRule"];
            contactLensElective: components["schemas"]["QuoteVisionSpecialCopayAllowanceRule"];
            contactLensExam: components["schemas"]["QuoteVisionCopayAllowanceRule"];
        };
        /**
         * @description The frequency at which vision benefits can be used.
         * @enum {string}
         */
        QuoteVisionBenefitFrequencyOptionEnum: QuoteVisionBenefitFrequencyOptionEnum;
        QuoteVisionBenefit: {
            objectType: components["schemas"]["VisionObjectTypeEnum"];
            /** @description This is an array of in and out of network benefits. In most cases, it should only have two items - one with `network` set to `inNetwork` and one set to `outOfNetwork`. */
            networkBenefits: components["schemas"]["QuoteVisionNetworkBenefit"][];
            examFrequency: components["schemas"]["QuoteVisionBenefitFrequencyOptionEnum"];
            lensesFrequency: components["schemas"]["QuoteVisionBenefitFrequencyOptionEnum"];
            framesFrequency: components["schemas"]["QuoteVisionBenefitFrequencyOptionEnum"];
            annualOpenEnrollment: components["schemas"]["QuoteAnnualOpenEnrollmentEnum"];
            employerContribution: components["schemas"]["EmployerContributionEnum"];
        } & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            objectType: VisionObjectTypeEnum;
        };
        /**
         * @description Describes the spouse benefit configuration available for Quote.
         * @enum {string}
         */
        QuoteBasicLifeSpouseBenefitTypeEnum: QuoteVisionCopayRuleTypeEnum;
        /**
         * @description Describes the child benefit configuration available for Quote.
         * @enum {string}
         */
        QuoteBasicLifeChildBenefitTypeEnum: QuoteVisionCopayRuleTypeEnum;
        /**
         * @description Indicates the type of age reduction schedule for Quote.
         * @enum {string}
         */
        QuoteAgeReductionScheduleTypeEnum: QuoteAgeReductionScheduleTypeEnum;
        QuoteAgeReductionSchedule: components["schemas"]["BaseAgeReductionSchedule"] & {
            type?: components["schemas"]["QuoteAgeReductionScheduleTypeEnum"];
        };
        QuoteBasicLifeAdndBenefit: components["schemas"]["BaseBasicLifeAdndBenefit"] & {
            /** @description Indicates the amount of benefit available for a spouse. */
            spouseBenefit: {
                type: components["schemas"]["QuoteBasicLifeSpouseBenefitTypeEnum"];
                /** @description The spouse benefit dollar amount. Omit if type is notIncluded or notOffered. */
                amount?: number;
            };
            /** @description Indicates the amount of benefit available for a child. */
            childBenefit: {
                type: components["schemas"]["QuoteBasicLifeChildBenefitTypeEnum"];
                /** @description The child benefit dollar amount. Omit if type is notIncluded or notOffered. */
                amount?: number;
            };
            /** @description Details any benefit change-increments based on age. (Ex: 35% at 65, 50% at 70 *standard is two, but could be up to 6). */
            ageReductionSchedule: components["schemas"]["QuoteAgeReductionSchedule"];
            /** @description Indicates if the employee will be allowed to convert the basic life policy to a different form of life policy. */
            conversion: components["schemas"]["QuoteInclusionStatusEnum"];
            /** @description Indicates if the plan will allow for any amount of life insurance benefit to be paid out in advance of death (typically in the case of a terminal illness diagnosis). */
            acceleratedDeathBenefit: components["schemas"]["QuoteInclusionStatusEnum"];
            /** @description Indicates if premium payments will be waived in the case of a critical illness or serious injury. */
            waiverOfPremium: components["schemas"]["QuoteInclusionStatusEnum"];
        } & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            objectType: RfpBasicLifeObjectTypeEnum;
        };
        /**
         * @description Describes the benefit configuration available for employee.
         * @enum {string}
         */
        QuoteVoluntaryLifeEmployeeBenefitTypeEnum: RfpVoluntaryLifeEmployeeBenefitTypeEnum;
        /** @description Describes the benefit configuration available for employee. */
        QuoteVoluntaryLifeEmployeeBenefitAmount: {
            /** @description The type of benefit amount. */
            type: components["schemas"]["QuoteVoluntaryLifeEmployeeBenefitTypeEnum"];
            /** @description List of benefit amounts when applicable. Omit if not applicable. */
            amounts?: number[];
        };
        /**
         * @description Indicates the maximum amount of benefit that can be elected.
         * @enum {string}
         */
        QuoteVoluntaryLifeBenefitMaximumTypeEnum: BenefitMaximumTypeEnum;
        /** @description Benefit maximum configuration. */
        QuoteVoluntaryLifeBenefitMaximum: {
            /** @description The type of benefit maximum. */
            type: components["schemas"]["QuoteVoluntaryLifeBenefitMaximumTypeEnum"];
            /** @description Dollar amount maximum when applicable. Omit if not applicable. */
            dollarAmount?: number;
            /** @description Salary multiplier maximum when applicable. Omit if not applicable. */
            salaryMultiplier?: number;
        };
        /**
         * @description Indicates the amount of Life Insurance volume available without having to provide Evidence of Insurability.
         * @enum {string}
         */
        QuoteVoluntaryLifeGuaranteeIssueTypeEnum: QuoteVoluntaryLifeGuaranteeIssueTypeEnum;
        /** @description Guarantee issue configuration. */
        QuoteVoluntaryLifeGuaranteeIssue: {
            /** @description The type of guarantee issue. */
            type: components["schemas"]["QuoteVoluntaryLifeGuaranteeIssueTypeEnum"];
            /** @description Dollar amount for guarantee issue when applicable. Omit if not applicable. */
            dollarAmount?: number;
            /** @description Used for salary multiplier types. Omit otherwise. */
            salaryMultiplier?: number;
            /** @description Used for salaryMultiplierWithDollarAmountPlusAdditionalAmount. Omit otherwise. */
            additionalAmount?: number;
            /** @description Age-based guarantee issue amounts when applicable. Omit if not applicable. */
            ageBasedAmounts?: components["schemas"]["GuaranteeIssueAgeBasedAmount"][];
        };
        /** @description Employee voluntary life benefit configuration. */
        QuoteVoluntaryLifeEmployeeBenefit: {
            /** @description Benefit amount configuration for employee. */
            benefitDescription?: components["schemas"]["QuoteVoluntaryLifeEmployeeBenefitAmount"];
            /** @description Benefit maximum configuration for employee. */
            benefitMaximum?: components["schemas"]["QuoteVoluntaryLifeBenefitMaximum"];
            /** @description Guarantee issue configuration for employee. */
            guaranteeIssue?: components["schemas"]["QuoteVoluntaryLifeGuaranteeIssue"];
        };
        /**
         * @description Describes the benefit configuration available for spouse and child.
         * @enum {string}
         */
        QuoteVoluntaryLifeSpouseChildBenefitTypeEnum: RfpVoluntaryLifeSpouseChildBenefitTypeEnum;
        /** @description Describes the benefit configuration available for spouse and child. */
        QuoteVoluntaryLifeSpouseChildBenefitAmount: {
            /** @description The type of benefit amount. */
            type: components["schemas"]["QuoteVoluntaryLifeSpouseChildBenefitTypeEnum"];
            /** @description List of benefit amounts when applicable. Omit if not applicable. */
            amounts?: number[];
        };
        /**
         * @description Indicates the maximum amount of benefit that can be elected for spouse and child.
         * @enum {string}
         */
        QuoteVoluntaryLifeSpouseChildBenefitMaximumTypeEnum: RfpVisionCopayRuleTypeEnum;
        /** @description Benefit maximum configuration for spouse and child. */
        QuoteVoluntaryLifeSpouseChildBenefitMaximum: {
            /** @description The type of benefit maximum. */
            type: components["schemas"]["QuoteVoluntaryLifeSpouseChildBenefitMaximumTypeEnum"];
            /** @description Dollar amount maximum when applicable. Omit if not applicable. */
            dollarAmount?: number;
        };
        /**
         * @description Indicates limitation on Spouse or Child benefit.
         * @enum {string}
         */
        QuoteVoluntaryLifeAmountNotToExceedTypeEnum: QuoteVoluntaryLifeAmountNotToExceedTypeEnum;
        /** @description Amount not to exceed configuration. */
        QuoteVoluntaryLifeAmountNotToExceed: {
            /** @description The type of amount not to exceed. */
            type: components["schemas"]["QuoteVoluntaryLifeAmountNotToExceedTypeEnum"];
            /** @description Amount when applicable. Omit if not applicable. */
            amount?: number;
        };
        /** @description Spouse voluntary life benefit configuration. */
        QuoteVoluntaryLifeSpouseBenefit: {
            /** @description Benefit amount configuration for spouse. */
            benefitDescription: components["schemas"]["QuoteVoluntaryLifeSpouseChildBenefitAmount"];
            /** @description Benefit maximum configuration for spouse. */
            benefitMaximum: components["schemas"]["QuoteVoluntaryLifeSpouseChildBenefitMaximum"];
            /** @description Guarantee issue configuration for spouse. */
            guaranteeIssue: components["schemas"]["QuoteVoluntaryLifeGuaranteeIssue"];
            /** @description Amount not to exceed configuration for spouse. */
            amountNotToExceed: components["schemas"]["QuoteVoluntaryLifeAmountNotToExceed"];
        };
        /** @description Child benefit configuration for a specific age band. */
        QuoteChildBenefitAgeBasedAmount: {
            /** @description Lower age limit for this benefit band (in days for children under 1 year, in years for older children). If excluded, indicates this band applies to all ages less than or equal to ageBandUpper. */
            ageBandLower?: number;
            /** @description Upper age limit for this benefit band (in days for children under 1 year, in years for older children). If excluded, indicates this band applies to all ages greater than or equal to ageBandLower. */
            ageBandUpper?: number;
            unit: components["schemas"]["ChildBenefitAgeUnitEnum"];
            /** @description Benefit amount configuration for this age band. */
            benefitAmount: components["schemas"]["QuoteVoluntaryLifeSpouseChildBenefitAmount"];
        };
        /** @description Child benefit configuration by age bands. */
        QuoteVoluntaryLifeChildBenefitByAge: components["schemas"]["QuoteChildBenefitAgeBasedAmount"][];
        /**
         * @description Indicates if the child benefits are offered beyond the child limiting age for children who are full time students.
         * @enum {string}
         */
        QuoteVoluntaryLifeStudentStatusTypeEnum: QuoteInclusionStatusEnum;
        /** @description Student status configuration. */
        QuoteVoluntaryLifeStudentStatus: {
            /** @description The type of student status. */
            type: components["schemas"]["QuoteVoluntaryLifeStudentStatusTypeEnum"];
            /** @description Student limiting age when applicable. Omit if not applicable. */
            amount?: number;
        };
        /** @description Child voluntary life benefit configuration. */
        QuoteVoluntaryLifeChildBenefit: {
            /** @description Benefit amounts by age bands for child. */
            benefitAmountsByAge: components["schemas"]["QuoteVoluntaryLifeChildBenefitByAge"];
            /** @description Benefit maximum configuration for child. */
            benefitMaximum: components["schemas"]["QuoteVoluntaryLifeSpouseChildBenefitMaximum"];
            /** @description Amount not to exceed configuration for child. */
            amountNotToExceed: components["schemas"]["QuoteVoluntaryLifeAmountNotToExceed"];
            /** @description Student status configuration for child. */
            studentLimitingAge: components["schemas"]["QuoteVoluntaryLifeStudentStatus"];
        };
        /**
         * @description Indicates if AD&D benefit amount must match vol life benefit amount.
         * @enum {string}
         */
        QuoteVoluntaryLifeAdndTiedToLifeTypeEnum: QuoteVoluntaryLifeAdndTiedToLifeTypeEnum;
        /**
         * @description Indicates the type of age reduction schedule.
         * @enum {string}
         */
        QuoteVoluntaryLifeAgeReductionScheduleTypeEnum: QuoteAgeReductionScheduleTypeEnum;
        /** @description Age reduction schedule configuration. */
        QuoteVoluntaryLifeAgeReductionSchedule: {
            /** @description The type of age reduction schedule. */
            type: components["schemas"]["QuoteVoluntaryLifeAgeReductionScheduleTypeEnum"];
            /** @description The reduction schedule details. Omit if type is 'none' or 'notIncluded'. */
            schedules?: components["schemas"]["ReductionSchedule"];
        };
        /**
         * @description Indicates if policy holder can continue policy after separation of employment and whether Evidence of Insurability would be required.
         * @enum {string}
         */
        QuotePortabilityTypeEnum: QuotePortabilityTypeEnum;
        QuoteVoluntaryLifeAdndBenefit: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            objectType: RfpVoluntaryLifeAdndBenefitObjectType;
            /** @description Employee benefit configuration. */
            employee: components["schemas"]["QuoteVoluntaryLifeEmployeeBenefit"];
            /** @description Spouse benefit configuration. */
            spouse: components["schemas"]["QuoteVoluntaryLifeSpouseBenefit"];
            /** @description Child benefit configuration. */
            child: components["schemas"]["QuoteVoluntaryLifeChildBenefit"];
            definitionOfEarnings: components["schemas"]["DefinitionOfEarnings"];
            /** @description Indicates if AD&D benefit is included with Life benefit. */
            adndIncluded: components["schemas"]["QuoteInclusionStatusEnum"];
            /** @description Indicates if AD&D benefit amount must match vol life benefit amount. */
            adndTiedToLife?: components["schemas"]["QuoteVoluntaryLifeAdndTiedToLifeTypeEnum"];
            /** @description Details any benefit change-increments based on age. */
            ageReductionSchedule: components["schemas"]["QuoteVoluntaryLifeAgeReductionSchedule"];
            /** @description Indicates if the employee will be allowed to convert the life policy to a different form of life policy. */
            conversion: components["schemas"]["QuoteInclusionStatusEnum"];
            /** @description Indicates if the plan will allow for any amount of life insurance benefit to be paid out in advance of death. */
            acceleratedDeathBenefit: components["schemas"]["QuoteInclusionStatusEnum"];
            /** @description Indicates if premium payments will be waived in the case of a critical illness or serious injury. */
            waiverOfPremium: components["schemas"]["QuoteInclusionStatusEnum"];
            /** @description Indicates if annual open enrollment is included in the plan. */
            annualOpenEnrollment: components["schemas"]["QuoteAnnualOpenEnrollmentEnum"];
            /** @description Indicates if policy holder can continue policy after separation of employment and whether Evidence of Insurability would be required. */
            portability: components["schemas"]["QuotePortabilityTypeEnum"];
        };
        /**
         * @description Indicates the period of time that must pass before they begin receiving benefit.
         * @enum {string}
         */
        QuoteEliminationPeriodTypeEnum: QuoteEliminationPeriodTypeEnum;
        QuoteEliminationPeriodType: components["schemas"]["EliminationPeriodType"] & {
            type: components["schemas"]["QuoteEliminationPeriodTypeEnum"];
        };
        /**
         * @description Indicates the maximum amount of time the carrier will pay out the benefit.
         * @enum {string}
         */
        QuoteStdBenefitDurationTypeEnum: QuoteStdBenefitDurationTypeEnum;
        /** @description Indicates the maximum amount of time the carrier will pay out the benefit minus the elimination period time. */
        QuoteStdBenefitDuration: {
            /** @description Indicates the maximum amount of time the carrier will pay out the benefit. */
            type: components["schemas"]["QuoteStdBenefitDurationTypeEnum"];
            /** @description The duration amount when applicable. Omit if not applicable. */
            amount?: number;
        };
        /**
         * @description Indicates the pre-existing condition type.
         * @enum {string}
         */
        QuotePreExistingConditionTypeEnum: QuotePreExistingConditionTypeEnum;
        /** @description Indicates the amount of months before effective date AND after effective date participant needs to be illness free to claim benefit. */
        QuotePreExistingConditionExtended: {
            /** @description The pre-existing condition type. */
            type: components["schemas"]["QuotePreExistingConditionTypeEnum"];
            /** @description Months diagnosis free before effective date. Omit if not applicable. */
            monthsDiagnosisFreeBeforeEffDate?: number;
            /** @description Months treatment free. Omit if not applicable. */
            monthsTreatmentFree?: number;
            /** @description Months diagnosis free after effective date. Omit if not applicable. */
            monthsDiagnosisFreeAfterEffDate?: number;
        };
        /**
         * @description Indicates if FICA match is included.
         * @enum {string}
         */
        QuoteFicaMatchTypeEnum: QuoteInclusionStatusEnum;
        /**
         * @description Indicates if the FICA match is considered billable or non-billable.
         * @enum {string}
         */
        QuoteBillableTypeEnum: RfpBillableTypeEnum;
        QuoteStdBenefit: components["schemas"]["BaseStdBenefit"] & {
            /** @description Indicates the period of time after accident event that must pass before they begin receiving benefit. */
            eliminationPeriodAccident: components["schemas"]["QuoteEliminationPeriodType"];
            /** @description Indicates the period of time after start of illness that must pass before they begin receiving benefit. */
            eliminationPeriodIllness: components["schemas"]["QuoteEliminationPeriodType"];
            /** @description Indicates the maximum amount of time the carrier will pay out the benefit minus the elimination period time. */
            benefitDuration: components["schemas"]["QuoteStdBenefitDuration"];
            /** @description Indicates the amount of months before eff date AND after effective date participant needs to be illness free to claim benefit. */
            preExistingCondition: components["schemas"]["QuotePreExistingConditionExtended"];
            /** @description Indicates if FICA match is included in the quote. */
            ficaMatch: components["schemas"]["QuoteFicaMatchTypeEnum"];
            /** @description Indicates if the FICA match is considered billable or non-billable. */
            billableType: components["schemas"]["QuoteBillableTypeEnum"];
        } & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            objectType: StdObjectTypeEnum;
        };
        /**
         * @description The type of guaranteed issue structure for Quote.
         * @enum {string}
         */
        QuoteLtdGuaranteedIssueRuleTypeEnum: QuoteVisionCopayRuleTypeEnum;
        QuoteGuaranteedIssue: components["schemas"]["GuaranteedIssue"] & {
            type?: components["schemas"]["QuoteLtdGuaranteedIssueRuleTypeEnum"];
        };
        /**
         * @description The type of own occupation period for Quote.
         * @enum {string}
         */
        QuoteLtdOwnOccupationPeriodTypeEnum: QuoteLtdOwnOccupationPeriodTypeEnum;
        QuoteOwnOccupationPeriod: components["schemas"]["OwnOccupationPeriod"] & {
            type?: components["schemas"]["QuoteLtdOwnOccupationPeriodTypeEnum"];
        };
        /**
         * @description The type of gainful earnings test for Quote.
         * @enum {string}
         */
        QuoteGainfulEarningsRuleTypeEnum: QuoteGainfulEarningsRuleTypeEnum;
        QuoteGainfulEarningsTest: components["schemas"]["GainfulEarningsTest"] & {
            type?: components["schemas"]["QuoteGainfulEarningsRuleTypeEnum"];
        };
        QuoteEliminationPeriod: components["schemas"]["EliminationPeriod"] & {
            type?: components["schemas"]["QuoteEliminationPeriodTypeEnum"];
        };
        /**
         * @description Indicates if additional plan limitations exist.
         * @enum {string}
         */
        QuoteLtdOtherLimitationsEnum: QuoteLtdOtherLimitationsEnum;
        QuoteOtherLimitation: components["schemas"]["Limitation"] & {
            type?: components["schemas"]["QuoteLtdOtherLimitationsEnum"];
        };
        /**
         * @description The type of time period limitation for Quote.
         * @enum {string}
         */
        QuoteLtdLimitationTypeEnum: QuoteLtdOtherLimitationsEnum;
        QuoteLimitation: components["schemas"]["Limitation"] & {
            type?: components["schemas"]["QuoteLtdLimitationTypeEnum"];
        };
        /** @description Indicates the amount of months before effective date AND after effective date participant needs to be illness free to claim benefit. */
        QuotePreExistingCondition: {
            type: components["schemas"]["QuotePreExistingConditionTypeEnum"];
            /** @description Months diagnosis free before effective date. Omit if not applicable. */
            monthsDiagnosisFreeBeforeEffDate?: number;
            /** @description Months treatment free. Omit if not applicable. */
            monthsTreatmentFree?: number;
            /** @description Months diagnosis free after effective date. Omit if not applicable. */
            monthsDiagnosisFreeAfterEffDate?: number;
        };
        /**
         * @description Defines the carrier rehabilitation requirement to be eligible for benefit.
         * @enum {string}
         */
        QuoteRehabTypeEnum: QuoteRehabTypeEnum;
        QuoteLtdBenefit: components["schemas"]["BaseLtdBenefit"] & {
            /** @description Indicates the total benefit that is guaranteed without health questions. */
            guaranteedIssue: components["schemas"]["QuoteGuaranteedIssue"];
            /** @description Own occupation period configuration. */
            ownOccupationPeriod: components["schemas"]["QuoteOwnOccupationPeriod"];
            /** @description Defines the carrier's required 'loss of earnings' that must be met to be eligible for benefit during the own occupation period. */
            gainfulEarningsTestOwnOccupation: components["schemas"]["QuoteGainfulEarningsTest"];
            /** @description Defines the carrier's required 'loss of earnings' that must be met to be eligible for benefit during the any occupation period. */
            gainfulEarningsTestAnyOccupation: components["schemas"]["QuoteGainfulEarningsTest"];
            /** @description Indicates the period of time after participant becomes disabled that must pass before they begin receiving benefit. */
            eliminationPeriod: components["schemas"]["QuoteEliminationPeriod"];
            /** @description Indicates the amount of time the carrier will pay out the benefit. */
            benefitDuration: components["schemas"]["BenefitDuration"];
            /** @description Indicates if additional plan limitations exist in the quoted plan such as special conditions, self-reported limitations, etc. */
            otherLimitations: components["schemas"]["QuoteOtherLimitation"];
            /** @description Indicates the time period limitation for mental illness. */
            mentalIllness: components["schemas"]["QuoteLimitation"];
            /** @description Indicates the time period limitation for substance abuse. */
            substanceAbuse: components["schemas"]["QuoteLimitation"];
            /** @description Indicates the amount of months before eff date AND after effective date participant needs to be illness free to claim benefit. */
            preExistingCondition: components["schemas"]["QuotePreExistingCondition"];
            /** @description Defines the carrier rehabilitation requirement to be eligible for benefit. */
            rehab: components["schemas"]["QuoteRehabTypeEnum"];
            /** @description Indicates if Cost of Living Adjustment will be factored into the benefit amount proposed. */
            cola: components["schemas"]["QuoteInclusionStatusEnum"];
            /** @description Indicates if the employee will be allowed to convert the policy to a different form of coverage. */
            conversion: components["schemas"]["QuoteInclusionStatusEnum"];
            /** @description Indicates if premium payments will be waived in the case of a critical illness or serious injury. */
            waiverOfPremium: components["schemas"]["QuoteInclusionStatusEnum"];
        } & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            objectType: LtdObjectTypeEnum;
        };
        /** @description Describes the benefit configuration available for employee. */
        QuoteCriticalIllnessEmployeeBenefitDescription: {
            /** @description The type of benefit description. */
            type: components["schemas"]["CriticalIllnessEmployeeBenefitDescriptionTypeEnum"];
            /** @description The benefit description amounts. Include multiple items when type is multipleOptions, single item otherwise when applicable. */
            amounts?: number[];
            /** @description The minimum benefit description amount. Include when applicable. */
            minimum?: number;
        };
        /** @description Indicates the maximum amount of benefit the employee can elect. */
        QuoteCriticalIllnessEmployeeBenefitMaximum: {
            /** @description The type of benefit maximum. */
            type: components["schemas"]["CriticalIllnessEmployeeMaximumTypeEnum"];
            /** @description The dollar amount for the maximum. Include when type is dollarAmount or percentageOfEeBenefitAndDollarAmount. */
            dollarAmount?: number;
            /** @description The percentage of employee benefit. Include when type is percentageOfEeBenefit or percentageOfEeBenefitAndDollarAmount. */
            percent?: number;
        };
        /**
         * @description Indicates the amount of Employee Benefit available without having to provide Evidence of Insurability.
         * @enum {string}
         */
        QuoteCriticalIllnessEmployeeGuaranteeIssueTypeEnum: QuoteCriticalIllnessEmployeeGuaranteeIssueTypeEnum;
        /** @description Indicates the amount of Employee Benefit available without having to provide Evidence of Insurability. */
        QuoteCriticalIllnessEmployeeGuaranteeIssue: {
            /** @description The type of guarantee issue. */
            type: components["schemas"]["QuoteCriticalIllnessEmployeeGuaranteeIssueTypeEnum"];
            /** @description The guarantee issue amount. Include when type allows amounts. */
            amount?: number;
        };
        /** @description Employee critical illness benefit configuration. */
        QuoteCriticalIllnessEmployeeBenefit: {
            /** @description Describes the benefit configuration available for employee. */
            benefitDescription: components["schemas"]["QuoteCriticalIllnessEmployeeBenefitDescription"];
            /** @description Indicates the maximum amount of benefit the employee can elect. */
            benefitMaximum: components["schemas"]["QuoteCriticalIllnessEmployeeBenefitMaximum"];
            /** @description Indicates the amount of Employee Benefit available without having to provide Evidence of Insurability. */
            guaranteeIssue: components["schemas"]["QuoteCriticalIllnessEmployeeGuaranteeIssue"];
        };
        /**
         * @description Describes the benefit configuration available for spouse.
         * @enum {string}
         */
        QuoteCriticalIllnessSpouseBenefitDescriptionTypeEnum: QuoteCriticalIllnessSpouseBenefitDescriptionTypeEnum;
        /** @description Describes the benefit configuration available for spouse. */
        QuoteCriticalIllnessSpouseBenefitDescription: {
            /** @description The type of benefit description. */
            type: components["schemas"]["QuoteCriticalIllnessSpouseBenefitDescriptionTypeEnum"];
            /** @description The benefit description amounts. Include multiple items when type is multipleOptions, single item otherwise when applicable. */
            amounts?: number[];
            /** @description The minimum benefit description amount. Include when applicable. */
            minimum?: number;
        };
        /**
         * @description Indicates the maximum amount of benefit the spouse can elect.
         * @enum {string}
         */
        QuoteCriticalIllnessSpouseMaximumTypeEnum: QuoteCriticalIllnessSpouseMaximumTypeEnum;
        /** @description Indicates the maximum amount of benefit the spouse can elect. */
        QuoteCriticalIllnessSpouseBenefitMaximum: {
            /** @description The type of benefit maximum. */
            type: components["schemas"]["QuoteCriticalIllnessSpouseMaximumTypeEnum"];
            /** @description The dollar amount for the maximum. Include when type is dollarAmount or percentageOfEeBenefitAndDollarAmount. */
            dollarAmount?: number;
            /** @description The percentage of employee benefit. Include when type is percentageOfEeBenefit or percentageOfEeBenefitAndDollarAmount. */
            percent?: number;
        };
        /**
         * @description Indicates the amount of Spouse Benefit available without having to provide Evidence of Insurability.
         * @enum {string}
         */
        QuoteCriticalIllnessSpouseGuaranteeIssueTypeEnum: QuoteCriticalIllnessEmployeeGuaranteeIssueTypeEnum;
        /** @description Indicates the amount of Spouse Benefit available without having to provide Evidence of Insurability. */
        QuoteCriticalIllnessSpouseGuaranteeIssue: {
            /** @description The type of guarantee issue. */
            type: components["schemas"]["QuoteCriticalIllnessSpouseGuaranteeIssueTypeEnum"];
            /** @description The guarantee issue amount. Include when type allows amounts. */
            amount?: number;
        };
        /** @description Spouse critical illness benefit configuration. */
        QuoteCriticalIllnessSpouseBenefit: {
            /** @description Describes the benefit configuration available for spouse. */
            benefitDescription: components["schemas"]["QuoteCriticalIllnessSpouseBenefitDescription"];
            /** @description Indicates the maximum amount of benefit the spouse can elect. */
            benefitMaximum: components["schemas"]["QuoteCriticalIllnessSpouseBenefitMaximum"];
            /** @description Indicates the amount of Spouse Benefit available without having to provide Evidence of Insurability. */
            guaranteeIssue: components["schemas"]["QuoteCriticalIllnessSpouseGuaranteeIssue"];
        };
        /**
         * @description Describes the benefit configuration available for child.
         * @enum {string}
         */
        QuoteCriticalIllnessChildBenefitDescriptionTypeEnum: QuoteCriticalIllnessEmployeeGuaranteeIssueTypeEnum;
        /** @description Describes the benefit configuration available for child. */
        QuoteCriticalIllnessChildBenefitDescription: {
            /** @description The type of benefit description. */
            type: components["schemas"]["QuoteCriticalIllnessChildBenefitDescriptionTypeEnum"];
            /** @description The benefit description amounts. Include multiple items when type is flatAmount, single item otherwise when applicable. */
            amounts?: number[];
            /** @description The minimum benefit description amount. Include when applicable. */
            minimum?: number;
        };
        /** @description Child critical illness benefit configuration. */
        QuoteCriticalIllnessChildBenefit: {
            /** @description Describes the benefit configuration available for child. */
            benefitDescription: components["schemas"]["QuoteCriticalIllnessChildBenefitDescription"];
        };
        /**
         * @description Indicates what carrier will cover as benefit for this service.
         * @enum {string}
         */
        QuoteIllnessTypeEnum: QuoteIllnessTypeEnum;
        QuoteIllnessCoverage: components["schemas"]["BaseIllnessCoverage"] & {
            type?: components["schemas"]["QuoteIllnessTypeEnum"];
        };
        /**
         * @description Indicates the total amount the plan will payout to any given employee (after factoring in recurrence and second occurrence).
         * @enum {string}
         */
        QuoteMaximumPayoutTypeEnum: QuoteMaximumPayoutTypeEnum;
        QuoteMaximumPayout: components["schemas"]["BaseMaximumPayout"] & {
            type?: components["schemas"]["QuoteMaximumPayoutTypeEnum"];
        };
        /**
         * @description Indicates coverage and time period for illness occurrences.
         * @enum {string}
         */
        QuoteOccurrenceTypeEnum: QuoteOccurrenceTypeEnum;
        QuoteOccurrenceOfDifferentIllness: components["schemas"]["BaseOccurrenceOfDifferentIllness"] & {
            type?: components["schemas"]["QuoteOccurrenceTypeEnum"];
        };
        QuoteAdditionalOccurrenceOfSameIllness: components["schemas"]["BaseAdditionalOccurrenceOfSameIllness"] & {
            type?: components["schemas"]["QuoteOccurrenceTypeEnum"];
        };
        /**
         * @description Indicates dollar amount of available reimbursement for member completing wellness initiative(s).
         * @enum {string}
         */
        QuoteWellnessBenefitTypeEnum: QuoteVisionCopayRuleTypeEnum;
        QuoteWellnessBenefit: components["schemas"]["BaseWellnessBenefit"] & {
            type?: components["schemas"]["QuoteWellnessBenefitTypeEnum"];
        };
        /**
         * @description Indicates whether the available benefit(s) are based on member age at time of policy issuance, or based member attained age in conjunction with age-band rules.
         * @enum {string}
         */
        QuoteAgeBasisEnum: QuoteAgeBasisEnum;
        QuoteCriticalIllnessBenefit: {
            objectType: components["schemas"]["CriticalIllnessObjectTypeEnum"];
            /** @description Employee benefit configuration. */
            employee: components["schemas"]["QuoteCriticalIllnessEmployeeBenefit"];
            /** @description Spouse benefit configuration. */
            spouse: components["schemas"]["QuoteCriticalIllnessSpouseBenefit"];
            /** @description Child benefit configuration. */
            child: components["schemas"]["QuoteCriticalIllnessChildBenefit"];
            /** @description Indicates what carrier will cover as benefit for invasive cancer. */
            invasiveCancer: components["schemas"]["QuoteIllnessCoverage"];
            /** @description Indicates what carrier will cover as benefit for non-invasive cancer. */
            nonInvasiveCancer: components["schemas"]["QuoteIllnessCoverage"];
            /** @description Indicates what carrier will cover as benefit for Category 1 heart attack. */
            category1HeartAttack: components["schemas"]["QuoteIllnessCoverage"];
            /** @description Indicates what carrier will cover as benefit for Category 1 stroke. */
            category1Stroke: components["schemas"]["QuoteIllnessCoverage"];
            /** @description Indicates what carrier will cover as benefit for kidney failure. */
            kidneyFailure: components["schemas"]["QuoteIllnessCoverage"];
            /** @description Indicates the total amount the plan will payout to any given employee (after factoring in recurrence and second occurrence). */
            maximumPayout: components["schemas"]["QuoteMaximumPayout"];
            /** @description Indicates the percentage at which an additional illness (in a different category) will be covered, and the time period compared to the initial illness covered. */
            occurrenceOfDifferentIllness: components["schemas"]["QuoteOccurrenceOfDifferentIllness"];
            /** @description Indicates the percentage at which a repeat occurrence of the same illness will be covered, and the time period compared to the initial illness covered. */
            additionalOccurrenceOfSameIllness: components["schemas"]["QuoteAdditionalOccurrenceOfSameIllness"];
            /** @description Details any benefit change-increments based on age. */
            ageReductionSchedule: components["schemas"]["QuoteAgeReductionSchedule"];
            /** @description Indicates the amount of months before effective date AND after effective date participant needs to be illness free to claim benefit. */
            preExistingCondition: components["schemas"]["QuotePreExistingCondition"];
            /** @description Indicates if policy holder can continue policy after separation of employment. */
            portability: components["schemas"]["QuoteInclusionStatusEnum"];
            /** @description Indicates dollar amount of available reimbursement for member completing wellness initiative(s). */
            wellnessBenefit: components["schemas"]["QuoteWellnessBenefit"];
            /** @description Indicates if annual open enrollment is included in the plan. */
            annualOpenEnrollment: components["schemas"]["QuoteAnnualOpenEnrollmentEnum"];
            /** @description Indicates whether the available benefit(s) are based on member age at time of policy issuance, or based member attained age in conjunction with age-band rules. */
            ageBasis: components["schemas"]["QuoteAgeBasisEnum"];
        } & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            objectType: CriticalIllnessObjectTypeEnum;
        };
        /**
         * @description Indicates when the accident event may occur to be eligible for coverage.
         * @enum {string}
         */
        QuoteAccidentCoverageTypeEnum: RfpAccidentCoverageTypeEnum;
        /**
         * @description Indicates dollar amount carrier will cover as benefit for specific services that should not include hospital admission benefits.
         * @enum {string}
         */
        QuoteAccidentSpecificBenefitTypeEnum: QuoteAccidentSpecificBenefitTypeEnum;
        QuoteAccidentSpecificBenefitDetails: components["schemas"]["AccidentBenefitDetails"] & {
            type?: components["schemas"]["QuoteAccidentSpecificBenefitTypeEnum"];
        };
        /**
         * @description Indicates dollar amount carrier will cover as benefit for this service, including any conditional requirements.
         * @enum {string}
         */
        QuoteAccidentBenefitTypeEnum: QuoteAccidentBenefitTypeEnum;
        QuoteAccidentBenefitDetails: components["schemas"]["AccidentBenefitDetails"] & {
            type?: components["schemas"]["QuoteAccidentBenefitTypeEnum"];
        };
        /**
         * @description Maximum benefit type for accident coverage.
         * @enum {string}
         */
        QuoteAccidentMaxBenefitTypeEnum: QuoteAccidentMaxBenefitTypeEnum;
        QuoteAccidentMaxBenefitDetails: components["schemas"]["AccidentBenefitDetails"] & {
            type?: components["schemas"]["QuoteAccidentMaxBenefitTypeEnum"];
        };
        /**
         * @description Indicates dollar amount carrier will cover as benefit for this service, including any conditional requirements.
         * @enum {string}
         */
        QuoteBenefitTypeEnum: QuoteVisionCopayRuleTypeEnum;
        QuoteBenefitAmountDetails: components["schemas"]["BenefitAmountDetails"] & {
            type?: components["schemas"]["QuoteBenefitTypeEnum"];
        };
        QuoteAccidentBenefit: {
            /** @enum {string} */
            objectType: RfpAccidentBenefitObjectType;
            /** @description Indicates when the accident event may occur to be eligible for coverage (hours covered). */
            coverageType: components["schemas"]["QuoteAccidentCoverageTypeEnum"];
            /** @description Indicates dollar amount carrier will cover as benefit for this service, including any conditional requirements. */
            hospitalAdmission: components["schemas"]["QuoteAccidentSpecificBenefitDetails"];
            /** @description Indicates dollar amount carrier will cover as benefit for this service, including any conditional requirements. */
            icuAdmission: components["schemas"]["QuoteAccidentBenefitDetails"];
            /** @description Indicates dollar amount carrier will cover as benefit for this service, including any conditional requirements. */
            dailyHospitalConfinement: components["schemas"]["QuoteAccidentSpecificBenefitDetails"];
            /** @description Indicates dollar amount carrier will cover as benefit for this service, including any conditional requirements. */
            dailyIcuConfinement: components["schemas"]["QuoteAccidentBenefitDetails"];
            /** @description Indicates dollar amount carrier will cover as benefit for this service, including any conditional requirements. */
            ambulanceAir: components["schemas"]["QuoteAccidentSpecificBenefitDetails"];
            /** @description Indicates dollar amount carrier will cover as benefit for this service, including any conditional requirements. */
            ambulanceGround: components["schemas"]["QuoteAccidentSpecificBenefitDetails"];
            /** @description Indicates dollar amount carrier will cover as benefit for this service, including any conditional requirements. */
            emergencyTreatment: components["schemas"]["QuoteAccidentSpecificBenefitDetails"];
            /** @description Indicates dollar amount carrier will cover as benefit for this service, including any conditional requirements. */
            urgentCare: components["schemas"]["QuoteAccidentSpecificBenefitDetails"];
            /** @description Indicates dollar amount carrier will cover as benefit for this service, including any conditional requirements. */
            initialPhysicianOfficeVisit: components["schemas"]["QuoteAccidentSpecificBenefitDetails"];
            /** @description Max benefit amount for dislocations. */
            dislocationsMaximum: components["schemas"]["QuoteAccidentMaxBenefitDetails"];
            /** @description Max benefit amount for fractures. */
            fracturesMaximum: components["schemas"]["QuoteAccidentMaxBenefitDetails"];
            /** @description Indicates the maximum benefit amount available for lacerations. */
            lacerationsMaximum: components["schemas"]["QuoteAccidentMaxBenefitDetails"];
            /** @description Indicates the benefit amount available for a coma. */
            coma: components["schemas"]["QuoteAccidentMaxBenefitDetails"];
            /** @description Indicates the benefit amount available for a x-ray. */
            majorDiagnosticExamXray: components["schemas"]["QuoteAccidentMaxBenefitDetails"];
            /** @description Indicates the benefit amount available for a MRI. */
            majorDiagnosticExamMri: components["schemas"]["QuoteAccidentMaxBenefitDetails"];
            /** @description Indicates if child organized sports enhancement is included. */
            childOrganizedSportsEnhancement: components["schemas"]["QuoteInclusionStatusEnum"];
            /** @description Indicates if policy holder can continue policy after separation of employment. */
            portability: components["schemas"]["QuoteInclusionStatusEnum"];
            /** @description Indicates the age and associated percentage of benefit reduction. */
            ageReductionSchedule: components["schemas"]["QuoteAgeReductionSchedule"];
            /** @description Indicates dollar amount of available reimbursement for member completing wellness initiative(s). */
            wellnessBenefit: components["schemas"]["QuoteBenefitAmountDetails"];
            annualOpenEnrollment: components["schemas"]["QuoteAnnualOpenEnrollmentEnum"];
        } & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            objectType: RfpAccidentBenefitObjectType;
        };
        QuoteHospitalIndemnityBenefit: {
            /** @enum {string} */
            objectType: RfpHospitalIndemnityBenefitObjectType;
            /** @description Indicates dollar amount carrier will cover as benefit for this service, including any conditional requirements. */
            hospitalAdmission: components["schemas"]["QuoteBenefitAmountDetails"];
            /** @description Indicates dollar amount carrier will cover as benefit for this service, including any conditional requirements. */
            icuAdmission: components["schemas"]["QuoteBenefitAmountDetails"];
            /** @description Indicates dollar amount carrier will cover as benefit for this service, including any conditional requirements. */
            hospitalConfinement: components["schemas"]["QuoteBenefitAmountDetails"];
            /** @description Indicates dollar amount carrier will cover as benefit for this service, including any conditional requirements. */
            icuConfinement: components["schemas"]["QuoteBenefitAmountDetails"];
            /** @description Indicates the amount of months before effective date AND after effective date participant needs to be illness free to claim benefit. */
            preExistingCondition: components["schemas"]["QuotePreExistingCondition"];
            /** @description Indicates if policy holder can continue policy after separation of employment. */
            portability: components["schemas"]["QuoteInclusionStatusEnum"];
            /** @description Indicates dollar amount of available reimbursement for member completing wellness initiative(s). */
            wellness: components["schemas"]["QuoteBenefitAmountDetails"];
            /** @description Indicates if annual open enrollment is included in the plan. */
            annualOpenEnrollment: components["schemas"]["QuoteAnnualOpenEnrollmentEnum"];
        } & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            objectType: RfpHospitalIndemnityBenefitObjectType;
        };
        /**
         * @description Indicates the type of benefit available for Quote.
         * @enum {string}
         */
        QuoteCancerAmountBenefitTypeEnum: QuoteVisionCopayRuleTypeEnum;
        QuoteCancerAmountBenefit: {
            type: components["schemas"]["QuoteCancerAmountBenefitTypeEnum"];
            /** @description The dollar amount of the benefit. Omit if type is not dollarAmount. */
            amount?: number;
        };
        /**
         * @description Indicates the type of hospice benefit available for Quote.
         * @enum {string}
         */
        QuoteCancerHospiceBenefitTypeEnum: QuoteCancerHospiceBenefitTypeEnum;
        QuoteCancerHospiceBenefit: {
            type: components["schemas"]["QuoteCancerHospiceBenefitTypeEnum"];
            /** @description The dollar amount of the hospice benefit. Omit if type is not dollarAmount or dollarAmountPerDayPerLifetime. */
            amount?: number;
            /** @description The limit of days per lifetime that this benefit is available. 0 is unlimited. */
            duration?: number;
        };
        /**
         * @description Indicates the type of schedule benefit available for Quote.
         * @enum {string}
         */
        QuoteCancerScheduleBenefitTypeEnum: QuoteCancerScheduleBenefitTypeEnum;
        QuoteCancerScheduleBenefit: {
            type: components["schemas"]["QuoteCancerScheduleBenefitTypeEnum"];
            /** @description The dollar amount of the schedule benefit. Omit if type is not scheduleUpToDollarAmount. */
            amount?: number;
        };
        QuoteCancerBenefit: components["schemas"]["BaseCancerBenefit"] & {
            /** @description The dollar benefit available when a cancer diagnosis is made. */
            diagnosisBenefit: components["schemas"]["QuoteCancerAmountBenefit"];
            /** @description The benefit available for radiation/chemo. This can be a schedule or a flat dollar amount. This field will show the maximum available. */
            radiationTherapyChemo: components["schemas"]["QuoteCancerAmountBenefit"];
            /** @description The benefit available for services related to blood/plasma/platelets. */
            bloodPlasmaPlatelets: components["schemas"]["QuoteCancerAmountBenefit"];
            /** @description The daily amount available when on hospice.  Also the limit of days per lifetime that this benefit is available. */
            hospice: components["schemas"]["QuoteCancerHospiceBenefit"];
            /** @description Indicates dollar amount carrier will cover as benefit for this service, including any conditional requirements. */
            hospitalConfinementInitial: components["schemas"]["QuoteCancerAmountBenefit"];
            /** @description Indicates dollar amount carrier will cover as benefit for this service, including any conditional requirements. */
            icuConfinementInitial: components["schemas"]["QuoteCancerAmountBenefit"];
            /** @description The benefit for skin cancer treatment. */
            skinCancer: components["schemas"]["QuoteCancerScheduleBenefit"];
            /** @description The benefit for surgical procedures. */
            surgicalBenefit: components["schemas"]["QuoteCancerScheduleBenefit"];
            preExistingCondition: components["schemas"]["QuotePreExistingCondition"];
            portability: components["schemas"]["QuoteInclusionStatusEnum"];
            /** @description The wellness benefit available. */
            wellnessBenefit: components["schemas"]["QuoteCancerAmountBenefit"];
            waiverOfPremium: components["schemas"]["QuoteInclusionStatusEnum"];
            annualOpenEnrollment: components["schemas"]["QuoteAnnualOpenEnrollmentEnum"];
        } & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            objectType: CancerObjectTypeEnum;
        };
        /**
         * @description The type of coverage for Quote.
         * @enum {string}
         */
        QuoteFmlBenefitTypeEnum: QuoteFmlBenefitTypeEnum;
        QuoteFmlBenefitType: {
            /** @description The type of coverage. */
            type: components["schemas"]["QuoteFmlBenefitTypeEnum"];
            /** @description The dollar amount if type is additionalDollarAmount. Omit otherwise. */
            amount?: number;
        };
        /**
         * @description Confirms if the plan is integrated with disability for Quote.
         * @enum {string}
         */
        QuoteIntegratedStdFmlaClaimIntakeEnum: QuoteInclusionStatusEnum;
        QuoteFmlBenefit: components["schemas"]["BaseFmlBenefit"] & {
            /** @description Indicates if federal leaves are included in the provided plan. */
            federalFmla: components["schemas"]["QuoteFmlBenefitType"];
            /** @description Indicates if additional unpaid state leaves are included in the provided plan. */
            unpaidStateLeaves: components["schemas"]["QuoteFmlBenefitType"];
            /** @description Indicates if military leaves are included in the provided plan. */
            militaryUserra: components["schemas"]["QuoteFmlBenefitType"];
            /** @description Indicates if jury duty is included in the provided plan. */
            juryDuty: components["schemas"]["QuoteFmlBenefitType"];
            /** @description Indicates if ADA is included in the base price or for additional charge. */
            ada: components["schemas"]["QuoteFmlBenefitType"];
            /** @description Confirms if the plan is integrated with disability. */
            integratedStdFmlaClaimIntake: components["schemas"]["QuoteIntegratedStdFmlaClaimIntakeEnum"];
        } & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            objectType: QuoteFmlBenefitObjectType;
        };
        /**
         * @description Indicates which product the EAP is tied to for Quote.
         * @enum {string}
         */
        QuoteTiedToAnotherLocEnum: QuoteTiedToAnotherLocEnum;
        QuoteEapBenefit: components["schemas"]["BaseEapBenefit"] & {
            /** @description Indicates if telephonic visits are unlimited or not. */
            unlimitedTelephonic: components["schemas"]["QuoteInclusionStatusEnum"];
            /** @description Indicates which, if any product the EAP is tied to. */
            tiedToAnotherLoc: components["schemas"]["QuoteTiedToAnotherLocEnum"];
        } & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            objectType: EapObjectTypeEnum;
        };
        /**
         * @description Describes the LTD plan design type for Quote.
         * @enum {string}
         */
        QuoteLtdPlanDesignTypeEnum: RfpLtdPlanDesignTypeEnum;
        /**
         * @description Describes the IDI plan design type for Quote.
         * @enum {string}
         */
        QuoteIdiPlanDesignTypeEnum: RfpIdiPlanDesignTypeEnum;
        /**
         * @description The type of own occupation period for Quote.
         * @enum {string}
         */
        QuoteIndividualDisabilityOwnOccupationPeriodTypeEnum: QuoteLtdOwnOccupationPeriodTypeEnum;
        /**
         * @description The mental illness benefit type for Quote.
         * @enum {string}
         */
        QuoteIndividualDisabilityMentalIllnessBenefitTypeEnum: QuoteLtdOtherLimitationsEnum;
        /**
         * @description Indicates if a recovery benefit is included in the IDI offering for Quote.
         * @enum {string}
         */
        QuoteRecoveryBenefitEnum: QuoteRecoveryBenefitEnum;
        /**
         * @description Indicates the benefit allowed for a catastrophic benefit for Quote.
         * @enum {string}
         */
        QuoteCatastrophicBenefitEnum: QuoteCatastrophicBenefitEnum;
        QuoteIndividualDisabilityBenefit: components["schemas"]["BaseIndividualDisabilityBenefit"] & {
            /** @description Indicates the benefit amount and benefit maximum of the existing LTD plan design. */
            ltdPlanDesign: {
                type: components["schemas"]["QuoteLtdPlanDesignTypeEnum"];
                /** @description The plan design amount. Omit if not applicable. */
                amount?: number;
            };
            /** @description Indicates the plan design offered with the extra IDI coverage. */
            idiPlanDesign: {
                type: components["schemas"]["QuoteIdiPlanDesignTypeEnum"];
                /** @description The percentage amount. Omit if not percentage or percentageToDollarAmount. */
                percentageAmount?: number;
                /** @description The dollar amount. Omit if not percentageToDollarAmount. */
                dollarAmount?: number;
            };
            /** @description Indicates the maximum dollar amount of benefit allowed. */
            gsiBenefitMaximum: number;
            /** @description Indicates the own occupation period. */
            ownOccupationPeriod: {
                type: components["schemas"]["QuoteIndividualDisabilityOwnOccupationPeriodTypeEnum"];
                /** @description The amount of time for own occupation period. Omit if not applicable. */
                amount?: number;
            };
            /** @description Indicates the period of time after participant becomes disabled that must pass before they begin receiving benefit. */
            eliminationPeriodDays: number;
            preExistingCondition: components["schemas"]["QuotePreExistingCondition"];
            /** @description Indicates the time period limitation of benefit duration for mental illness. */
            mentalIllnessBenefit: {
                type: components["schemas"]["QuoteIndividualDisabilityMentalIllnessBenefitTypeEnum"];
                /** @description The mental illness timeframe. Omit if not applicable. */
                timeframe?: number;
            };
            /** @description Indicates if a recovery benefit is included in the IDI offering. */
            recoveryBenefit: {
                type: components["schemas"]["QuoteRecoveryBenefitEnum"];
                /** @description The dollar amount for the recovery benefit. Omit if type is not dollarAmount. */
                amount?: number;
            };
            /** @description Indicates the benefit allowed for a catastrophic benefit. */
            catastrophicBenefit: {
                type: components["schemas"]["QuoteCatastrophicBenefitEnum"];
                /** @description The percentage amount for the catastrophic benefit. Omit if type is not percentageAmount. */
                amount?: number;
            };
            /** @description Indicates if policy holder can continue policy after separation of employment and whether Evidence of Insurability would be required. */
            portability?: components["schemas"]["QuoteInclusionStatusEnum"];
        } & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            objectType: QuoteIndividualDisabilityBenefitObjectType;
        };
        /**
         * @description Indicates when the plan will be initiated for Quote.
         * @enum {string}
         */
        QuoteWholeLifeCoverageEffectiveDateEnum: QuoteWholeLifeCoverageEffectiveDateEnum;
        /**
         * @description Describes the dependent benefit configuration available for Quote.
         * @enum {string}
         */
        QuoteDependentBenefitTypeEnum: QuoteVisionCopayRuleTypeEnum;
        /** @description Indicates the amount of benefit available for a dependent. */
        QuoteDependentBenefit: {
            type: components["schemas"]["QuoteDependentBenefitTypeEnum"];
            /** @description The dependent benefit dollar amount. Omit if type is notIncluded or notOffered. */
            amount?: number;
        };
        QuoteWholeLifeBenefit: components["schemas"]["BaseWholeLifeBenefit"] & {
            portability: components["schemas"]["QuoteInclusionStatusEnum"];
            /** @description Indicates when the plan will be initiated. */
            coverageEffectiveDate: components["schemas"]["QuoteWholeLifeCoverageEffectiveDateEnum"];
            annualOpenEnrollment: components["schemas"]["QuoteAnnualOpenEnrollmentEnum"];
            spouseBenefitAmount: components["schemas"]["QuoteDependentBenefit"];
            spouseBenefitMaximum: components["schemas"]["QuoteDependentBenefit"];
            childBenefitAmount: components["schemas"]["QuoteDependentBenefit"];
            childBenefitMaximum: components["schemas"]["QuoteDependentBenefit"];
            /** @description Indicates if LTC is covered under the plan quoted. */
            longTermCare: string;
        } & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            objectType: WholeLifeObjectTypeEnum;
        };
        QuoteBenefitPlan: components["schemas"]["BaseBenefitPlan"] & {
            /** @description Display name of the Benefit Plan. This is the name used in booklets and other published materials. */
            name?: string;
            /** @description The number of employees eligible to enroll in this plan. */
            numberOfLives?: number;
            /** @description This is the time frame in which the rates are guaranteed to stay the same. */
            rateGuarantee?: {
                type: components["schemas"]["RateGuaranteeTypeEnum"];
                amount?: number;
            };
            /** @description Indicates if there is a cap to rate increases for any specific time. */
            rateCap?: string;
        } & {
            benefits?: components["schemas"]["QuoteDentalBenefit"] | components["schemas"]["QuoteVisionBenefit"] | components["schemas"]["QuoteBasicLifeAdndBenefit"] | components["schemas"]["QuoteVoluntaryLifeAdndBenefit"] | components["schemas"]["QuoteStdBenefit"] | components["schemas"]["QuoteLtdBenefit"] | components["schemas"]["QuoteCriticalIllnessBenefit"] | components["schemas"]["QuoteAccidentBenefit"] | components["schemas"]["QuoteHospitalIndemnityBenefit"] | components["schemas"]["QuoteCancerBenefit"] | components["schemas"]["QuoteFmlBenefit"] | components["schemas"]["QuoteEapBenefit"] | components["schemas"]["QuoteIndividualDisabilityBenefit"] | components["schemas"]["QuoteWholeLifeBenefit"];
        };
        ProposalCoverage: components["schemas"]["BaseCoverage"] & {
            /** @description Indicates if the coverage was quoted or declined. */
            status: components["schemas"]["ProposalCoverageStatusEnum"];
            /** @description When status is declinedToQuote, this indicates the reason. */
            statusReason?: components["schemas"]["DeclineReasonEnum"];
            /** @description When statusReason is other, this freeform field should be used to explain the reason. */
            statusReasonOther?: string;
            benefitPlans: components["schemas"]["QuoteBenefitPlan"][];
        };
        ProposalCommissions: components["schemas"]["CommissionsBase"] & {
            /** @description Type of commission being proposed. */
            proposalType: components["schemas"]["CommissionTypeEnum"];
            proposalAmount?: components["schemas"]["FlatAmount"];
            proposalHeapedAmount?: components["schemas"]["HeapedAmount"];
        };
        GroupProposal: {
            /** @description This is the unique identifier generated by the carrier for the Proposal. */
            carrierIssuedIdentifier: string;
            /** @description This is the carrierIssuedIdentifier of the RFP for which this Proposal has been generated. */
            rfpIdentifier: string;
            /** @description This is the version number of the RFP that was submitted for this Proposal. */
            rfpVersionNumber: number;
            /** @description Carriers must send the full benefit class list back if they make any updates. */
            benefitClasses?: components["schemas"]["BenefitClass"][];
            /** @description This is the list of coverages being quoted. */
            coverages: components["schemas"]["ProposalCoverage"][];
            /** @description Premium percentage that is retained and allocated to Producers in the form of commission. */
            commissions: components["schemas"]["ProposalCommissions"][];
            benAdmin: components["schemas"]["BenAdmin"];
            /** @description Notes to be accompanied with the proposal for any extra information. */
            notes?: string;
            /** @description This is the representative at the carrier for this proposal. This is the person the analyst will reach out to with questions or clarifications. */
            carrierContact: components["schemas"]["ContactSlim"];
            /**
             * Format: date
             * @description This is the date after which the proposal is considered as expired. ISO-8601 standard.
             */
            expirationDate?: string;
            /**
             * Format: date
             * @description This is the quote effective date, in case the carrier is unable to honor the requested effective date on RFP for some reason. Populate with the requested effective date, otherwise.
             */
            effectiveDate: string;
            /** @description This is the list of documents associated with this Proposal. */
            files: components["schemas"]["File"][];
        };
        /** @description This is the Ecosystem's internal identifier for the carrier. */
        identifier: string;
        /**
         * @description This is the event type for which the notification is sent.
         * @enum {string}
         */
        RfpqEventTypeEnum: RfpqEventTypeEnum;
        /** @description This is the definition of the event that occurred. */
        RfpqEvent: {
            /**
             * Format: date-time
             * @description This is the timestamp when the event occurred, which follows the ISO 8601 format
             */
            timestamp: string;
            type: components["schemas"]["RfpqEventTypeEnum"];
            /** @description When type is declinedToQuote, this indicates the reason. */
            typeReason?: components["schemas"]["DeclineReasonEnum"];
            /** @description When typeReason is other, this freeform field should be used to explain the reason. */
            typeReasonOther?: string;
        };
        /** @description This is event type specific data structure that holds the data specific to the event that occurred. */
        RfpqEventData: {
            /** @description This is the carrierIssuedIdentifier of the RFP for which the proposal is generated. */
            rfpIdentifier: string;
            /** @description The version number of the RFP that was sent in the rfp submission for which this quote is generated. */
            rfpVersionNumber?: number;
            /**
             * @description This is the identifier of the proposal to be retrieved, at the carrier system.
             * @example d291232f-6c29-23c5-e958-4ef894fc9da2
             */
            proposalIdentifier?: string;
            /** @description This is additional notes for the event. This can also be used for reason of the change. */
            notes?: string;
        };
        /** @description This is the definition of event notification structure used to notify about different events in a Group Insurance lifecycle. */
        RfpqEventNotification: {
            event: components["schemas"]["RfpqEvent"];
            data: components["schemas"]["RfpqEventData"];
        };
    };
    responses: {
        /** @description Bad Request */
        BadRequest: {
            headers: {
                [name: string]: unknown;
            };
            content: {
                "application/json": components["schemas"]["Error"];
            };
        };
        /** @description Unauthorized */
        Unauthorized: {
            headers: {
                [name: string]: unknown;
            };
            content: {
                "application/json": components["schemas"]["Error"];
            };
        };
        /** @description Forbidden */
        Forbidden: {
            headers: {
                [name: string]: unknown;
            };
            content: {
                "application/json": components["schemas"]["Error"];
            };
        };
        /** @description Validation Error */
        ValidationError: {
            headers: {
                [name: string]: unknown;
            };
            content: {
                "application/json": components["schemas"]["ValidationError"];
            };
        };
        /** @description Internal Server Error */
        InternalServerError: {
            headers: {
                [name: string]: unknown;
            };
            content: {
                "application/json": components["schemas"]["Error"];
            };
        };
        /** @description Not Found */
        NotFound: {
            headers: {
                [name: string]: unknown;
            };
            content: {
                "application/json": components["schemas"]["Error"];
            };
        };
        /** @description File Not Found */
        FileNotFound: {
            headers: {
                [name: string]: unknown;
            };
            content: {
                "application/json": components["schemas"]["Error"];
            };
        };
    };
    parameters: {
        /** @description This is the standard HTTP content type header. This request must be sent with the content type of application/json. Suffixes such as charset=utf-8 are allowed. */
        ContentTypeJsonHeader: string;
        /** @description This is a unique identifier created by the originator for this HTTP request. It is used for log/trace correlation. */
        TraceIdHeader: string;
        /** @description Identifies the sender's environment name e.g. QAT, UAT, PROD. */
        EnvironmentNameHeader: string;
        /** @description This is the carrierIssuedIdentifier for the RFP being submitted for re-quote. */
        rfpCarrierIssuedIdentifier: string;
        /** @description This is the carrierIssuedIdentifier for the RFP that the proposal belongs to. */
        proposalCarrierIssuedIdentifier: string;
        /** @description This is the carrierIssuedIdentifier for the proposal being retrieved. */
        proposalIdentifier: string;
        /** @description The shared Ecosystem identifier of the carrier */
        carrierIdentifier: components["schemas"]["identifier"];
        /** @description This is the standard HTTP content type header. This request must be sent with the content type of multipart/form-data. */
        ContentTypeMultipartHeader: string;
        /** @description This is the standard HTTP accept header. This request must be sent with the accept header set to application/octet-stream. */
        AcceptBinaryHeader: string;
        /** @description The unique identifier of the file to be downloaded. */
        fileIdentifier: string;
    };
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
    createRfp: {
        parameters: {
            query?: never;
            header: {
                /** @description This is the standard HTTP content type header. This request must be sent with the content type of application/json. Suffixes such as charset=utf-8 are allowed. */
                "content-type": components["parameters"]["ContentTypeJsonHeader"];
                /** @description This is a unique identifier created by the originator for this HTTP request. It is used for log/trace correlation. */
                "x-trace-id": components["parameters"]["TraceIdHeader"];
                /** @description Identifies the sender's environment name e.g. QAT, UAT, PROD. */
                "x-environment-name": components["parameters"]["EnvironmentNameHeader"];
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PostGroupRfp"];
            };
        };
        responses: {
            /** @description RFP created. */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GroupRfp"];
                };
            };
            400: components["responses"]["BadRequest"];
            401: components["responses"]["Unauthorized"];
            403: components["responses"]["Forbidden"];
            422: components["responses"]["ValidationError"];
            500: components["responses"]["InternalServerError"];
        };
    };
    replaceRfp: {
        parameters: {
            query?: never;
            header: {
                /** @description This is the standard HTTP content type header. This request must be sent with the content type of application/json. Suffixes such as charset=utf-8 are allowed. */
                "content-type": components["parameters"]["ContentTypeJsonHeader"];
                /** @description This is a unique identifier created by the originator for this HTTP request. It is used for log/trace correlation. */
                "x-trace-id": components["parameters"]["TraceIdHeader"];
                /** @description Identifies the sender's environment name e.g. QAT, UAT, PROD. */
                "x-environment-name": components["parameters"]["EnvironmentNameHeader"];
            };
            path: {
                /** @description This is the carrierIssuedIdentifier for the RFP being submitted for re-quote. */
                carrierIssuedIdentifier: components["parameters"]["rfpCarrierIssuedIdentifier"];
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["GroupRfp"];
            };
        };
        responses: {
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            400: components["responses"]["BadRequest"];
            401: components["responses"]["Unauthorized"];
            403: components["responses"]["Forbidden"];
            422: components["responses"]["ValidationError"];
            500: components["responses"]["InternalServerError"];
        };
    };
    getProposal: {
        parameters: {
            query?: never;
            header: {
                /** @description This is a unique identifier created by the originator for this HTTP request. It is used for log/trace correlation. */
                "x-trace-id": components["parameters"]["TraceIdHeader"];
                /** @description Identifies the sender's environment name e.g. QAT, UAT, PROD. */
                "x-environment-name": components["parameters"]["EnvironmentNameHeader"];
            };
            path: {
                /** @description This is the carrierIssuedIdentifier for the RFP that the proposal belongs to. */
                carrierIssuedIdentifier: components["parameters"]["proposalCarrierIssuedIdentifier"];
                /** @description This is the carrierIssuedIdentifier for the proposal being retrieved. */
                proposalIdentifier: components["parameters"]["proposalIdentifier"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GroupProposal"];
                };
            };
            400: components["responses"]["BadRequest"];
            401: components["responses"]["Unauthorized"];
            403: components["responses"]["Forbidden"];
            404: components["responses"]["NotFound"];
            500: components["responses"]["InternalServerError"];
        };
    };
    rfpqEventSubmit: {
        parameters: {
            query?: never;
            header: {
                /** @description This is the standard HTTP content type header. This request must be sent with the content type of application/json. Suffixes such as charset=utf-8 are allowed. */
                "content-type": components["parameters"]["ContentTypeJsonHeader"];
                /** @description This is a unique identifier created by the originator for this HTTP request. It is used for log/trace correlation. */
                "x-trace-id": components["parameters"]["TraceIdHeader"];
                /** @description Identifies the sender's environment name e.g. QAT, UAT, PROD. */
                "x-environment-name": components["parameters"]["EnvironmentNameHeader"];
            };
            path: {
                /** @description The shared Ecosystem identifier of the carrier */
                carrierIdentifier: components["parameters"]["carrierIdentifier"];
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["RfpqEventNotification"];
            };
        };
        responses: {
            /** @description Event notification received. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            400: components["responses"]["BadRequest"];
            401: components["responses"]["Unauthorized"];
            403: components["responses"]["Forbidden"];
            422: components["responses"]["ValidationError"];
            500: components["responses"]["InternalServerError"];
        };
    };
    uploadFile: {
        parameters: {
            query?: never;
            header: {
                /** @description This is the standard HTTP content type header. This request must be sent with the content type of multipart/form-data. */
                "content-type": components["parameters"]["ContentTypeMultipartHeader"];
                /** @description This is a unique identifier created by the originator for this HTTP request. It is used for log/trace correlation. */
                "x-trace-id": components["parameters"]["TraceIdHeader"];
                /** @description Identifies the sender's environment name e.g. QAT, UAT, PROD. */
                "x-environment-name": components["parameters"]["EnvironmentNameHeader"];
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": {
                    /**
                     * Format: binary
                     * @description The file contents
                     */
                    file: string;
                    /** @description The name of the file */
                    name: string;
                };
            };
        };
        responses: {
            /** @description The file was successfully uploaded */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["File"];
                };
            };
            400: components["responses"]["BadRequest"];
            401: components["responses"]["Unauthorized"];
            403: components["responses"]["Forbidden"];
            /** @description File Too Large */
            413: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
            500: components["responses"]["InternalServerError"];
        };
    };
    downloadFile: {
        parameters: {
            query?: never;
            header: {
                /** @description This is the standard HTTP accept header. This request must be sent with the accept header set to application/octet-stream. */
                accept: components["parameters"]["AcceptBinaryHeader"];
                /** @description This is a unique identifier created by the originator for this HTTP request. It is used for log/trace correlation. */
                "x-trace-id": components["parameters"]["TraceIdHeader"];
                /** @description Identifies the sender's environment name e.g. QAT, UAT, PROD. */
                "x-environment-name": components["parameters"]["EnvironmentNameHeader"];
            };
            path: {
                /** @description The unique identifier of the file to be downloaded. */
                fileIdentifier: components["parameters"]["fileIdentifier"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description The file was found and can be downloaded */
            200: {
                headers: {
                    /**
                     * @description Use attachment as the first parameter, and include the filename as the second parameter.
                     * @example attachment; filename="example.txt"
                     */
                    "Content-Disposition": string;
                    /**
                     * @description The MIME type of the file being downloaded.
                     * @example application/pdf
                     */
                    "Content-Type"?: string;
                    [name: string]: unknown;
                };
                content: {
                    "*/*": string;
                };
            };
            400: components["responses"]["BadRequest"];
            401: components["responses"]["Unauthorized"];
            403: components["responses"]["Forbidden"];
            404: components["responses"]["FileNotFound"];
            500: components["responses"]["InternalServerError"];
        };
    };
}
export enum StateTerritoryCodeEnum {
    AL = "AL",
    AK = "AK",
    AS = "AS",
    AZ = "AZ",
    AR = "AR",
    CA = "CA",
    CO = "CO",
    CT = "CT",
    DE = "DE",
    DC = "DC",
    FM = "FM",
    FL = "FL",
    GA = "GA",
    GU = "GU",
    HI = "HI",
    ID = "ID",
    IL = "IL",
    IN = "IN",
    IA = "IA",
    KS = "KS",
    KY = "KY",
    LA = "LA",
    ME = "ME",
    MH = "MH",
    MD = "MD",
    MA = "MA",
    MI = "MI",
    MN = "MN",
    MS = "MS",
    MO = "MO",
    MT = "MT",
    NE = "NE",
    NV = "NV",
    NH = "NH",
    NJ = "NJ",
    NM = "NM",
    NY = "NY",
    NC = "NC",
    ND = "ND",
    MP = "MP",
    OH = "OH",
    OK = "OK",
    OR = "OR",
    PW = "PW",
    PA = "PA",
    PR = "PR",
    RI = "RI",
    SC = "SC",
    SD = "SD",
    TN = "TN",
    TX = "TX",
    UT = "UT",
    VT = "VT",
    VA = "VA",
    VI = "VI",
    WA = "WA",
    WV = "WV",
    WI = "WI",
    WY = "WY"
}
export enum CountryCodeEnum {
    US = "US",
    CA = "CA",
    MX = "MX"
}
export enum BenAdminNameEnum {
    employeeNavigator = "employeeNavigator",
    ease = "ease",
    bSwift = "bSwift",
    adp = "adp",
    planSource = "planSource",
    paychex = "paychex",
    triNet = "triNet",
    rippling = "rippling",
    paylocity = "paylocity",
    selerix = "selerix",
    zenefits = "zenefits",
    workday = "workday",
    paycom = "paycom",
    none = "none",
    other = "other"
}
export enum EmploymentTypeEnum {
    fullTime = "fullTime",
    partTime = "partTime"
}
export enum GenderCodeEnum {
    male = "male",
    female = "female",
    nonBinary = "nonBinary"
}
export enum EmploymentStatusEnum {
    active = "active",
    retired = "retired",
    cobra = "cobra",
    onLeave = "onLeave",
    terminated = "terminated"
}
export enum CoverageTypeEnum {
    dental = "dental",
    vision = "vision",
    std = "std",
    ltd = "ltd",
    basicLifeAdnd = "basicLifeAdnd",
    voluntaryLifeAdnd = "voluntaryLifeAdnd",
    accident = "accident",
    criticalIllness = "criticalIllness",
    hospitalIndemnity = "hospitalIndemnity",
    cancer = "cancer",
    fmla = "fmla",
    eap = "eap",
    individualDisabilityInsurance = "individualDisabilityInsurance",
    wholeLife = "wholeLife"
}
export enum CoverageTierEnum {
    employee = "employee",
    employeeDependent = "employeeDependent",
    employeeSpouse = "employeeSpouse",
    employeeChildren = "employeeChildren",
    employeeFamily = "employeeFamily",
    employee2Dependents = "employee2Dependents",
    spouseOnly = "spouseOnly",
    spouseDependent = "spouseDependent",
    spouseChildren = "spouseChildren",
    childOnly = "childOnly"
}
export enum CoverageAmountTypeEnum {
    flatAmount = "flatAmount",
    salaryMultiplier = "salaryMultiplier",
    percentage = "percentage"
}
export enum CurrentCommissionTypeEnum {
    heaped = "heaped",
    percentage = "percentage",
    standard = "standard",
    graded = "graded",
    net = "net",
    pepm = "pepm",
    notApplicable = "notApplicable"
}
export enum CommissionTypeEnum {
    heaped = "heaped",
    percentage = "percentage",
    standard = "standard",
    graded = "graded",
    net = "net",
    pepm = "pepm"
}
export enum GeneralAgentNameEnum {
    Centro_Benefits_Research_LLC = "Centro Benefits Research, LLC"
}
export enum UnsupportedCoverageTypeEnum {
    pet = "pet",
    legal = "legal",
    smd = "smd",
    gvul = "gvul",
    gul = "gul",
    other = "other"
}
export enum TechCreditTypeEnum {
    percentage = "percentage",
    dollarAmount = "dollarAmount",
    pepm = "pepm",
    carrierStandard = "carrierStandard"
}
export enum PostRfpCoverageStatusEnum {
    quoteNeeded = "quoteNeeded"
}
export enum BenefitPlanTypeEnum {
    ppo = "ppo",
    hmo = "hmo",
    epo = "epo",
    pos = "pos",
    indemnity = "indemnity",
    notApplicable = "notApplicable"
}
export enum FundingTypeEnum {
    fullyInsured = "fullyInsured",
    selfFundedASO = "selfFundedASO",
    selfFundedATP = "selfFundedATP",
    checkCutting = "checkCutting",
    levelFunded = "levelFunded",
    notApplicable = "notApplicable"
}
export enum OptionNameEnum {
    high = "high",
    medium = "medium",
    low = "low",
    notApplicable = "notApplicable"
}
export enum RateDesignEnum {
    composite = "composite",
    gender = "gender",
    flatRate = "flatRate",
    ageBanded = "ageBanded",
    ageBandedGender = "ageBandedGender",
    ageBandedTobacco = "ageBandedTobacco",
    ageBandedTiered = "ageBandedTiered"
}
export enum RateGenderEnum {
    male = "male",
    female = "female"
}
export enum RateUnitEnum {
    usd = "usd",
    volumePer10 = "volumePer10",
    volumePer100 = "volumePer100",
    volumePer1000 = "volumePer1000",
    per10OfSalary = "per10OfSalary",
    per100OfSalary = "per100OfSalary",
    per1000OfSalary = "per1000OfSalary",
    fmlaPepm = "fmlaPepm",
    adaPepm = "adaPepm",
    totalPepm = "totalPepm"
}
export enum RateCoverageIndicatorEnum {
    life = "life",
    adnd = "adnd"
}
export enum PolicyPeriodEnum {
    newBusiness = "newBusiness",
    current = "current",
    alternate = "alternate"
}
export enum DentalObjectTypeEnum {
    dental = "dental"
}
export enum ServiceWaitingPeriodTypeEnum {
    preventive = "preventive",
    basic = "basic",
    major = "major",
    ortho = "ortho",
    sealants = "sealants",
    spaceMaintainers = "spaceMaintainers",
    generalAnesthesia = "generalAnesthesia",
    compositeWhiteFillings = "compositeWhiteFillings",
    endodontics = "endodontics",
    periodonticsSurgical = "periodonticsSurgical",
    periodonticsNonSurgical = "periodonticsNonSurgical",
    oralSurgerySimple = "oralSurgerySimple",
    oralSurgeryComplex = "oralSurgeryComplex",
    implants = "implants"
}
export enum EmployerContributionEnum {
    oneHundredPercentEmployerPaid = "oneHundredPercentEmployerPaid",
    contributory = "contributory",
    voluntary = "voluntary",
    bonusUp = "bonusUp",
    grossUp = "grossUp",
    taxChoice = "taxChoice",
    notIncluded = "notIncluded"
}
export enum NetworkEnum {
    inNetwork = "inNetwork",
    outOfNetwork = "outOfNetwork"
}
export enum IndividualDeductibleEnum {
    dollarAmount = "dollarAmount"
}
export enum RfpDollarBenefitEnum {
    dollarAmount = "dollarAmount",
    dollarAmountPerPerson = "dollarAmountPerPerson",
    notIncluded = "notIncluded"
}
export enum RfpPercentageBenefitTypeEnum {
    percentageAmount = "percentageAmount",
    notIncluded = "notIncluded"
}
export enum RfpDentalServiceCategoryEnum {
    preventive = "preventive",
    basic = "basic",
    major = "major",
    notIncluded = "notIncluded"
}
export enum RfpOrthoAgeLimitTypeEnum {
    childrenOnlyToAge = "childrenOnlyToAge",
    adultAndChildren = "adultAndChildren",
    childrenOnlyAgeNotDisclosed = "childrenOnlyAgeNotDisclosed",
    notApplicable = "notApplicable",
    notIncluded = "notIncluded"
}
export enum OutOfNetworkReimbursementEnum {
    Value45thUcr = "45thUcr",
    Value50thUcr = "50thUcr",
    Value51stUcr = "51stUcr",
    Value70thUcr = "70thUcr",
    Value75thUcr = "75thUcr",
    Value80thUcr = "80thUcr",
    Value85thUcr = "85thUcr",
    Value90thUcr = "90thUcr",
    Value95thUcr = "95thUcr",
    Value99thUcr = "99thUcr",
    mac = "mac",
    mpa = "mpa",
    feeSchedule = "feeSchedule",
    notIncluded = "notIncluded"
}
export enum RfpInclusionStatusEnum {
    included = "included",
    notIncluded = "notIncluded"
}
export enum RfpAnnualOpenEnrollmentEnum {
    oneTimeOpenEnrollment = "oneTimeOpenEnrollment",
    annualOpenEnrollment = "annualOpenEnrollment",
    modifiedOpenEnrollment = "modifiedOpenEnrollment",
    included = "included",
    notIncluded = "notIncluded"
}
export enum RfpDeductibleDurationEnum {
    calendarYear = "calendarYear",
    lifetime = "lifetime",
    notIncluded = "notIncluded"
}
export enum VisionObjectTypeEnum {
    vision = "vision"
}
export enum InNetworkOnlyEnum {
    inNetwork = "inNetwork"
}
export enum RfpVisionCopayRuleTypeEnum {
    dollarAmount = "dollarAmount",
    notIncluded = "notIncluded"
}
export enum RfpVisionCopayFullAllowanceRuleTypeEnum {
    coveredInFullAfterCopay = "coveredInFullAfterCopay",
    coveredInFull = "coveredInFull",
    dollarAmountAllowance = "dollarAmountAllowance",
    dollarAmountAllowanceWithCopay = "dollarAmountAllowanceWithCopay",
    notIncluded = "notIncluded"
}
export enum RfpVisionCopayAllowanceRuleTypeEnum {
    coveredInFullAfterCopay = "coveredInFullAfterCopay",
    dollarAmountAllowance = "dollarAmountAllowance",
    dollarAmountAllowanceWithoutCopay = "dollarAmountAllowanceWithoutCopay",
    dollarAmountAllowanceWithCopay = "dollarAmountAllowanceWithCopay",
    notIncluded = "notIncluded"
}
export enum RfpVisionSpecialCopayAllowanceRuleTypeEnum {
    dollarAmountAllowance = "dollarAmountAllowance",
    dollarAmountAllowanceWithoutCopay = "dollarAmountAllowanceWithoutCopay",
    dollarAmountAllowanceWithCopay = "dollarAmountAllowanceWithCopay",
    notIncluded = "notIncluded"
}
export enum RfpFramesDiscountsRuleTypeEnum {
    upToPercentageOff = "upToPercentageOff",
    upToDollarAmountOff = "upToDollarAmountOff",
    notIncluded = "notIncluded"
}
export enum RfpVisionBenefitFrequencyOptionEnum {
    twelve = "twelve",
    twentyFour = "twentyFour",
    calendarYear = "calendarYear",
    everyOtherCalendarYear = "everyOtherCalendarYear",
    notIncluded = "notIncluded"
}
export enum RfpBasicLifeObjectTypeEnum {
    basicLifeAdnd = "basicLifeAdnd"
}
export enum RfpBasicLifeBenefitAmountTypeEnum {
    increments = "increments",
    dollarAmount = "dollarAmount",
    salaryMultiplier = "salaryMultiplier",
    salaryMultiplierPlusDollarAmount = "salaryMultiplierPlusDollarAmount"
}
export enum BenefitMaximumTypeEnum {
    dollarAmount = "dollarAmount",
    salaryMultiplier = "salaryMultiplier",
    lesserOfDollarAmountOrSalaryMultiplier = "lesserOfDollarAmountOrSalaryMultiplier"
}
export enum RfpBasicLifeGuaranteeIssueTypeEnum {
    dollarAmount = "dollarAmount",
    salaryMultiplierWithCap = "salaryMultiplierWithCap",
    salaryMultiplierWithDollarAmountPlusAdditionalAmount = "salaryMultiplierWithDollarAmountPlusAdditionalAmount",
    allGuaranteeIssue = "allGuaranteeIssue",
    notIncluded = "notIncluded"
}
export enum DefinitionOfEarningsTypeEnum {
    salary = "salary",
    salaryPlusCommissions = "salaryPlusCommissions",
    salaryPlusBonus = "salaryPlusBonus",
    salaryPlusBonusPlusCommissions = "salaryPlusBonusPlusCommissions",
    priorYearW2 = "priorYearW2",
    k1 = "k1",
    notApplicable = "notApplicable",
    notIncluded = "notIncluded"
}
export enum RfpPortabilityTypeEnum {
    included = "included",
    notIncluded = "notIncluded",
    includedWithEOI = "includedWithEOI",
    includedWithoutEOI = "includedWithoutEOI"
}
export enum RfpAgeReductionScheduleTypeEnum {
    percentageAtAge = "percentageAtAge",
    notIncluded = "notIncluded"
}
export enum RfpVoluntaryLifeEmployeeBenefitTypeEnum {
    increments = "increments",
    dollarAmount = "dollarAmount",
    multipleOptions = "multipleOptions",
    salaryMultiplier = "salaryMultiplier"
}
export enum RfpVoluntaryLifeGuaranteeIssueTypeEnum {
    dollarAmount = "dollarAmount",
    ageBasedAmounts = "ageBasedAmounts",
    salaryMultiplierWithCap = "salaryMultiplierWithCap",
    salaryMultiplierWithDollarAmountPlusAdditionalAmount = "salaryMultiplierWithDollarAmountPlusAdditionalAmount",
    allGuaranteeIssue = "allGuaranteeIssue",
    notIncluded = "notIncluded"
}
export enum RfpVoluntaryLifeSpouseChildBenefitTypeEnum {
    increments = "increments",
    dollarAmount = "dollarAmount",
    multipleOptions = "multipleOptions",
    percentageOfEmployeeElection = "percentageOfEmployeeElection",
    notIncluded = "notIncluded"
}
export enum RfpVoluntaryLifeAmountNotToExceedTypeEnum {
    percentageOfEmployeeElection = "percentageOfEmployeeElection",
    notApplicable = "notApplicable",
    notIncluded = "notIncluded"
}
export enum ChildBenefitAgeUnitEnum {
    days = "days",
    months = "months",
    years = "years"
}
export enum RfpVoluntaryLifeAdndTiedToLifeTypeEnum {
    tied = "tied",
    untied = "untied",
    clientLevelDecision = "clientLevelDecision"
}
export enum RfpVoluntaryLifeAdndBenefitObjectType {
    voluntaryLifeAdnd = "voluntaryLifeAdnd"
}
export enum StdObjectTypeEnum {
    std = "std"
}
export enum StdBenefitAmountTypeEnum {
    increments = "increments",
    flatAmount = "flatAmount",
    percentageOfSalary = "percentageOfSalary"
}
export enum MaximumAmountTypeEnum {
    dollarAmount = "dollarAmount",
    dollarAmountNotToExceedPercentageOfPredisabilityEarnings = "dollarAmountNotToExceedPercentageOfPredisabilityEarnings",
    unlimited = "unlimited"
}
export enum DefinitionOfDisabilityTypeEnum {
    lossOfDuties = "lossOfDuties",
    lossOfEarnings = "lossOfEarnings",
    lossOfEarningsAndDuties = "lossOfEarningsAndDuties",
    lossOfEarningsOrLossOfDuties = "lossOfEarningsOrLossOfDuties"
}
export enum RfpEliminationPeriodTypeEnum {
    days = "days",
    notIncluded = "notIncluded"
}
export enum RfpStdBenefitDurationTypeEnum {
    days = "days",
    weeks = "weeks",
    notIncluded = "notIncluded"
}
export enum RfpPreExistingConditionTypeEnum {
    months = "months",
    waived = "waived",
    none = "none"
}
export enum RfpBillableTypeEnum {
    billable = "billable",
    nonBillable = "nonBillable",
    notApplicable = "notApplicable",
    notIncluded = "notIncluded"
}
export enum LtdObjectTypeEnum {
    ltd = "ltd"
}
export enum RfpLtdOwnOccupationPeriodTypeEnum {
    yearsOwnOccupation = "yearsOwnOccupation",
    monthsOwnOccupation = "monthsOwnOccupation",
    ownOccupationOnly = "ownOccupationOnly",
    notIncluded = "notIncluded"
}
export enum RfpGainfulEarningsRuleTypeEnum {
    percentage = "percentage",
    notApplicable = "notApplicable",
    notIncluded = "notIncluded"
}
export enum BenefitDurationTypeEnum {
    ssnra = "ssnra",
    ssnraWithRbd = "ssnraWithRbd",
    rbdWithSsnra = "rbdWithSsnra",
    adea1WithSsnra = "adea1WithSsnra",
    adea1 = "adea1",
    adea2 = "adea2",
    adea3 = "adea3",
    adea4 = "adea4",
    twoYearAdea = "twoYearAdea",
    threeYearAdea = "threeYearAdea",
    fiveYearAdea = "fiveYearAdea",
    tenYearAdeaSchedule = "tenYearAdeaSchedule",
    reducingBenefitDuration = "reducingBenefitDuration",
    ssAdea = "ssAdea",
    toAge65 = "toAge65",
    toAge67 = "toAge67",
    laterOfAgeOrSsnra = "laterOfAgeOrSsnra",
    lesserOfRbdOrNumberOfYears = "lesserOfRbdOrNumberOfYears",
    yearDuration = "yearDuration",
    notIncluded = "notIncluded"
}
export enum RfpLtdOtherLimitationsEnum {
    years = "years",
    months = "months",
    noLimit = "noLimit",
    payableSameAsAnyOtherDisability = "payableSameAsAnyOtherDisability",
    included = "included",
    notIncluded = "notIncluded"
}
export enum RfpRehabTypeEnum {
    mandatory = "mandatory",
    mandatoryWithEnhanced = "mandatoryWithEnhanced",
    voluntary = "voluntary",
    voluntaryWithEnhanced = "voluntaryWithEnhanced",
    enhanced = "enhanced",
    notIncluded = "notIncluded"
}
export enum CriticalIllnessObjectTypeEnum {
    criticalIllness = "criticalIllness"
}
export enum CriticalIllnessEmployeeBenefitDescriptionTypeEnum {
    increments = "increments",
    percentage = "percentage",
    dollarAmount = "dollarAmount",
    multipleOptions = "multipleOptions"
}
export enum CriticalIllnessEmployeeMaximumTypeEnum {
    dollarAmount = "dollarAmount",
    percentageOfEeBenefit = "percentageOfEeBenefit",
    percentageOfEeBenefitAndDollarAmount = "percentageOfEeBenefitAndDollarAmount"
}
export enum RfpCriticalIllnessEmployeeGuaranteeIssueTypeEnum {
    percentageOfEeBenefit = "percentageOfEeBenefit",
    flatAmount = "flatAmount",
    notIncluded = "notIncluded"
}
export enum RfpCriticalIllnessSpouseBenefitDescriptionTypeEnum {
    increments = "increments",
    percentage = "percentage",
    dollarAmount = "dollarAmount",
    multipleOptions = "multipleOptions",
    notIncluded = "notIncluded"
}
export enum RfpCriticalIllnessSpouseMaximumTypeEnum {
    dollarAmount = "dollarAmount",
    percentageOfEeBenefit = "percentageOfEeBenefit",
    percentageOfEeBenefitAndDollarAmount = "percentageOfEeBenefitAndDollarAmount",
    notIncluded = "notIncluded"
}
export enum RfpIllnessTypeEnum {
    percentage = "percentage",
    notIncluded = "notIncluded"
}
export enum RfpMaximumPayoutTypeEnum {
    dollarAmount = "dollarAmount",
    percentage = "percentage",
    noLimit = "noLimit",
    unlimited = "unlimited",
    willNotPayForThirdOrLaterOccurrence = "willNotPayForThirdOrLaterOccurrence",
    notIncluded = "notIncluded"
}
export enum RfpOccurrenceTypeEnum {
    months = "months",
    included = "included",
    notIncluded = "notIncluded"
}
export enum RfpAgeBasisEnum {
    issueAge = "issueAge",
    attainedAge = "attainedAge",
    notIncluded = "notIncluded"
}
export enum RfpAccidentCoverageTypeEnum {
    onAndOffJob = "onAndOffJob",
    offJob = "offJob"
}
export enum RfpAccidentSpecificBenefitTypeEnum {
    dollarAmount = "dollarAmount",
    includedInLumpSumBenefitPayout = "includedInLumpSumBenefitPayout",
    notIncluded = "notIncluded"
}
export enum RfpAccidentBenefitTypeEnum {
    dollarAmount = "dollarAmount",
    includedInLumpSumBenefitPayout = "includedInLumpSumBenefitPayout",
    includedWithHospitalAdmission = "includedWithHospitalAdmission",
    notIncluded = "notIncluded"
}
export enum RfpAccidentMaxBenefitTypeEnum {
    upToDollarAmount = "upToDollarAmount",
    notIncluded = "notIncluded"
}
export enum RfpAccidentBenefitObjectType {
    accident = "accident"
}
export enum RfpHospitalIndemnityBenefitObjectType {
    hospitalIndemnity = "hospitalIndemnity"
}
export enum CancerObjectTypeEnum {
    cancer = "cancer"
}
export enum CancerInitialDiagnosisWaitingPeriodTypeEnum {
    days = "days",
    months = "months"
}
export enum RfpCancerHospiceBenefitTypeEnum {
    dollarAmount = "dollarAmount",
    dollarAmountPerDayPerLifetime = "dollarAmountPerDayPerLifetime",
    notIncluded = "notIncluded"
}
export enum RfpCancerScheduleBenefitTypeEnum {
    scheduleUpToDollarAmount = "scheduleUpToDollarAmount",
    notIncluded = "notIncluded"
}
export enum FmlObjectTypeEnum {
    fml = "fml"
}
export enum RfpFmlBenefitTypeEnum {
    additionalDollarAmount = "additionalDollarAmount",
    includedInBasePrice = "includedInBasePrice",
    notIncluded = "notIncluded"
}
export enum EapObjectTypeEnum {
    eap = "eap"
}
export enum RfpTiedToAnotherLocEnum {
    shortTermDisability = "shortTermDisability",
    longTermDisability = "longTermDisability",
    basicLifeAdnd = "basicLifeAdnd",
    voluntaryLifeAdnd = "voluntaryLifeAdnd",
    notIncluded = "notIncluded",
    notTied = "notTied"
}
export enum IndividualDisabilityObjectTypeEnum {
    individualDisability = "individualDisability"
}
export enum RfpLtdPlanDesignTypeEnum {
    increments = "increments",
    percentageToDollarAmount = "percentageToDollarAmount",
    notIncluded = "notIncluded"
}
export enum RfpIdiPlanDesignTypeEnum {
    percentage = "percentage",
    percentageToDollarAmount = "percentageToDollarAmount",
    notIncluded = "notIncluded"
}
export enum RfpRecoveryBenefitEnum {
    dollarAmount = "dollarAmount",
    included = "included",
    notIncluded = "notIncluded"
}
export enum RfpCatastrophicBenefitEnum {
    percentageAmount = "percentageAmount",
    included = "included",
    notIncluded = "notIncluded"
}
export enum WholeLifeObjectTypeEnum {
    wholeLife = "wholeLife"
}
export enum WholeLifeCoverageTypeEnum {
    faceValue = "faceValue",
    cashValue = "cashValue",
    moneyPurchase = "moneyPurchase"
}
export enum WholeLifeEmployeeBenefitMaximumTypeEnum {
    dollarAmount = "dollarAmount",
    salaryMultiplier = "salaryMultiplier",
    lesserOfDollarAmountOrSalaryMultiplier = "lesserOfDollarAmountOrSalaryMultiplier",
    notIncluded = "notIncluded"
}
export enum RfpWholeLifeCoverageEffectiveDateEnum {
    firstOfTheMonthFollowingEffectiveDate = "firstOfTheMonthFollowingEffectiveDate",
    firstOfTheMonthFollowingSignedApplication = "firstOfTheMonthFollowingSignedApplication",
    firstDayOfTheMonthInWhichPayrollDeductionsBegin = "firstDayOfTheMonthInWhichPayrollDeductionsBegin",
    coverageIsEffectiveOnThePolicyDate = "coverageIsEffectiveOnThePolicyDate",
    dateOfSignedApplication = "dateOfSignedApplication",
    notIncluded = "notIncluded"
}
export enum PutRfpCoverageStatusEnum {
    quoteNeeded = "quoteNeeded",
    quoteNotNeeded = "quoteNotNeeded"
}
export enum ProposalCoverageStatusEnum {
    quoted = "quoted",
    declinedToQuote = "declinedToQuote"
}
export enum DeclineReasonEnum {
    coverageNotSupported = "coverageNotSupported",
    uncompetitiveRates = "uncompetitiveRates",
    participationTooLow = "participationTooLow",
    unableToMatchPlanDesign = "unableToMatchPlanDesign",
    sicCodeRestriction = "sicCodeRestriction",
    occupationRestriction = "occupationRestriction",
    geographicRestriction = "geographicRestriction",
    experienceBased = "experienceBased",
    other = "other"
}
export enum RateGuaranteeTypeEnum {
    months = "months",
    years = "years",
    notIncluded = "notIncluded",
    notOffered = "notOffered"
}
export enum QuoteInclusionStatusEnum {
    included = "included",
    notIncluded = "notIncluded",
    notOffered = "notOffered"
}
export enum QuoteAnnualOpenEnrollmentEnum {
    oneTimeOpenEnrollment = "oneTimeOpenEnrollment",
    annualOpenEnrollment = "annualOpenEnrollment",
    modifiedOpenEnrollment = "modifiedOpenEnrollment",
    included = "included",
    notIncluded = "notIncluded",
    notOffered = "notOffered"
}
export enum QuoteDollarBenefitTypeEnum {
    dollarAmount = "dollarAmount",
    dollarAmountPerPerson = "dollarAmountPerPerson",
    notIncluded = "notIncluded",
    notOffered = "notOffered"
}
export enum QuotePercentageBenefitTypeEnum {
    percentageAmount = "percentageAmount",
    notIncluded = "notIncluded",
    notOffered = "notOffered"
}
export enum QuoteDentalServiceCategoryEnum {
    preventive = "preventive",
    basic = "basic",
    major = "major",
    notIncluded = "notIncluded",
    notOffered = "notOffered"
}
export enum QuoteOrthoAgeLimitTypeEnum {
    childrenOnlyToAge = "childrenOnlyToAge",
    adultAndChildren = "adultAndChildren",
    childrenOnlyAgeNotDisclosed = "childrenOnlyAgeNotDisclosed",
    notApplicable = "notApplicable",
    notIncluded = "notIncluded",
    notOffered = "notOffered"
}
export enum QuoteDeductibleDurationEnum {
    calendarYear = "calendarYear",
    lifetime = "lifetime",
    notIncluded = "notIncluded",
    notOffered = "notOffered"
}
export enum QuoteOutOfNetworkReimbursementEnum {
    Value45thUcr = "45thUcr",
    Value50thUcr = "50thUcr",
    Value51stUcr = "51stUcr",
    Value70thUcr = "70thUcr",
    Value75thUcr = "75thUcr",
    Value80thUcr = "80thUcr",
    Value85thUcr = "85thUcr",
    Value90thUcr = "90thUcr",
    Value95thUcr = "95thUcr",
    Value99thUcr = "99thUcr",
    mac = "mac",
    mpa = "mpa",
    feeSchedule = "feeSchedule",
    notIncluded = "notIncluded",
    notOffered = "notOffered"
}
export enum QuoteVisionCopayRuleTypeEnum {
    dollarAmount = "dollarAmount",
    notIncluded = "notIncluded",
    notOffered = "notOffered"
}
export enum QuoteVisionCopayFullAllowanceRuleTypeEnum {
    coveredInFullAfterCopay = "coveredInFullAfterCopay",
    coveredInFull = "coveredInFull",
    dollarAmountAllowance = "dollarAmountAllowance",
    dollarAmountAllowanceWithCopay = "dollarAmountAllowanceWithCopay",
    notIncluded = "notIncluded",
    notOffered = "notOffered"
}
export enum QuoteVisionCopayAllowanceRuleTypeEnum {
    coveredInFullAfterCopay = "coveredInFullAfterCopay",
    dollarAmountAllowance = "dollarAmountAllowance",
    dollarAmountAllowanceWithoutCopay = "dollarAmountAllowanceWithoutCopay",
    dollarAmountAllowanceWithCopay = "dollarAmountAllowanceWithCopay",
    notIncluded = "notIncluded",
    notOffered = "notOffered"
}
export enum QuoteVisionSpecialCopayAllowanceRuleTypeEnum {
    dollarAmountAllowance = "dollarAmountAllowance",
    dollarAmountAllowanceWithoutCopay = "dollarAmountAllowanceWithoutCopay",
    dollarAmountAllowanceWithCopay = "dollarAmountAllowanceWithCopay",
    notIncluded = "notIncluded",
    notOffered = "notOffered"
}
export enum QuoteFramesDiscountsRuleTypeEnum {
    upToPercentageOff = "upToPercentageOff",
    upToDollarAmountOff = "upToDollarAmountOff",
    notIncluded = "notIncluded",
    notOffered = "notOffered"
}
export enum QuoteVisionBenefitFrequencyOptionEnum {
    twelve = "twelve",
    twentyFour = "twentyFour",
    calendarYear = "calendarYear",
    everyOtherCalendarYear = "everyOtherCalendarYear",
    notIncluded = "notIncluded",
    notOffered = "notOffered"
}
export enum QuoteAgeReductionScheduleTypeEnum {
    percentageAtAge = "percentageAtAge",
    notIncluded = "notIncluded",
    notOffered = "notOffered"
}
export enum QuoteVoluntaryLifeGuaranteeIssueTypeEnum {
    dollarAmount = "dollarAmount",
    ageBasedAmounts = "ageBasedAmounts",
    salaryMultiplierWithCap = "salaryMultiplierWithCap",
    salaryMultiplierWithDollarAmountPlusAdditionalAmount = "salaryMultiplierWithDollarAmountPlusAdditionalAmount",
    allGuaranteeIssue = "allGuaranteeIssue",
    notOffered = "notOffered",
    notIncluded = "notIncluded"
}
export enum QuoteVoluntaryLifeAmountNotToExceedTypeEnum {
    percentageOfEmployeeElection = "percentageOfEmployeeElection",
    notApplicable = "notApplicable",
    notOffered = "notOffered",
    notIncluded = "notIncluded"
}
export enum QuoteVoluntaryLifeAdndTiedToLifeTypeEnum {
    tied = "tied",
    untied = "untied",
    clientLevelDecision = "clientLevelDecision",
    notOffered = "notOffered"
}
export enum QuotePortabilityTypeEnum {
    included = "included",
    notIncluded = "notIncluded",
    includedWithEOI = "includedWithEOI",
    includedWithoutEOI = "includedWithoutEOI",
    notOffered = "notOffered"
}
export enum QuoteEliminationPeriodTypeEnum {
    days = "days",
    notOffered = "notOffered",
    notIncluded = "notIncluded"
}
export enum QuoteStdBenefitDurationTypeEnum {
    days = "days",
    weeks = "weeks",
    notIncluded = "notIncluded",
    notOffered = "notOffered"
}
export enum QuotePreExistingConditionTypeEnum {
    months = "months",
    waived = "waived",
    notOffered = "notOffered",
    none = "none"
}
export enum QuoteLtdOwnOccupationPeriodTypeEnum {
    yearsOwnOccupation = "yearsOwnOccupation",
    monthsOwnOccupation = "monthsOwnOccupation",
    ownOccupationOnly = "ownOccupationOnly",
    notIncluded = "notIncluded",
    notOffered = "notOffered"
}
export enum QuoteGainfulEarningsRuleTypeEnum {
    percentage = "percentage",
    notApplicable = "notApplicable",
    notIncluded = "notIncluded",
    notOffered = "notOffered"
}
export enum QuoteLtdOtherLimitationsEnum {
    years = "years",
    months = "months",
    noLimit = "noLimit",
    payableSameAsAnyOtherDisability = "payableSameAsAnyOtherDisability",
    included = "included",
    notIncluded = "notIncluded",
    notOffered = "notOffered"
}
export enum QuoteRehabTypeEnum {
    mandatory = "mandatory",
    mandatoryWithEnhanced = "mandatoryWithEnhanced",
    voluntary = "voluntary",
    voluntaryWithEnhanced = "voluntaryWithEnhanced",
    enhanced = "enhanced",
    notIncluded = "notIncluded",
    notOffered = "notOffered"
}
export enum QuoteCriticalIllnessEmployeeGuaranteeIssueTypeEnum {
    percentageOfEeBenefit = "percentageOfEeBenefit",
    flatAmount = "flatAmount",
    notIncluded = "notIncluded",
    notOffered = "notOffered"
}
export enum QuoteCriticalIllnessSpouseBenefitDescriptionTypeEnum {
    increments = "increments",
    percentage = "percentage",
    dollarAmount = "dollarAmount",
    multipleOptions = "multipleOptions",
    notIncluded = "notIncluded",
    notOffered = "notOffered"
}
export enum QuoteCriticalIllnessSpouseMaximumTypeEnum {
    dollarAmount = "dollarAmount",
    percentageOfEeBenefit = "percentageOfEeBenefit",
    percentageOfEeBenefitAndDollarAmount = "percentageOfEeBenefitAndDollarAmount",
    notIncluded = "notIncluded",
    notOffered = "notOffered"
}
export enum QuoteIllnessTypeEnum {
    percentage = "percentage",
    notIncluded = "notIncluded",
    notOffered = "notOffered"
}
export enum QuoteMaximumPayoutTypeEnum {
    dollarAmount = "dollarAmount",
    percentage = "percentage",
    noLimit = "noLimit",
    unlimited = "unlimited",
    willNotPayForThirdOrLaterOccurrence = "willNotPayForThirdOrLaterOccurrence",
    notIncluded = "notIncluded",
    notOffered = "notOffered"
}
export enum QuoteOccurrenceTypeEnum {
    months = "months",
    included = "included",
    notIncluded = "notIncluded",
    notOffered = "notOffered"
}
export enum QuoteAgeBasisEnum {
    issueAge = "issueAge",
    attainedAge = "attainedAge",
    notOffered = "notOffered",
    notIncluded = "notIncluded"
}
export enum QuoteAccidentSpecificBenefitTypeEnum {
    dollarAmount = "dollarAmount",
    includedInLumpSumBenefitPayout = "includedInLumpSumBenefitPayout",
    notIncluded = "notIncluded",
    notOffered = "notOffered"
}
export enum QuoteAccidentBenefitTypeEnum {
    dollarAmount = "dollarAmount",
    includedInLumpSumBenefitPayout = "includedInLumpSumBenefitPayout",
    includedWithHospitalAdmission = "includedWithHospitalAdmission",
    notIncluded = "notIncluded",
    notOffered = "notOffered"
}
export enum QuoteAccidentMaxBenefitTypeEnum {
    upToDollarAmount = "upToDollarAmount",
    notOffered = "notOffered",
    notIncluded = "notIncluded"
}
export enum QuoteCancerHospiceBenefitTypeEnum {
    dollarAmount = "dollarAmount",
    dollarAmountPerDayPerLifetime = "dollarAmountPerDayPerLifetime",
    notIncluded = "notIncluded",
    notOffered = "notOffered"
}
export enum QuoteCancerScheduleBenefitTypeEnum {
    scheduleUpToDollarAmount = "scheduleUpToDollarAmount",
    notOffered = "notOffered",
    notIncluded = "notIncluded"
}
export enum QuoteFmlBenefitTypeEnum {
    additionalDollarAmount = "additionalDollarAmount",
    includedInBasePrice = "includedInBasePrice",
    notIncluded = "notIncluded",
    notOffered = "notOffered"
}
export enum QuoteFmlBenefitObjectType {
    fmla = "fmla"
}
export enum QuoteTiedToAnotherLocEnum {
    shortTermDisability = "shortTermDisability",
    longTermDisability = "longTermDisability",
    basicLifeAdnd = "basicLifeAdnd",
    voluntaryLifeAdnd = "voluntaryLifeAdnd",
    notIncluded = "notIncluded",
    notTied = "notTied",
    notOffered = "notOffered"
}
export enum QuoteRecoveryBenefitEnum {
    dollarAmount = "dollarAmount",
    included = "included",
    notIncluded = "notIncluded",
    notOffered = "notOffered"
}
export enum QuoteCatastrophicBenefitEnum {
    percentageAmount = "percentageAmount",
    included = "included",
    notIncluded = "notIncluded",
    notOffered = "notOffered"
}
export enum QuoteIndividualDisabilityBenefitObjectType {
    individualDisabilityInsurance = "individualDisabilityInsurance"
}
export enum QuoteWholeLifeCoverageEffectiveDateEnum {
    firstOfTheMonthFollowingEffectiveDate = "firstOfTheMonthFollowingEffectiveDate",
    firstOfTheMonthFollowingSignedApplication = "firstOfTheMonthFollowingSignedApplication",
    firstDayOfTheMonthInWhichPayrollDeductionsBegin = "firstDayOfTheMonthInWhichPayrollDeductionsBegin",
    coverageIsEffectiveOnThePolicyDate = "coverageIsEffectiveOnThePolicyDate",
    dateOfSignedApplication = "dateOfSignedApplication",
    notOffered = "notOffered",
    notIncluded = "notIncluded"
}
export enum RfpqEventTypeEnum {
    quoteReady = "quoteReady",
    declinedToQuote = "declinedToQuote"
}
export enum ApiPaths {
    createRfp = "/rfp",
    replaceRfp = "/rfp/{carrierIssuedIdentifier}",
    getProposal = "/rfp/{carrierIssuedIdentifier}/proposal/{proposalIdentifier}",
    rfpqEventSubmit = "/event/rfpq/carrier/{carrierIdentifier}",
    uploadFile = "/files",
    downloadFile = "/files/{fileIdentifier}"
}
